// Add new keys here as more pages get translated. Every key must exist in
// both languages — t() falls back to Thai (then the raw key) if a language
// is missing an entry, so an incomplete `en` block degrades instead of
// crashing, but keep both in sync.
export const translations = {
  th: {
    navbar_welcome: "MESOK LOTERRY - ยินดีต้อนรับ",
    navbar_home: "หน้าแรก",
    navbar_logout: "ออกจากระบบ",
    navbar_notice: "ประกาศ",
    navbar_notice_text:
      "ประกาศจากระบบ : ขณะนี้อยู่ในช่วงกำลังพัฒนาระบบ ประกาศ 12/11/2024",
    logout_confirm_title: "คุณต้องการออกจากระบบ ?",
    logout_confirm_yes: "ใช่ , ออกจากระบบ",
    logout_confirm_no: "ไม่",

    sidebar_close_menu: "ปิดเมนู",
    sidebar_open_menu: "เปิดเมนู",
    menu_category_1: "1 เมนู",
    menu_category_2: "2 ตั้งค่าจำกัด",
    menu_category_3: "3 รายงาน",
    menu_category_4: "4 ยอดเดิมพัน",
    menu_category_5: "5 บันทึกระบบ",
    menu_dashboard: "Dashboard",
    menu_manage_members: "จัดการสมาชิก",
    menu_manage_subaccount: "จัดการบัญชีผู้ใช่ร่วม",
    menu_agent_system: "ระบบจัดการ Agent",
    menu_manage_senior: "จัดการ Senior",
    menu_manage_master: "จัดการ Master",
    menu_manage_agent: "จัดการ Agent",
    menu_manage_commission: "จัดการคอมมิชชั่น",
    menu_manage_topup: "จัดการสมาชิกเติมเงิน",
    menu_manage_withdraw: "จัดการสมาชิกถอนเงิน",
    menu_lotto_onoff: "เปิดปิดหวย",
    menu_limit_number: "เลขอั้น",
    menu_max_fight: "ตั้งค่ารับสู้สูงสุด",
    menu_commission_reward_setting: "ตั้งค่าคอมมิชชั่น & รางวัล",
    menu_lotto_type_setting: "ตั้งค่าประเภทหวย",
    menu_schedule_setting: "ตั้งค่าตารางเวลา",
    menu_winlose: "แพ้ชนะรวม",
    menu_lotto_result: "ผลหวย",
    menu_membertopup_report: "รายงานเติมเครดิตลูกค้า",
    menu_agenttopup_report: "รายงานเติมเครดิตเอเย่นต์",
    menu_bet_amount: "ยอดเดิมพัน",
    menu_outstanding_user: "ยอดคงค้างผู้ใช้",
    menu_outstanding_type: "ยอดคงค้างตามประเภท",
    menu_login_history: "ประวัติการเข้าระบบ",
    menu_activity_logs: "Activity Logs",
    menu_settings: "ตั้งค่า",
    settings_tab_currency: "สกุลเงิน",
    settings_currency_col_code: "รหัส",
    settings_currency_col_name: "ชื่อ",
    settings_currency_col_symbol: "สัญลักษณ์",
    settings_currency_col_status: "สถานะ",

    login_title: "เข้าสู่ระบบ",
    login_subtitle: "กรุณากรอกข้อมูลเพื่อเข้าใช้งานระบบจัดการ",
    login_username_label: "ชื่อผู้ใช้",
    login_password_label: "รหัสผ่าน",
    login_hide_password: "ซ่อนรหัสผ่าน",
    login_show_password: "แสดงรหัสผ่าน",
    login_signing_in: "กำลังเข้าสู่ระบบ...",
    login_suspended_title: "บัญชีถูกระงับ",
    login_suspended_text: "กรุณาติดต่อเจ้าของบัญชีหลัก",
    login_error_title: "เข้าสู่ระบบผิดพลาด",
    login_error_text: "Username หรือรหัสผ่านไม่ถูกต้อง",
    common_ok: "ตกลง",
    common_cancel: "ยกเลิก",
    common_confirm: "ยืนยัน",
    common_yes: "ใช่",
    common_no: "ไม่",
    common_error: "ข้อผิดพลาด!",
    common_oops: "อุ๊ปส์...",
    common_success_title: "สำเร็จ!",
    common_generic_error: "เกิดข้อผิดพลาด!",
    common_no_permission: "ไม่มีสิทธิ์เข้าถึง",
    common_load_error: "เกิดข้อผิดพลาดในการโหลดข้อมูล",
    common_add: "เพิ่ม",
    common_optional: "ไม่บังคับ",
    common_next: "ถัดไป",
    common_previous: "ย้อนกลับ",
    common_saving: "กำลังบันทึก...",
    common_are_you_sure: "แน่ใจหรือไม่?",
    common_page_previous: "ก่อนหน้า",
    common_items_unit: "รายการ",
    common_edit: "แก้ไข",
    common_all: "ทั้งหมด",
    common_no_data: "ไม่มีข้อมูล",
    common_member: "สมาชิก",
    common_create: "สร้าง",
    common_details: "รายละเอียด",
    common_loading: "กำลังโหลด...",
    common_to: "ถึง",
    common_delete: "ลบ",
    common_update: "อัปเดต",
    common_close: "ปิด",
    common_per_page: "แสดงต่อหน้า",

    weekday_sun: "อาทิตย์",
    weekday_mon: "จันทร์",
    weekday_tue: "อังคาร",
    weekday_wed: "พุธ",
    weekday_thu: "พฤหัสบดี",
    weekday_fri: "ศุกร์",
    weekday_sat: "เสาร์",

    dashboard_title: "บัญชี",
    dashboard_login_id: "ชื่อผู้ใช้เข้าสู่ระบบ",
    dashboard_credit: "เครดิตที่มีอยู่",
    dashboard_member_count: "จำนวนลูกค้า",
    dashboard_downline_count: "จำนวนดาวน์ไลน์",
    dashboard_bet_amount: "ยอดแทง",
    dashboard_loss_amount: "ยอดเสีย",
    dashboard_profit: "กำไร",

    topup_credit_modal_title: "เติมเครดิต",
    topup_credit_modal_user_not_found: "ไม่พบข้อมูลผู้ใช้",
    topup_credit_modal_error: "เกิดข้อผิดพลาดในการเติมเครดิต",
    topup_credit_modal_success: "เติมเครดิตสำเร็จ",
    topup_credit_modal_history_title: "ประวัติการเติมเครดิต",
    topup_credit_modal_col_by: "โดย",

    member_page_title: "สมาชิก",
    member_add_button: "เพิ่มสมาชิก",
    member_add_dialog_title: "เพิ่มสมาชิกใหม่",
    member_field_required: "จำเป็น",
    member_first_name: "ชื่อ",
    member_last_name: "นามสกุล",
    member_mobile_number: "เบอร์มือถือ",
    member_bank: "ธนาคาร",
    member_bank_account_number: "เลขบัญชีธนาคาร",
    member_fill_all_fields: "กรุณากรอกข้อมูลให้ครบถ้วน!",
    member_add_success: "เพิ่มสมาชิกใหม่เรียบร้อยแล้ว!",
    member_register_error: "เกิดข้อผิดพลาดในการลงทะเบียนผู้ใช้",
    member_package_label: "แพ็กเกจ",
    member_package_placeholder: "เลือกแพ็กเกจ",
    member_package_required: "กรุณาเลือกแพ็กเกจ",

    member_commission_no_groups: "ไม่มีกลุ่มรางวัลสำหรับหวยนี้",
    member_commission_sync_group: "ใช้ค่าเดียวกันทั้งกลุ่ม",
    member_commission_label: "คอมมิชชั่น (%)",
    member_commission_validate_title: "ตรวจสอบข้อมูลให้ถูกต้อง",
    member_commission_exceed_prefix: "คอมมิชชั่นไม่ควรเกิน",
    commission_step_reward_label: "รางวัล",
    commission_step_reward_exceed_prefix: "รางวัลไม่ควรเกิน",
    commission_step_no_items: "กลุ่มนี้ยังไม่มีรายการ",
    commission_step_reward_placeholder: "ใส่รางวัล",
    commission_step_commission_placeholder: "ใส่คอมมิชชั่น",
    commission_step_minbet_label: "แทงขั้นต่ำ",
    commission_step_maxbet_label: "แทงสูงสุด",
    commission_step_maxbetpermatch_label: "สูงสุด/แมทช์",
    commission_step_maxfight_label: "สู้สูงสุด (%)",
    commission_step_maxfight_exceed_prefix: "เปอร์เซ็นสู้ไม่ควรเกิน",
    member_commission_filter_label: "กรองตามหวย:",
    commission_filter_by_package: "แพ็คเกจ:",
    member_commission_group_thai: "ค่าคอมมิชชั่น หวยไทย",
    member_commission_group_hanoi: "ค่าคอมมิชชั่น หวยฮานอย",
    member_commission_group_laos: "ค่าคอมมิชชั่น หวยลาว",
    member_commission_group_yeekee: "ค่าคอมมิชชั่น จับยี่กี",
    member_commission_group_yeekeevip: "ค่าคอมมิชชั่น จับยี่กี VIP",
    member_commission_group_yeekeevvip: "ค่าคอมมิชชั่น จับยี่กี VVIP",

    table_lotto_thai: "หวยไทย",
    table_lotto_laos: "หวยลาว",
    table_lotto_yeekee5: "ยี่กี่ 5 นาที",
    table_lotto_yeekee10: "ยี่กี่ 10 นาที",
    table_lotto_yeekee15: "ยี่กี่ 15 นาที",
    table_status_paid: "จ่ายแล้ว",
    table_status_unpaid: "ยังไม่จ่าย",
    table_bet_first: "รางวัลที่หนึ่ง",
    table_bet_two_bot: "สองตัวล่าง",
    table_bet_run_top: "วิ่งบน",
    table_bet_two_top: "สองตัวบน",
    table_bet_three_front: "สามตัวหน้า",
    table_bet_run_bot: "วิ่งล่าง",
    table_bet_three_tod: "สามตัวโต๊ด",
    table_bet_three_top: "สามตัวบน",
    table_filter_by_lotto_type: "ตามประเภทหวย",
    table_filter_by_bet_type: "ประเภทเลข",
    table_search_button: "เรียกดู",
    common_export_excel: "ส่งออก Excel",
    common_exporting: "กำลังส่งออก...",
    table_from_date: "จากวันที่",
    table_to_date: "ถึงวันที่",
    table_search_username: "ค้นหาจากชื่อผู้ใช้",
    table_filter_by_payment_status: "ตามสถานะการจ่าย",
    table_search_phone: "ค้นหาจากเบอร์โทรศัพท์",
    table_search_account_number: "ค้นหาจากเลขบัญชี",
    table_search_agent_name: "ค้นหาชื่อ Agent",
    table_search_upline_name: "ค้นหาชื่อ Upline",
    table_total: "รวม",

    orderhistory_page_title: "ประวัติการสั่งซื้อ",
    orderhistory_search_number_placeholder: "ค้นหาเลข",
    orderhistory_col_draw_id: "รหัสงวด",
    orderhistory_col_ticket_no: "เลขที่ตั๋ว",
    orderhistory_col_transaction_time: "เวลาทำรายการ",
    orderhistory_col_turnover: "ยอดหมุนเวียน",
    orderhistory_col_net_amt: "ยอดสุทธิ",
    outstanding_detail_page_title: "รายละเอียดยอดค้าง",
    outstanding_detail_col_comm: "คอมมิชชั่น",
    common_first: "หน้าแรก",
    common_last: "หน้าสุดท้าย",

    membertable_delete_confirm_title: "ต้องการลบสมาชิก?",
    membertable_delete_confirm_text_prefix: "กดยืนยันเพื่อลบสมาชิก",
    membertable_delete_confirm_text_suffix: "แบบถาวร",
    membertable_delete_success: "ลบผู้ใช้สำเร็จ!",
    membertable_delete_error: "เกิดข้อผิดพลาดในการลบผู้ใช้",
    membertable_update_confirm_title: "ต้องการแก้ไขรายละเอียดสมาชิก?",
    membertable_update_confirm_text_prefix: "กดยืนยันเพื่อบันทึกข้อมูลสมาชิก",
    membertable_update_success: "อัปเดตข้อมูลผู้ใช้สำเร็จ!",
    membertable_update_error: "เกิดข้อผิดพลาดในการอัปเดตผู้ใช้",
    membertable_credit_invalid: "กรุณากรอกจำนวนเครดิตที่ถูกต้อง",
    membertable_add_credit_confirm_title: "เพิ่มเครดิต?",
    membertable_add_credit_confirm_text_prefix: "กดยืนยันเพื่อเพิ่มเครดิตจำนวน",
    membertable_add_credit_confirm_text_middle: "ให้กับสมาชิก",
    membertable_add_credit_insufficient: "เครดิตไม่เพียงพอ!",
    membertable_add_credit_success_prefix: "เพิ่มเครดิตจำนวน",
    membertable_add_credit_success_middle: "ให้กับสมาชิก",
    membertable_add_credit_success_suffix: "สำเร็จ",
    membertable_add_credit_error: "เกิดข้อผิดพลาดในการเพิ่มเครดิต",
    membertable_change_password_title: "เปลี่ยนรหัสให้กับสมาชิก?",
    membertable_change_password_text: "กดยืนยันเพื่อแก้ไขรหัสให้กับสมาชิก",
    membertable_change_password_error: "เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน",
    membertable_change_password_success: "เปลี่ยนรหัสผ่านสำเร็จ",
    membertable_col_no: "ลำดับ",
    membertable_col_name: "ชื่อ นามสกุล",
    membertable_col_phone: "เบอร์โทร",
    membertable_col_credit: "เครดิต",
    membertable_col_manage: "จัดการ",
    membertopupreport_col_date: "วันที่",
    membertopupreport_col_member: "ลูกค้า",
    membertopupreport_col_approveby: "อนุมัติโดย",
    agenttopupreport_col_sender: "ผู้เติมเครดิต",
    membertable_tx_col_sender: "ส่ง",
    membertable_tx_col_receiver: "รับ",
    membertable_tx_col_amount: "จำนวน",
    membertable_tx_col_date: "วันที่",
    membertable_tx_col_ip: "IP",
    membertable_tx_col_device: "อุปกรณ์",
    membertable_edit_title_prefix: "แก้ไขข้อมูล",
    membertable_commission_note:
      "หมายเหตุ: หากแก้ไขค่าคอมมิชชั่นของประเภทหวยใด กรุณากรอกให้ครบทุกช่องของประเภทนั้น (ช่องที่เว้นว่างไว้ในประเภทที่แก้ไขจะถูกบันทึกเป็น 0)",
    membertable_save: "บันทึก",
    membertable_change_password_dialog_title_prefix:
      "แก้ไขรหัสผ่าน สำหรับ Username :",
    membertable_new_password_prompt: "กรอกรหัสผ่านใหม่",
    membertable_credit_history_title: "ประวัติเครดิต",
    membertable_add_credit_title_prefix: "เพิ่มเครดิต :",
    membertable_credit_amount_label: "จำนวนเครดิต",
    membertable_credit_amount_placeholder: "กรอกจำนวนเครดิต",

    subaccount_page_title: "บัญชีผู้ใช้ร่วม",
    subaccount_add_button: "เพิ่มบัญชีผู้ใช้ร่วม",
    subaccount_permissions_fetch_error: "เกิดข้อผิดพลาดในการโหลดสิทธิการใช้งาน",
    subaccount_add_success: "เพิ่มบัญชีผู้ใช้ร่วมใหม่เรียบร้อยแล้ว!",
    subaccount_duplicate_username: "มีชื่อผู้ใช้นี้ในระบบแล้ว",
    subaccount_status_label: "สถานะ",
    subaccount_status_active: "ทำงาน",
    subaccount_status_inactive: "หยุดทำงาน",
    subaccount_permissions_label: "รายการสิทธิ์",
    subaccount_select_all: "เลือกทั้งหมด",
    subaccount_update_confirm_title: "ต้องการแก้ไขรายละเอียด?",
    subaccount_update_confirm_text: "กดยืนยันเพื่อบันทึกข้อมูล",
    subaccount_update_success: "แก้ไขข้อมูลบัญชีผู้ใช้ร่วมสำเร็จ!",
    subaccount_update_error: "เกิดข้อผิดพลาดในการแก้ไขข้อมูล",
    subaccount_change_password_title: "เปลี่ยนรหัสผ่านบัญชีผู้ใช้ร่วม?",
    subaccount_change_password_text: "กดยืนยันเพื่อเปลี่ยนรหัสผ่าน",
    subaccount_delete_confirm_title: "ต้องการลบบัญชีผู้ใช้ร่วม?",
    subaccount_delete_confirm_text_prefix: "คุณต้องการลบ",
    subaccount_delete_success: "ลบบัญชีผู้ใช้ร่วมเรียบร้อยแล้ว",
    common_delete_error: "เกิดข้อผิดพลาดบางอย่าง!",
    subaccount_col_last_login_time: "เวลาเปิดล่าสุด",
    subaccount_col_last_login_ip: "IP เปิดล่าสุด",
    subaccount_edit_dialog_title: "แก้ไขบัญชีผู้ใช้งานร่วม",

    agent_credit_amount_required: "กรุณากรอกจำนวนเครดิตที่ต้องการเติม!",
    agent_credit_confirm_title: "คุณแน่ใจหรือไม่?",
    agent_credit_confirm_text_prefix: "คุณต้องการเติมเครดิตจำนวน",
    agent_credit_confirm_text_middle: "ให้กับ",
    agent_credit_insufficient: "เครดิตไม่เพียงพอ!",
    agent_credit_added_success: "เติมเครดิตเรียบร้อยแล้ว!",
    agent_no_downline: "ไม่มีดาวน์ไลน์",
    agent_downline_list_title: "รายชื่อ Downline",
    agent_col_agent_username: "ชื่อผู้ใช้เอเย่นต์",
    agent_col_position: "ตำแหน่ง",
    agent_col_upline: "อัพไลน์",
    agent_col_total_downline: "ดาวน์ไลน์ทั้งหมด",
    agent_col_total_member: "สมาชิกทั้งหมด",
    agent_col_credit: "เครดิต",
    agent_col_credit_history: "ประวัติ",
    agent_col_status: "สถานะ",
    agent_col_lock: "ล็อค",
    agent_lock_confirm_title: "ยืนยันการทำรายการ",
    agent_lock_confirm_text_lock: "คุณต้องการล็อคผู้ใช้นี้ใช่หรือไม่?",
    agent_lock_confirm_text_unlock: "คุณต้องการปลดล็อคผู้ใช้นี้ใช่หรือไม่?",
    agent_lock_success: "บันทึกข้อมูลสำเร็จ",
    agent_lock_error: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
    agent_status_confirm_title: "เปลี่ยนสถานะผู้ใช้",
    agent_status_inactive_warning_title: "คำเตือน",
    agent_status_inactive_warning_text:
      'การตั้งสถานะเป็น "ไม่ใช้งาน" จะล้างค่าคอมมิชชั่นและอัตราจ่ายของผู้ใช้นี้ รวมถึงดาวน์ไลน์ทั้งหมดให้เป็น 0 อย่างถาวร ไม่สามารถย้อนคืนได้ ยืนยันหรือไม่?',
    member_status_inactive_warning_title: "คำเตือน",
    member_status_inactive_warning_text:
      'การตั้งสถานะเป็น "ไม่ใช้งาน" จะล้างค่าคอมมิชชั่นของสมาชิกคนนี้ให้เป็น 0 อย่างถาวร ไม่สามารถย้อนคืนได้ ยืนยันหรือไม่?',
    agent_col_add_remove_credit: "เพิ่ม/ลบเครดิต",
    agent_col_edit_data: "แก้ไขข้อมูล",
    agent_person_unit: "คน",
    agent_add_credit_title: "เพิ่มเครดิต",
    agent_remove_credit_title: "ลบเครดิต",

    permission_category_member: "จัดการสมาชิก",
    permission_category_sub_account: "บัญชีผู้ใช้งานร่วม",
    permission_category_company: "จัดการ Company",
    permission_category_senior_account: "จัดการ Senior",
    permission_category_master_account: "จัดการ Master",
    permission_category_agent: "จัดการเอเย่นต์",
    permission_category_commission: "ค่าคอมมิชชั่น",
    permission_category_payrate: "อัตราจ่าย",
    permission_category_limited_number: "เลขอั้น",
    permission_category_fight_limit: "จำกัดยอดแทง",
    permission_category_win_lose: "รายงานแพ้ชนะ",
    permission_category_result: "รายงานผลรางวัล",
    permission_category_lotto_wait: "รายงานรอผลหวย",
    permission_category_activity_log: "ประวัติการใช้งาน",
    permission_category_login_log: "ประวัติการเข้าสู่ระบบ",
    permission_category_bet: "การแทง",
    permission_category_billcut: "ตัดบิล",
    permission_category_hanoi: "ผลฮานอย",
    permission_category_memberlog: "ประวัติการทำรายการสมาชิก",
    permission_category_order: "ออเดอร์",
    permission_category_permission: "สิทธิ์การใช้งาน",
    permission_category_transaction: "รายการเดินบัญชี",
    permission_category_waitresultuser: "ยอดคงค้างผู้ใช้",
    permission_category_waitresulttype: "ยอดคงค้างตามประเภท",
    permission_category_lottobet: "ยอดเดิมพัน",
    permission_category_lotto_reward_type_group: "จัดการกลุ่มประเภทรางวัล",
    permission_category_lotto_type: "จัดการประเภทหวย",
    permission_category_schedule: "จัดการตารางเวลา",
    permission_category_other: "อื่นๆ",

    permission_label_member_view: "ดูข้อมูลสมาชิก",
    permission_label_member_add: "เพิ่มสมาชิก",
    permission_label_member_edit: "แก้ไขสมาชิก",
    permission_label_member_delete: "ลบสมาชิก",
    permission_label_sub_account_view: "ดูข้อมูลบัญชีย่อย",
    permission_label_sub_account_add: "เพิ่มบัญชีย่อย",
    permission_label_sub_account_edit: "แก้ไขบัญชีย่อย",
    permission_label_sub_account_delete: "ลบบัญชีย่อย",
    permission_label_company_view: "ดูข้อมูลบริษัท",
    permission_label_company_add: "เพิ่มบริษัท",
    permission_label_company_edit: "แก้ไขบริษัท",
    permission_label_company_delete: "ลบบริษัท",
    permission_label_senior_account_view: "ดูข้อมูลบัญชีซีเนียร์",
    permission_label_senior_account_add: "เพิ่มบัญชีซีเนียร์",
    permission_label_senior_account_edit: "แก้ไขบัญชีซีเนียร์",
    permission_label_senior_account_delete: "ลบบัญชีซีเนียร์",
    permission_label_master_account_view: "ดูข้อมูลบัญชีมาสเตอร์",
    permission_label_master_account_add: "เพิ่มบัญชีมาสเตอร์",
    permission_label_master_account_edit: "แก้ไขบัญชีมาสเตอร์",
    permission_label_master_account_delete: "ลบบัญชีมาสเตอร์",
    permission_label_agent_view: "ดูข้อมูลเอเย่นต์",
    permission_label_agent_add: "เพิ่มเอเย่นต์",
    permission_label_agent_edit: "แก้ไขเอเย่นต์",
    permission_label_agent_delete: "ลบเอเย่นต์",
    permission_label_commission_view: "ดูข้อมูลค่าคอมมิชชั่น",
    permission_label_commission_edit: "แก้ไขค่าคอมมิชชั่น",
    permission_label_payrate_view: "ดูข้อมูลอัตราจ่าย",
    permission_label_payrate_edit: "แก้ไขอัตราจ่าย",
    permission_label_payrate_on_off: "เปิด/ปิดอัตราจ่าย",
    permission_label_limited_number_view: "ดูข้อมูลเลขอั้น",
    permission_label_limited_number_add: "เพิ่มเลขอั้น",
    permission_label_limited_number_edit: "แก้ไขเลขอั้น",
    permission_label_limited_number_delete: "ลบเลขอั้น",
    permission_label_fight_limit_view: "ดูข้อมูลจำกัดยอดแทง",
    permission_label_fight_limit_edit: "แก้ไขจำกัดยอดแทง",
    permission_label_win_lose_view: "ดูข้อมูลผลแพ้ชนะ",
    permission_label_result_view: "ดูข้อมูลผลรางวัล",
    permission_label_lotto_wait_view: "ดูข้อมูลรอผลหวย",
    permission_label_activity_log_view: "ดูข้อมูลประวัติการใช้งาน",
    permission_label_login_log_view: "ดูข้อมูลประวัติการเข้าสู่ระบบ",
    permission_label_bet_view: "ดูข้อมูลการแทง",
    permission_label_bet_edit: "แก้ไขข้อมูลการแทง",
    permission_label_billcut_view: "ดูข้อมูลตัดบิล",
    permission_label_billcut_edit: "แก้ไขข้อมูลตัดบิล",
    permission_label_hanoi_edit: "แก้ไขผลฮานอย",
    permission_label_memberlog_view: "ดูประวัติการทำรายการสมาชิก",
    permission_label_memberlog_edit: "แก้ไขประวัติการทำรายการสมาชิก",
    permission_label_order_view: "ดูข้อมูลออเดอร์",
    permission_label_order_edit: "แก้ไขข้อมูลออเดอร์",
    permission_label_permission_view: "ดูข้อมูลสิทธิ์การใช้งาน",
    permission_label_permission_edit: "แก้ไขสิทธิ์การใช้งาน",
    permission_label_transaction_view: "ดูข้อมูลรายการเดินบัญชี",
    permission_label_waitresultuser_view: "ยอดคงค้างผู้ใช้",
    permission_label_waitresulttype_view: "ยอดคงค้างตามประเภท",
    permission_label_lottobet_view: "ยอดเดิมพัน",
    permission_label_lotto_reward_type_group_view: "ดูกลุ่มประเภทรางวัล",
    permission_label_lotto_reward_type_group_add: "เพิ่มกลุ่มประเภทรางวัล",
    permission_label_lotto_reward_type_group_edit: "แก้ไขกลุ่มประเภทรางวัล",
    permission_label_lotto_reward_type_group_delete: "ลบกลุ่มประเภทรางวัล",
    permission_label_lotto_type_view: "ดูประเภทหวย",
    permission_label_lotto_type_add: "เพิ่มประเภทหวย",
    permission_label_lotto_type_edit: "แก้ไขประเภทหวย",
    permission_label_lotto_type_delete: "ลบประเภทหวย",
    permission_label_schedule_view: "ดูตารางเวลา",
    permission_label_schedule_add: "เพิ่มตารางเวลา",
    permission_label_schedule_edit: "แก้ไขตารางเวลา",
    permission_label_schedule_delete: "ลบตารางเวลา",

    agentadd_password_required: "กรุณากรอกรหัสผ่าน!",
    agentadd_package_required: "กรุณาเปิดใช้งานอย่างน้อย 1 แพ็คเกจ!",
    agentadd_position_required: "กรุณาเลือกตำแหน่ง!",
    agentadd_generic_error: "เกิดข้อผิดพลาด กรุณารีเฟรชและลองใหม่อีกครั้ง!",
    agentadd_confirm_title: "ต้องการเพิ่ม Agent",
    agentadd_confirm_text_prefix: "เพิ่ม Agent",
    agentadd_confirm_text_middle: "ระดับ",
    agentadd_success_prefix: "เพิ่มบัญชี",
    agentadd_success_middle: "ระดับ",
    agentadd_success_suffix: "เรียบร้อย",
    agentadd_step_commission_reward: "คอมมิชชั่น & รางวัล",
    agentadd_step_bet_limit: "วงเงินแทง",
    agentadd_step_max_fight_percent: "เปอร์เซ็นสู้สูงสุด",
    agentadd_step_fight_limit: "จำกัดยอดสู้",
    agentadd_header_title: "Agent => เพิ่มเอเย่นต์ใหม่",
    agentadd_name_label: "ชื่อ",
    agentadd_tel_label: "เบอร์โทร",
    agentadd_email_label: "อีเมล",
    agentadd_status_label: "สถานะ",
    agentadd_status_active: "ใช้งาน",
    agentadd_status_inactive: "ไม่ใช้งาน",
    agentadd_status_suspend: "ระงับ",
    agentadd_lock_label: "ล็อค",
    agentadd_currency_label: "สกุลเงิน",
    agentedit_currency_cascade_hint:
      "การเปลี่ยนสกุลเงินจะมีผลกับ downline และสมาชิกทั้งหมดของเอเย่นต์นี้",
    agentadd_save_button: "บันทึกข้อมูล",

    agentedit_confirm_text: "คุณจะบันทึกข้อมูลนี้ใช่หรือไม่?",
    agentedit_save_success: "บันทึกข้อมูลสำเร็จ",
    agentedit_save_error: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
    agentedit_header_title: "Agent => แก้ไขเอเย่นต์",
    agentedit_downline_header: "แก้ไขดาวน์ไลน์",
    agentedit_downline_header_of: "ซึ่งเป็นดาวน์ไลน์ของ",

    commission_nav_commission: "ค่าคอมมิชชั่น",
    commission_nav_reward: "รางวัล",
    commission_nav_max_bet: "แทงสูงสุด",
    commission_nav_min_bet: "แทงต่ำสุด",
    commission_nav_max_bet_per_match: "แทงสูงสุดต่อเลข",
    commission_filter_by_lotto_type: "กรองตามประเภทหวย:",
    commission_filter_by_downline_level: "ระดับดาวน์ไลน์:",
    commission_page_label: "หน้า",
    commission_total_prefix: "ทั้งหมด",
    commission_edit_dialog_title: "ปรับค่าคอมมิชชั่น",
    commission_max_label: "สูงสุด",
    commission_no_data_yet: "ยังไม่มีข้อมูล",

    stake_label_first: "รางวัลที่ 1",
    stake_label_four_top: "4 ตัวบน",
    stake_label_four_tod: "4 ตัวโดด",
    stake_label_three_top: "3 ตัวบน",
    stake_label_three_front: "3 ตัวหน้า",
    stake_label_three_bot: "3 ตัวหลัง",
    stake_label_three_tod: "3 ตัวโดด",
    stake_label_two_top: "2 ตัวบน",
    stake_label_two_bot: "2 ตัวล่าง",
    stake_label_run_top: "วิ่งบน",
    stake_label_run_bot: "วิ่งล่าง",
    stake_label_run_top_front: "วิ่งหน้า (บน)",
    stake_label_run_top_mid: "วิ่งกลาง (บน)",
    stake_label_run_top_end: "วิ่งท้าย (บน)",
    stake_label_run_bot_front: "วิ่งหน้า (ล่าง)",
    stake_label_run_bot_mid: "วิ่งกลาง (ล่าง)",
    stake_label_run_bot_end: "วิ่งท้าย (ล่าง)",
    stake_label_run_top_big: "วิ่งสูง (บน)",
    stake_label_run_top_small: "วิ่งต่ำ (บน)",
    stake_label_run_top_even: "วิ่งคู่ (บน)",
    stake_label_run_top_odd: "วิ่งคี่ (บน)",
    stake_label_run_bot_big: "วิ่งสูง (ล่าง)",
    stake_label_run_bot_small: "วิ่งต่ำ (ล่าง)",
    stake_label_run_bot_even: "วิ่งคู่ (ล่าง)",
    stake_label_run_bot_odd: "วิ่งคี่ (ล่าง)",
    stake_label_run_top_front_even: "วิ่งหน้าคู่ (บน)",
    stake_label_run_top_front_odd: "วิ่งหน้าคี่ (บน)",
    stake_label_run_top_front_small: "วิ่งหน้าต่ำ (บน)",
    stake_label_run_top_front_big: "วิ่งหน้าสูง (บน)",
    stake_label_run_top_mid_even: "วิ่งกลางคู่ (บน)",
    stake_label_run_top_mid_odd: "วิ่งกลางคี่ (บน)",
    stake_label_run_top_mid_small: "วิ่งกลางต่ำ (บน)",
    stake_label_run_top_mid_big: "วิ่งกลางสูง (บน)",
    stake_label_run_top_end_even: "วิ่งท้ายคู่ (บน)",
    stake_label_run_top_end_odd: "วิ่งท้ายคี่ (บน)",
    stake_label_run_top_end_small: "วิ่งท้ายต่ำ (บน)",
    stake_label_run_top_end_big: "วิ่งท้ายสูง (บน)",
    stake_label_run_bot_front_even: "วิ่งหน้าคู่ (ล่าง)",
    stake_label_run_bot_front_odd: "วิ่งหน้าคี่ (ล่าง)",
    stake_label_run_bot_front_small: "วิ่งหน้าต่ำ (ล่าง)",
    stake_label_run_bot_front_big: "วิ่งหน้าสูง (ล่าง)",
    stake_label_run_bot_mid_even: "วิ่งกลางคู่ (ล่าง)",
    stake_label_run_bot_mid_odd: "วิ่งกลางคี่ (ล่าง)",
    stake_label_run_bot_mid_small: "วิ่งกลางต่ำ (ล่าง)",
    stake_label_run_bot_mid_big: "วิ่งกลางสูง (ล่าง)",
    stake_label_run_bot_end_even: "วิ่งท้ายคู่ (ล่าง)",
    stake_label_run_bot_end_odd: "วิ่งท้ายคี่ (ล่าง)",
    stake_label_run_bot_end_small: "วิ่งท้ายต่ำ (ล่าง)",
    stake_label_run_bot_end_big: "วิ่งท้ายสูง (ล่าง)",
    stake_label_step_front_mid_end: "เลขชุด หน้ากลางหลัง (สูง, ต่ำ, คู่, คี่)",
    stake_label_step_mix: "เลขชุด ผสม (สูงต่ำ + คู่คี่ + ตัดเลข)",
    step_pick_big: "สูง",
    step_pick_small: "ต่ำ",
    step_pick_even: "คู่",
    step_pick_odd: "คี่",

    // Package labels — keyed by Package.code (see api/src/seeds/package.seed.ts)
    package1: "บาทละ 70",
    package2: "บาทละ 80",
    package3: "บาทละ 90",
    package4: "บาทละ 91",
    package5: "บาทละ 92",
    package6: "บาทละ 93",
    package7: "บาทละ 94",
    package8: "บาทละ 95",
    package9: "บาทละ 96",
    package10: "บาทละ 97",
    package11: "บาทละ 98",

    topup_status_pending: "รอดำเนินการ",
    topup_status_approved: "อนุมัติแล้ว",
    topup_status_rejected: "ปฏิเสธแล้ว",
    topup_load_admin_error: "เกิดข้อผิดพลาดในการโหลดข้อมูลผู้ดูแล",
    topup_admin_not_found: "ไม่พบข้อมูลผู้ดูแลระบบ",
    topup_confirm_approve_title: "อนุมัติรายการเติมเงินนี้?",
    topup_confirm_reject_title: "ปฏิเสธรายการเติมเงินนี้?",
    topup_already_processed: "รายการนี้ถูกดำเนินการไปแล้ว",
    topup_approve_success: "อนุมัติรายการสำเร็จ",
    topup_reject_success: "ปฏิเสธรายการสำเร็จ",
    topup_action_error: "เกิดข้อผิดพลาดในการดำเนินการ",
    topup_col_evidence: "หลักฐาน",
    topup_col_processed_by: "ดำเนินการโดย",
    topup_approve_button: "อนุมัติ",
    topup_reject_button: "ปฏิเสธ",

    withdraw_confirm_approve_title: "อนุมัติรายการถอนเงินนี้?",
    withdraw_confirm_reject_title: "ปฏิเสธรายการถอนเงินนี้?",
    withdraw_confirm_approve_text_prefix: "จำนวน",
    withdraw_confirm_approve_text_middle: "จะถูกหักออกจากยอดเงินของสมาชิก",
    withdraw_confirm_reject_text: "กดยืนยันเพื่อปฏิเสธรายการถอนเงินของสมาชิก",
    withdraw_insufficient_credit:
      "ยอดเงินของสมาชิกไม่เพียงพอสำหรับการถอนครั้งนี้",
    withdraw_col_balance: "ยอดเงินคงเหลือ",
    withdraw_col_amount: "จำนวนที่ถอน",

    lotto_service_day_of_month_prefix: "วันที่",
    lotto_service_toggle_text_prefix: "คุณกำลังทำการ",
    lotto_service_action_open: "เปิด",
    lotto_service_action_close: "ปิด",
    lotto_service_toggle_text_suffix: "ขายหวย",
    lotto_service_confirm_update: "ใช่, อัพเดต!",
    lotto_service_update_status_error: "เกิดข้อผิดพลาดในการอัพเดตสถานะ",
    lotto_service_update_status_success: "อัพเดตสถานะสำเร็จแล้ว!",
    lotto_service_add_title: "เพิ่มประเภทหวย",
    lotto_service_name_label: "ชื่อประเภทหวย",
    lotto_service_type_code_placeholder: "รหัสประเภท (เช่น th_gov)",
    lotto_service_name_required: "กรุณาระบุชื่อประเภทหวย",
    lotto_service_type_code_required: "กรุณาระบุรหัสประเภท",
    lotto_service_add_error: "เพิ่มประเภทหวยไม่สำเร็จ",
    lotto_service_add_success: "เพิ่มประเภทหวยสำเร็จ",
    lotto_service_round_number_invalid: "หมายเลขรอบต้องเป็นจำนวนเต็มบวก",
    lotto_service_round_prefix: "รอบที่",
    lotto_service_round_duplicate_suffix: "ซ้ำกัน",
    lotto_service_round_needs_time_suffix: "ต้องมีอย่างน้อย 1 ช่วงเวลา",
    lotto_service_round_time_required_suffix: "กรุณาระบุเวลาเริ่ม-สิ้นสุด",
    lotto_service_round_days_of_month_required_suffix:
      "กรุณาเลือกวันที่ในเดือนอย่างน้อย 1 วัน",
    lotto_service_round_days_of_week_required_suffix:
      "กรุณาเลือกวันในสัปดาห์อย่างน้อย 1 วัน",
    lotto_service_edit_error: "แก้ไขประเภทหวยไม่สำเร็จ",
    lotto_service_edit_success: "แก้ไขประเภทหวยสำเร็จ",
    lotto_service_col_type: "ประเภทหวย",
    lotto_service_col_rounds_time: "รอบ และ เวลาเปิดขาย",
    lotto_service_col_reward_group: "กลุ่มรางวัล",
    lotto_service_col_sale_status: "สถานะการขาย",
    lotto_service_no_rounds_yet: "ยังไม่ได้ตั้งค่ารอบ",
    lotto_service_round_label: "รอบ",
    lotto_service_manage_reward_group: "จัดการกลุ่มรางวัล",
    lotto_service_no_reward_groups_yet: "ยังไม่มีกลุ่มรางวัลสำหรับหวยนี้",
    lotto_service_status_open: "เปิดขาย",
    lotto_service_status_closed: "ปิดการขาย",
    lotto_service_edit_title: "แก้ไขประเภทหวย",
    lotto_service_rounds_schedule_label: "รอบ และ ตารางเวลาเปิดขาย",
    lotto_service_add_round_button: "+ เพิ่มรอบ",
    lotto_service_no_rounds_yet_short: "ยังไม่มีรอบ",
    lotto_service_delete_round_button: "ลบรอบ",
    lotto_service_mode_days_of_month: "วันที่ในเดือน",
    lotto_service_mode_days_of_week: "วันในสัปดาห์",
    lotto_service_add_rule_button: "+ เพิ่มช่วงเวลา",

    limitnumber_incomplete_title: "ข้อมูลไม่ครบถ้วน",
    limitnumber_add_confirm_prefix: "คุณจะเพิ่มเลข",
    limitnumber_add_confirm_lotto_prefix: "หวย",
    limitnumber_add_confirm_date_prefix: "งวดวันที่",
    limitnumber_add_confirm_reward_prefix: "รางวัล",
    limitnumber_add_success: "เพิ่มข้อมูลสำเร็จ",
    limitnumber_add_error: "เกิดข้อผิดพลาดในการเพิ่มข้อมูล",
    limitnumber_delete_confirm_text: "คุณต้องการลบเลขอั้นนี้ใช่หรือไม่",
    limitnumber_delete_success: "ลบข้อมูลสำเร็จ",
    limitnumber_delete_error: "เกิดข้อผิดพลาดในการลบข้อมูล",
    limitnumber_edit_confirm_prefix: "คุณต้องการแก้ไขรางวัลเลขที่อั้น",
    limitnumber_edit_confirm_middle: "เป็น",
    limitnumber_edit_success: "แก้ไขข้อมูลสำเร็จ",
    limitnumber_edit_error: "เกิดข้อผิดพลาดในการแก้ไขข้อมูล",
    limitnumber_period_label: "งวดที่",
    limitnumber_add_button: "เพิ่มเลขอั้น",
    limitnumber_col_number: "เลขที่อั้น",
    limitnumber_draw_label: "งวด",
    limitnumber_col_result_round: "รอบที่ออกผล",
    limitnumber_placeholder: "เลขอั้น",
    limitnumber_reward_label: "รางวัลเลขที่อั้น",
    limitnumber_edit_title: "แก้ไขเรทเลขอั้น",

    lotto_type_th_gov: "รัฐบาลไทย",
    lotto_type_laos_gov: "ลาว",
    lotto_type_hanoi: "หวยฮานอย",

    fightlimit_exceed_prefix: "รับสู้สูงสุดไม่ควรเกิน",
    fightlimit_update_success: "อัปเดตรับสู้สูงสุดสำเร็จ",
    fightlimit_update_error: "เกิดข้อผิดพลาดในการอัปเดตรับสู้สูงสุด",
    fightlimit_col_game_type: "ชนิดเกมส์",
    fightlimit_col_max: "รับสู้สูงสุด",
    fightlimit_save_button: "บันทึกเข้าสู่ระบบ",

    lotto_type_select_filter_first:
      "กรุณาเลือกประเภทหวยที่ตัวกรองก่อนสร้างกลุ่ม",
    lotto_type_create_group_title: "สร้างกลุ่มใหม่",
    lotto_type_group_name_label: "ชื่อกลุ่ม",
    lotto_type_group_name_required: "กรุณาระบุชื่อกลุ่ม",
    lotto_type_create_group_error: "สร้างกลุ่มไม่สำเร็จ",
    lotto_type_create_group_success: "สร้างกลุ่มสำเร็จ",
    lotto_type_edit_group_title: "แก้ไขกลุ่ม",
    lotto_type_select_type_required: "กรุณาเลือกประเภทหวย",
    lotto_type_edit_group_error: "แก้ไขกลุ่มไม่สำเร็จ",
    lotto_type_edit_group_success: "แก้ไขกลุ่มสำเร็จ",
    lotto_type_delete_group_confirm_prefix: "ต้องการลบกลุ่ม",
    lotto_type_confirm_yes_delete: "ใช่, ลบ",
    lotto_type_delete_group_error: "ลบกลุ่มไม่สำเร็จ",
    lotto_type_delete_group_success: "ลบกลุ่มสำเร็จ",
    lotto_type_remove_item_error: "นำออกไม่สำเร็จ",
    lotto_type_add_item_error: "เพิ่มไม่สำเร็จ",
    lotto_type_add_item_success: "เพิ่มรายการสำเร็จ",
    lotto_type_create_group_button: "สร้างกลุ่ม",
    lotto_type_no_groups_yet: "ยังไม่มีกลุ่ม",
    lotto_type_add_item_button: "เพิ่มรายการ",
    lotto_type_delete_group_button: "ลบกลุ่ม",
    lotto_type_no_items_in_group: "ยังไม่มีรายการในกลุ่มนี้",
    lotto_type_search_placeholder: "ค้นหาชื่อ/รหัส",
    lotto_type_no_items_available: "ไม่มีรายการที่สามารถเพิ่มได้",
    lotto_type_used_in_group_prefix: "ใช้อยู่ในกลุ่ม",
    lotto_type_add_count_button: "เพิ่ม",

    common_hour: "ชั่วโมง",
    common_minute: "นาที",

    schedule_job_label_th_gov: "หวยรัฐบาลไทย",
    schedule_job_label_lao_gov: "หวยรัฐบาลลาว",
    schedule_job_label_yeekee5: "ยี่กี่ 5",
    schedule_job_label_yeekee10: "ยี่กี่ 10",
    schedule_job_label_yeekee15: "ยี่กี่ 15",
    schedule_job_label_hanoi_round_1: "ฮานอย รอบ 1",
    schedule_job_label_hanoi_round_2: "ฮานอย รอบ 2",
    schedule_job_label_hanoi_round_3: "ฮานอย รอบ 3",
    schedule_job_label_hanoi_round_4: "ฮานอย รอบ 4",
    schedule_job_label_hanoi_round_5: "ฮานอย รอบ 5",
    schedule_job_label_hanoi_round_6: "ฮานอย รอบ 6",
    schedule_job_label_clear_activity_log: "ล้างประวัติกิจกรรม",
    schedule_type_minute_list: "รายการนาที (เช่น ทุก 5 นาที)",
    schedule_type_daily: "รายวัน (เวลาเดียวต่อวัน)",
    schedule_type_weekly_window: "ช่วงเวลารายสัปดาห์",
    schedule_type_advanced: "ขั้นสูง (Cron Expression)",
    schedule_all_jobs_configured_prefix: "มีตารางเวลาครบทั้ง",
    schedule_all_jobs_configured_suffix: "งานแล้ว",
    schedule_description_required: "กรุณาระบุคำอธิบาย",
    schedule_minute_required: "กรุณาเลือกอย่างน้อย 1 นาที",
    schedule_day_required: "กรุณาเลือกอย่างน้อย 1 วัน",
    schedule_cron_required: "กรุณาระบุ Cron Expression",
    schedule_create_error: "สร้างตารางเวลาไม่สำเร็จ",
    schedule_create_success: "สร้างตารางเวลาสำเร็จ",
    schedule_edit_error: "แก้ไขตารางเวลาไม่สำเร็จ",
    schedule_edit_success: "แก้ไขตารางเวลาสำเร็จ",
    schedule_toggle_status_error: "เปลี่ยนสถานะไม่สำเร็จ",
    schedule_add_button: "เพิ่มตารางเวลา",
    schedule_col_description: "คำอธิบาย",
    schedule_col_format: "รูปแบบ",
    schedule_col_cron_example: "Cron (ตัวอย่างที่รัน)",
    schedule_enabled_label: "เปิดใช้งาน",
    schedule_no_schedules_yet: "ยังไม่มีตารางเวลา",
    schedule_edit_title: "แก้ไขตารางเวลา",
    schedule_type_label: "รูปแบบเวลา",
    schedule_minutes_label: "นาทีที่ทำงาน",
    schedule_hour_optional_label: "ชั่วโมง (เว้นว่าง = ทุกชั่วโมง)",
    schedule_every_hour: "ทุกชั่วโมง",
    schedule_days_of_month_optional_label: "วันที่ของเดือน (เว้นว่าง = ทุกวัน)",
    schedule_minute_start_label: "นาทีเริ่ม",
    schedule_minute_end_label: "นาทีสิ้นสุด",
    schedule_cron_placeholder: "เช่น 0,15,30,45 * * * *",

    common_view: "ดู",
    winlose_col_account: "บัญชี",
    winlose_col_name: "ชื่อ",
    winlose_col_view: "ตัว",
    winlose_col_bet_amount: "ยอดการแทง",
    winlose_col_payout: "จ่ายออก",
    winlose_col_company: "บริษัท",
    winlose_col_senior: "ซีเนียร์",
    winlose_col_master: "มาสเตอร์",
    winlose_col_agent: "เอเย่นต์",
    winlose_col_win_loss: "ชนะ/แพ้",

    wl_tooltip_stake: "ยอดแทง",
    wl_tooltip_position_pct: "อัตราภาระ (ระดับนี้)",
    wl_tooltip_position_amount: "ภาระ",
    wl_tooltip_fight_limit_credit: "วงเงินค้ำที่เหลือ",
    wl_tooltip_fight_limit_config: "วงเงินค้ำถือสู้",
    wl_upline_config_title: "การตั้งค่าสายเทิงของสมาชิก",
    wl_upline_config_tier: "ระดับ",
    wl_upline_config_name: "ชื่อ",
    wl_upline_config_reward_rate: "อัตราจ่าย",
    wl_tooltip_excess: "ส่วนเกิน (ส่งต่อชั้นบน)",
    wl_tooltip_turnover_formula:
      "เทิร์นโอเวอร์ คือยอดที่ระดับนี้รับผิดชอบจริง โดยจะเอาค่าที่น้อยกว่าระหว่างวงเงินค้ำที่เหลือ กับยอดภาระที่ควรได้รับ (รวมส่วนเกินที่ส่งมาจากระดับล่าง ถ้ามี) เพื่อไม่ให้เกินวงเงินที่ตั้งไว้",
    wl_tooltip_commission_pct: "อัตราคอมมิชชั่น",
    wl_tooltip_commission_base:
      "ฐานคำนวณคอม (stake − เทิร์นโอเวอร์ตัวเอง/ชั้นล่าง)",
    wl_tooltip_net_commission: "คอมมิชชั่นสุทธิ",
    wl_tooltip_position_net_base_pct: "อัตราภาระสุทธิ",
    wl_tooltip_position_net: "ภาระสุทธิ",
    wl_tooltip_net_amount_label: "ยอดสุทธิ",
    wl_tooltip_net_amount_formula: "ยอดสุทธิ = ภาระสุทธิ + คอมมิชชั่นสุทธิ",
    wl_tooltip_win_formula:
      "ผลได้เสีย = −(เทิร์นโอเวอร์ × อัตราจ่าย) + ยอดสุทธิ",
    wl_tooltip_pending_formula: "ผลได้เสีย = ยอดสุทธิ (ยังไม่ออกผล/แพ้)",
    wl_tooltip_member_turnover_formula: "เทิร์นโอเวอร์ของสมาชิก = ยอดแทง",
    wl_tooltip_member_commission_amount:
      "ค่าคอมมิชชั่นสมาชิก (stake × อัตราคอม)",
    wl_tooltip_member_net_formula: "ยอดสุทธิ = (stake × อัตราคอม) − stake",
    wl_tooltip_win_amount: "ยอดถูกรางวัล",
    wl_tooltip_member_win_formula:
      "ผลได้เสีย = ยอดถูกรางวัล − (ยอดแทง − ค่าคอมมิชชั่น)",
    wl_tooltip_member_pending_formula: "ผลได้เสีย = ยอดสุทธิ (ยังไม่ออกผล/แพ้)",
    wl_tooltip_title_turnover: "ที่มาของเทิร์นโอเวอร์",
    wl_tooltip_title_net_amt: "ที่มาของยอดสุทธิ",
    wl_tooltip_title_wl: "ที่มาของผลได้เสีย",

    lottoresult_select_type_label: "เลือกประเภทหวย :",
    lottoresult_date_label: "วันที่ผลออก :",
    lottoresult_select_round_label: "เลือกรอบ :",
    lottoresult_add_button: "+ เพิ่มผลรางวัล",
    lottoresult_table_header: "ผลรางวัล",
    lottoresult_source_title: "ตรวจสอบการเชื่อมต่อแหล่งผลหวย",
    lottoresult_source_check_button: "ตรวจสอบ",
    lottoresult_source_checking: "กำลังตรวจสอบ...",
    lottoresult_source_th_gov: "หวยไทย",
    lottoresult_source_laos_gov: "หวยลาว",
    lottoresult_source_hanoy: "หวยฮานอย",
    lottoresult_source_connected: "เชื่อมต่อได้",
    lottoresult_source_failed: "เชื่อมต่อไม่ได้",
    lottoresult_source_latest: "ล่าสุด",

    add_result_title: "เพิ่มผลรางวัล",
    add_result_lotto_type_label: "ประเภทหวย",
    add_result_date_label: "วันที่ผลออก",
    add_result_round_label: "รอบที่",
    add_result_top_label: "เลขบน",
    add_result_bottom_label: "เลขล่าง",
    add_result_digits_suffix: "หลัก",
    add_result_top_placeholder_th_gov: "เช่น 506357",
    add_result_top_placeholder_other: "เช่น 12345",
    add_result_bottom_placeholder: "เช่น 31",
    add_result_top_required: "กรุณากรอกเลขบน",
    add_result_bottom_required: "กรุณากรอกเลขล่าง",
    add_result_save_error: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
    add_result_save_success: "บันทึกผลรางวัลสำเร็จ",
    add_result_save_button: "บันทึก",
    add_result_fetch_button: "ดึงผลจากแหล่งข้อมูล",
    add_result_fetching: "กำลังดึงผล...",
    add_result_fetch_success: "ดึงผลสำเร็จ กรุณาตรวจสอบก่อนบันทึก",

    common_order: "ออเดอร์",
    common_number_label: "เลข",
    waitresult_fight_percent_label: "สู้ %",
    waitresult_commission_percent_label: "คอมมิชชั่น (%)",
    waitresult_fight_limit_remaining_label: "Fight Limit คงเหลือ",
    waitresult_outstanding_label: "ยอดคงค้าง",
    waitresult_payout_rate_label: "อัตราจ่าย",
    waitresult_bet_wager_label: "ยอดพนัน(เดิมพัน)",
    waitresult_bet_payout_label: "ยอดพนัน(การจ่าย)",
    waitresult_amount_label: "ยอด",

    common_date_label: "วันที่",
    common_search: "ค้นหา",
    lotto_type_yeekee: "จับยี่กี",
    lotto_type_yeekee_vip: "จับยี่กี VIP",
    lotto_type_yeekee_vvip: "จับยี่กี VVIP",
    bet_group_four_digit: "4ตัว",
    bet_group_three_digit: "3ตัว",
    bet_group_two_digit: "2ตัว",
    lottobet_market_label: "ตลาด",
    lottobet_draw_date_label: "งวดประจำวันที่",
    lottobet_bet_type_label: "ประเภทที่แทง",
    loginlog_date_prefix: "วันที่",
    loginlog_time_prefix: "เวลา",
    activitylog_col_entity: "เอนทิตี",
    activitylog_col_entity_id: "รหัสเอนทิตี",
    activitylog_col_action: "การกระทำ",
    activitylog_col_changed_fields: "ฟิลด์ที่เปลี่ยนแปลง",
    activitylog_col_old_values: "ค่าเดิม",
    activitylog_col_new_values: "ค่าใหม่",
    activitylog_col_user_id: "รหัสผู้ใช้",
  },
  en: {
    navbar_welcome: "MESOK LOTERRY - Welcome",
    navbar_home: "Home",
    navbar_logout: "Logout",
    navbar_notice: "NOTICE",
    navbar_notice_text:
      "System notice: the system is currently under development. Announced 12/11/2024",
    logout_confirm_title: "Do you want to log out?",
    logout_confirm_yes: "Yes, log out",
    logout_confirm_no: "No",

    sidebar_close_menu: "Close Menu",
    sidebar_open_menu: "Open Menu",
    menu_category_1: "1 Menu",
    menu_category_2: "2 Limit Setting",
    menu_category_3: "3 Report",
    menu_category_4: "4 Stake",
    menu_category_5: "5 System Logs",
    menu_dashboard: "Dashboard",
    menu_manage_members: "Manage Members",
    menu_manage_subaccount: "Manage Sub-accounts",
    menu_agent_system: "Agent Management System",
    menu_manage_senior: "Manage Senior",
    menu_manage_master: "Manage Master",
    menu_manage_agent: "Manage Agent",
    menu_manage_commission: "Manage Commission",
    menu_manage_topup: "Manage Member Top-up",
    menu_manage_withdraw: "Manage Member Withdrawal",
    menu_lotto_onoff: "Lotto On/Off",
    menu_limit_number: "Limit Number",
    menu_max_fight: "Max Fight Setting",
    menu_commission_reward_setting: "Commission & Reward Setting",
    menu_lotto_type_setting: "Lotto Type Setting",
    menu_schedule_setting: "Schedule Setting",
    menu_winlose: "Win/Loss",
    menu_lotto_result: "Lotto Result",
    menu_membertopup_report: "Customer Credit Top-up Report",
    menu_agenttopup_report: "Agent Credit Top-up Report",
    menu_bet_amount: "Stake",
    menu_outstanding_user: "Outstanding by User",
    menu_outstanding_type: "Outstanding by Type",
    menu_login_history: "Login History",
    menu_activity_logs: "Activity Logs",
    menu_settings: "Settings",
    settings_tab_currency: "Currency",
    settings_currency_col_code: "Code",
    settings_currency_col_name: "Name",
    settings_currency_col_symbol: "Symbol",
    settings_currency_col_status: "Status",

    login_title: "Login",
    login_subtitle: "Please enter your details to access the admin system",
    login_username_label: "Username",
    login_password_label: "Password",
    login_hide_password: "Hide password",
    login_show_password: "Show password",
    login_signing_in: "Signing in...",
    login_suspended_title: "Account Suspended",
    login_suspended_text: "Please contact the main account owner",
    login_error_title: "Login Failed",
    login_error_text: "Incorrect Username or password",
    common_ok: "OK",
    common_cancel: "Cancel",
    common_confirm: "Confirm",
    common_yes: "Yes",
    common_no: "No",
    common_error: "Error!",
    common_oops: "Oops...",
    common_success_title: "Success!",
    common_generic_error: "An error occurred!",
    common_no_permission: "No permission",
    common_load_error: "Error loading data",
    common_add: "Add",
    common_optional: "Optional",
    common_next: "Next",
    common_previous: "Previous",
    common_saving: "Saving...",
    common_are_you_sure: "Are you sure?",
    common_page_previous: "Previous",
    common_items_unit: "items",
    common_edit: "Edit",
    common_all: "All",
    common_no_data: "No data",
    common_member: "Member",
    common_create: "Create",
    common_details: "Details",
    common_loading: "Loading...",
    common_to: "to",
    common_delete: "Delete",
    common_update: "Update",
    common_close: "Close",
    common_per_page: "Per page",

    weekday_sun: "Sunday",
    weekday_mon: "Monday",
    weekday_tue: "Tuesday",
    weekday_wed: "Wednesday",
    weekday_thu: "Thursday",
    weekday_fri: "Friday",
    weekday_sat: "Saturday",

    dashboard_title: "Account",
    dashboard_login_id: "Login Username",
    dashboard_credit: "Available Credit",
    dashboard_member_count: "Number of Members",
    dashboard_downline_count: "Number of Downlines",
    dashboard_bet_amount: "Total Staked",
    dashboard_loss_amount: "Total Loss",
    dashboard_profit: "Profit",

    topup_credit_modal_title: "Top-up Credit",
    topup_credit_modal_user_not_found: "User not found",
    topup_credit_modal_error: "Failed to top up credit",
    topup_credit_modal_success: "Credit topped up successfully",
    topup_credit_modal_history_title: "Top-up Credit History",
    topup_credit_modal_col_by: "By",

    member_page_title: "Member",
    member_add_button: "Add Member",
    member_add_dialog_title: "Add New Member",
    member_field_required: "Required",
    member_first_name: "First Name",
    member_last_name: "Last Name",
    member_mobile_number: "Mobile Number",
    member_bank: "Bank",
    member_bank_account_number: "Bank Account Number",
    member_fill_all_fields: "Please fill in all required fields!",
    member_add_success: "New member added successfully!",
    member_register_error: "An error occurred while registering the user.",
    member_package_label: "Package",
    member_package_placeholder: "Select package",
    member_package_required: "Please select a package",

    member_commission_no_groups: "No reward groups for this lotto type",
    member_commission_sync_group: "Use the same value for the whole group",
    member_commission_label: "Commission",
    member_commission_validate_title: "Please check the information",
    member_commission_exceed_prefix: "Commission should not exceed",
    commission_step_reward_label: "Reward",
    commission_step_reward_exceed_prefix: "Reward should not exceed",
    commission_step_no_items: "This group has no items yet",
    commission_step_reward_placeholder: "Enter reward",
    commission_step_commission_placeholder: "Enter commission",
    commission_step_minbet_label: "Min Bet",
    commission_step_maxbet_label: "Max Bet",
    commission_step_maxbetpermatch_label: "Max/Match",
    commission_step_maxfight_label: "Max Fight %",
    commission_step_maxfight_exceed_prefix:
      "Position tracking should not exceed",
    member_commission_filter_label: "Filter by lotto:",
    commission_filter_by_package: "Package:",
    member_commission_group_thai: "Thai Lotto Commission",
    member_commission_group_hanoi: "Hanoi Lotto Commission",
    member_commission_group_laos: "Laos Lotto Commission",
    member_commission_group_yeekee: "Yeekee Commission",
    member_commission_group_yeekeevip: "Yeekee VIP Commission",
    member_commission_group_yeekeevvip: "Yeekee VVIP Commission",

    table_lotto_thai: "Thai Lotto",
    table_lotto_laos: "Laos Lotto",
    table_lotto_yeekee5: "Yeekee 5 Min",
    table_lotto_yeekee10: "Yeekee 10 Min",
    table_lotto_yeekee15: "Yeekee 15 Min",
    table_status_paid: "Paid",
    table_status_unpaid: "Unpaid",
    table_bet_first: "First Prize",
    table_bet_two_bot: "2-Digit Bottom",
    table_bet_run_top: "Run Top",
    table_bet_two_top: "2-Digit Top",
    table_bet_three_front: "3-Digit Front",
    table_bet_run_bot: "Run Bottom",
    table_bet_three_tod: "3-Digit Tod",
    table_bet_three_top: "3-Digit Top",
    table_filter_by_lotto_type: "By Lotto Type",
    table_filter_by_bet_type: "Game",
    table_search_button: "Search",
    common_export_excel: "Export Excel",
    common_exporting: "Exporting...",
    table_from_date: "From Date",
    table_to_date: "To Date",
    table_search_username: "Search by Username",
    table_filter_by_payment_status: "By Payment Status",
    table_search_phone: "Search by Phone Number",
    table_search_account_number: "Search by Account Number",
    table_search_agent_name: "Search Agent Name",
    table_search_upline_name: "Search Upline Name",
    table_total: "Total",

    orderhistory_page_title: "Order History",
    orderhistory_search_number_placeholder: "Search number",
    orderhistory_col_draw_id: "Draw ID",
    orderhistory_col_ticket_no: "Ticket No",
    orderhistory_col_transaction_time: "Transaction Time",
    orderhistory_col_turnover: "Turnover",
    orderhistory_col_net_amt: "Net Amt",
    outstanding_detail_page_title: "Outstanding Detail",
    outstanding_detail_col_comm: "Comm",
    common_first: "First",
    common_last: "Last",

    membertable_delete_confirm_title: "Delete this member?",
    membertable_delete_confirm_text_prefix:
      "Press confirm to permanently delete member",
    membertable_delete_confirm_text_suffix: "",
    membertable_delete_success: "User deleted successfully!",
    membertable_delete_error: "An error occurred while deleting the user.",
    membertable_update_confirm_title: "Update this member's details?",
    membertable_update_confirm_text_prefix: "Press confirm to save member data",
    membertable_update_success: "User updated successfully!",
    membertable_update_error: "An error occurred while updating the user.",
    membertable_credit_invalid: "Please enter a valid credit amount",
    membertable_add_credit_confirm_title: "Add credit?",
    membertable_add_credit_confirm_text_prefix:
      "Press confirm to add a credit amount of",
    membertable_add_credit_confirm_text_middle: "to member",
    membertable_add_credit_insufficient: "Insufficient credit!",
    membertable_add_credit_success_prefix: "Added a credit amount of",
    membertable_add_credit_success_middle: "to member",
    membertable_add_credit_success_suffix: "successfully",
    membertable_add_credit_error: "An error occurred while adding credit",
    membertable_change_password_title: "Change this member's password?",
    membertable_change_password_text:
      "Press confirm to change this member's password",
    membertable_change_password_error:
      "An error occurred while updating the password",
    membertable_change_password_success: "Password changed successfully",
    membertable_col_no: "No.",
    membertable_col_name: "First Last Name",
    membertable_col_phone: "Phone",
    membertable_col_credit: "Credit",
    membertable_col_manage: "Manage",
    membertopupreport_col_date: "Date",
    membertopupreport_col_member: "Customer",
    membertopupreport_col_approveby: "Approved By",
    agenttopupreport_col_sender: "Given By",
    membertable_tx_col_sender: "Sender",
    membertable_tx_col_receiver: "Receiver",
    membertable_tx_col_amount: "Amount",
    membertable_tx_col_date: "Date",
    membertable_tx_col_ip: "IP",
    membertable_tx_col_device: "Device",
    membertable_edit_title_prefix: "Edit",
    membertable_commission_note:
      "Note: If you edit the commission for any lotto type, please fill in every field for that type completely. (Any field left blank in an edited type will be saved as 0)",
    membertable_save: "Save",
    membertable_change_password_dialog_title_prefix:
      "Change Password for Username:",
    membertable_new_password_prompt: "Enter new password",
    membertable_credit_history_title: "Credit History",
    membertable_add_credit_title_prefix: "Add Credit:",
    membertable_credit_amount_label: "Credit Amount",
    membertable_credit_amount_placeholder: "Enter credit amount",

    subaccount_page_title: "Sub Account",
    subaccount_add_button: "Add Shared Account",
    subaccount_permissions_fetch_error:
      "An error occurred while fetching permissions.",
    subaccount_add_success: "New shared account added successfully!",
    subaccount_duplicate_username: "This username already exists in the system",
    subaccount_status_label: "Status",
    subaccount_status_active: "Active",
    subaccount_status_inactive: "Inactive",
    subaccount_permissions_label: "Permissions",
    subaccount_select_all: "Select All",
    subaccount_update_confirm_title: "Update these details?",
    subaccount_update_confirm_text: "Press confirm to save the data",
    subaccount_update_success: "Shared account updated successfully!",
    subaccount_update_error: "An error occurred while updating the account.",
    subaccount_change_password_title: "Change this shared account's password?",
    subaccount_change_password_text: "Press confirm to change the password",
    subaccount_delete_confirm_title: "Delete this shared account?",
    subaccount_delete_confirm_text_prefix: "Do you want to delete",
    subaccount_delete_success: "Shared account deleted successfully!",
    common_delete_error: "Something went wrong!",
    subaccount_col_last_login_time: "Last Login Time",
    subaccount_col_last_login_ip: "Last Login IP",
    subaccount_edit_dialog_title: "Edit Shared Account",

    agent_credit_amount_required: "Please enter the credit amount!",
    agent_credit_confirm_title: "Are you sure?",
    agent_credit_confirm_text_prefix: "Do you want to add a credit amount of",
    agent_credit_confirm_text_middle: "to",
    agent_credit_insufficient: "Insufficient credit!",
    agent_credit_added_success: "Credit added successfully!",
    agent_no_downline: "No downline",
    agent_downline_list_title: "Downline List",
    agent_col_agent_username: "Agent Username",
    agent_col_position: "Position",
    agent_col_upline: "Upline",
    agent_col_total_downline: "Total Downline",
    agent_col_total_member: "Total Member",
    agent_col_credit: "Credit",
    agent_col_credit_history: "History",
    agent_col_status: "Status",
    agent_col_lock: "Lock",
    agent_lock_confirm_title: "Confirm Action",
    agent_lock_confirm_text_lock: "Do you want to lock this user?",
    agent_lock_confirm_text_unlock: "Do you want to unlock this user?",
    agent_lock_success: "Data saved successfully",
    agent_lock_error: "An error occurred while saving the data",
    agent_status_confirm_title: "Change User Status",
    agent_status_inactive_warning_title: "Warning",
    agent_status_inactive_warning_text:
      "Setting status to \"Inactive\" will permanently reset this agent's and every downline's commission and payrate to 0. This cannot be undone. Continue?",
    member_status_inactive_warning_title: "Warning",
    member_status_inactive_warning_text:
      'Setting status to "Inactive" will permanently reset this member\'s commission to 0. This cannot be undone. Continue?',
    agent_col_add_remove_credit: "Add/Remove Credit",
    agent_col_edit_data: "Edit Data",
    agent_person_unit: "",
    agent_add_credit_title: "Add Credit",
    agent_remove_credit_title: "Remove Credit",

    permission_category_member: "Manage Members",
    permission_category_sub_account: "Shared Accounts",
    permission_category_company: "Manage Company",
    permission_category_senior_account: "Manage Senior",
    permission_category_master_account: "Manage Master",
    permission_category_agent: "Manage Agent",
    permission_category_commission: "Commission",
    permission_category_payrate: "Reward",
    permission_category_limited_number: "Limited Numbers",
    permission_category_fight_limit: "Bet Limit",
    permission_category_win_lose: "Win/Loss Report",
    permission_category_result: "Lottery Result Report",
    permission_category_lotto_wait: "Pending Result Report",
    permission_category_activity_log: "Activity Log",
    permission_category_login_log: "Login History",
    permission_category_bet: "Betting",
    permission_category_billcut: "Bill Cut",
    permission_category_hanoi: "Hanoi Result",
    permission_category_memberlog: "Member Transaction Log",
    permission_category_order: "Orders",
    permission_category_permission: "Permissions",
    permission_category_transaction: "Transactions",
    permission_category_waitresultuser: "Outstanding by User",
    permission_category_waitresulttype: "Outstanding by Type",
    permission_category_lottobet: "Stake",
    permission_category_lotto_reward_type_group: "Manage Reward Type Groups",
    permission_category_lotto_type: "Manage Lottery Types",
    permission_category_schedule: "Manage Schedule",
    permission_category_other: "Other",

    permission_label_member_view: "View Member Information",
    permission_label_member_add: "Add Member",
    permission_label_member_edit: "Edit Member",
    permission_label_member_delete: "Delete Member",
    permission_label_sub_account_view: "View Sub Account Information",
    permission_label_sub_account_add: "Add Sub Account",
    permission_label_sub_account_edit: "Edit Sub Account",
    permission_label_sub_account_delete: "Delete Sub Account",
    permission_label_company_view: "View Company Information",
    permission_label_company_add: "Add Company",
    permission_label_company_edit: "Edit Company",
    permission_label_company_delete: "Delete Company",
    permission_label_senior_account_view: "View Senior Account Information",
    permission_label_senior_account_add: "Add Senior Account",
    permission_label_senior_account_edit: "Edit Senior Account",
    permission_label_senior_account_delete: "Delete Senior Account",
    permission_label_master_account_view: "View Master Account Information",
    permission_label_master_account_add: "Add Master Account",
    permission_label_master_account_edit: "Edit Master Account",
    permission_label_master_account_delete: "Delete Master Account",
    permission_label_agent_view: "View Agent Information",
    permission_label_agent_add: "Add Agent",
    permission_label_agent_edit: "Edit Agent",
    permission_label_agent_delete: "Delete Agent",
    permission_label_commission_view: "View Commission Information",
    permission_label_commission_edit: "Edit Commission",
    permission_label_payrate_view: "View Reward Information",
    permission_label_payrate_edit: "Edit Reward",
    permission_label_payrate_on_off: "Enable/Disable Reward",
    permission_label_limited_number_view: "View Limited Numbers Information",
    permission_label_limited_number_add: "Add Limited Number",
    permission_label_limited_number_edit: "Edit Limited Number",
    permission_label_limited_number_delete: "Delete Limited Number",
    permission_label_fight_limit_view: "View Bet Limit Information",
    permission_label_fight_limit_edit: "Edit Bet Limit",
    permission_label_win_lose_view: "View Win/Loss Information",
    permission_label_result_view: "View Lottery Result Information",
    permission_label_lotto_wait_view: "View Pending Lottery Result Information",
    permission_label_activity_log_view: "View Activity Log Information",
    permission_label_login_log_view: "View Login History Information",
    permission_label_bet_view: "View Bet Information",
    permission_label_bet_edit: "Edit Bet Information",
    permission_label_billcut_view: "View Bill Cut Information",
    permission_label_billcut_edit: "Edit Bill Cut Information",
    permission_label_hanoi_edit: "Edit Hanoi Result",
    permission_label_memberlog_view: "View Member Transaction Log",
    permission_label_memberlog_edit: "Edit Member Transaction Log",
    permission_label_order_view: "View Order Information",
    permission_label_order_edit: "Edit Order Information",
    permission_label_permission_view: "View Permission Information",
    permission_label_permission_edit: "Edit Permission",
    permission_label_transaction_view: "View Transaction Information",
    permission_label_waitresultuser_view: "Outstanding by User",
    permission_label_waitresulttype_view: "Outstanding by Type",
    permission_label_lottobet_view: "Stake",
    permission_label_lotto_reward_type_group_view: "View Reward Type Group",
    permission_label_lotto_reward_type_group_add: "Add Reward Type Group",
    permission_label_lotto_reward_type_group_edit: "Edit Reward Type Group",
    permission_label_lotto_reward_type_group_delete: "Delete Reward Type Group",
    permission_label_lotto_type_view: "View Lottery Type",
    permission_label_lotto_type_add: "Add Lottery Type",
    permission_label_lotto_type_edit: "Edit Lottery Type",
    permission_label_lotto_type_delete: "Delete Lottery Type",
    permission_label_schedule_view: "View Schedule",
    permission_label_schedule_add: "Add Schedule",
    permission_label_schedule_edit: "Edit Schedule",
    permission_label_schedule_delete: "Delete Schedule",

    agentadd_password_required: "Please fill in the password!",
    agentadd_package_required: "Please enable at least 1 package!",
    agentadd_position_required: "Please select a position!",
    agentadd_generic_error:
      "Something went wrong, please refresh and try again!",
    agentadd_confirm_title: "Add this Agent?",
    agentadd_confirm_text_prefix: "Add Agent",
    agentadd_confirm_text_middle: "at level",
    agentadd_success_prefix: "Added account",
    agentadd_success_middle: "at level",
    agentadd_success_suffix: "successfully",
    agentadd_step_commission_reward: "Commission & Reward",
    agentadd_step_bet_limit: "Bet Limit",
    agentadd_step_max_fight_percent: "Positon tacking",
    agentadd_step_fight_limit: "Fight Limit",
    agentadd_header_title: "Agent => Add New Agent",
    agentadd_name_label: "Name",
    agentadd_tel_label: "Tel",
    agentadd_email_label: "Email",
    agentadd_status_label: "Status",
    agentadd_status_active: "Active",
    agentadd_status_inactive: "Inactive",
    agentadd_status_suspend: "Suspend",
    agentadd_lock_label: "Lock",
    agentadd_currency_label: "Currency",
    agentedit_currency_cascade_hint:
      "Changing the currency also applies to all downline agents and members of this agent",
    agentadd_save_button: "Save Data",

    agentedit_confirm_text: "Do you want to save this data?",
    agentedit_save_success: "Data saved successfully",
    agentedit_save_error: "An error occurred while saving the data",
    agentedit_header_title: "Agent => Edit Agent",
    agentedit_downline_header: "Downline Edit",
    agentedit_downline_header_of: "downline of",

    commission_nav_commission: "Commission",
    commission_nav_reward: "Reward",
    commission_nav_max_bet: "Max Bet",
    commission_nav_min_bet: "Min Bet",
    commission_nav_max_bet_per_match: "Max Bet Per Number",
    commission_filter_by_lotto_type: "Filter by lotto type:",
    commission_filter_by_downline_level: "Downline level:",
    commission_page_label: "Page",
    commission_total_prefix: "Total",
    commission_edit_dialog_title: "Adjust Commission",
    commission_max_label: "Max",
    commission_no_data_yet: "No data yet",

    stake_label_first: "First Prize",
    stake_label_four_top: "4 Top",
    stake_label_four_tod: "4 Tod",
    stake_label_three_top: "3 Top",
    stake_label_three_front: "3 Front",
    stake_label_three_bot: "3 Bottom",
    stake_label_three_tod: "3 Tod",
    stake_label_two_top: "2 Top",
    stake_label_two_bot: "2 Bottom",
    stake_label_run_top: "Run Top",
    stake_label_run_bot: "Run Bottom",
    stake_label_run_top_front: "Run Front (Top)",
    stake_label_run_top_mid: "Run Middle (Top)",
    stake_label_run_top_end: "Run End (Top)",
    stake_label_run_bot_front: "Run Front (Bottom)",
    stake_label_run_bot_mid: "Run Middle (Bottom)",
    stake_label_run_bot_end: "Run End (Bottom)",
    stake_label_run_top_big: "Run High (Top)",
    stake_label_run_top_small: "Run Low (Top)",
    stake_label_run_top_even: "Run Even (Top)",
    stake_label_run_top_odd: "Run Odd (Top)",
    stake_label_run_bot_big: "Run High (Bottom)",
    stake_label_run_bot_small: "Run Low (Bottom)",
    stake_label_run_bot_even: "Run Even (Bottom)",
    stake_label_run_bot_odd: "Run Odd (Bottom)",
    stake_label_run_top_front_even: "Run Front Even (Top)",
    stake_label_run_top_front_odd: "Run Front Odd (Top)",
    stake_label_run_top_front_small: "Run Front Low (Top)",
    stake_label_run_top_front_big: "Run Front High (Top)",
    stake_label_run_top_mid_even: "Run Middle Even (Top)",
    stake_label_run_top_mid_odd: "Run Middle Odd (Top)",
    stake_label_run_top_mid_small: "Run Middle Low (Top)",
    stake_label_run_top_mid_big: "Run Middle High (Top)",
    stake_label_run_top_end_even: "Run End Even (Top)",
    stake_label_run_top_end_odd: "Run End Odd (Top)",
    stake_label_run_top_end_small: "Run End Low (Top)",
    stake_label_run_top_end_big: "Run End High (Top)",
    stake_label_run_bot_front_even: "Run Front Even (Bottom)",
    stake_label_run_bot_front_odd: "Run Front Odd (Bottom)",
    stake_label_run_bot_front_small: "Run Front Low (Bottom)",
    stake_label_run_bot_front_big: "Run Front High (Bottom)",
    stake_label_run_bot_mid_even: "Run Middle Even (Bottom)",
    stake_label_run_bot_mid_odd: "Run Middle Odd (Bottom)",
    stake_label_run_bot_mid_small: "Run Middle Low (Bottom)",
    stake_label_run_bot_mid_big: "Run Middle High (Bottom)",
    stake_label_run_bot_end_even: "Run End Even (Bottom)",
    stake_label_run_bot_end_odd: "Run End Odd (Bottom)",
    stake_label_run_bot_end_small: "Run End Low (Bottom)",
    stake_label_run_bot_end_big: "Run End High (Bottom)",
    stake_label_step_front_mid_end:
      "Number Set: Front-Middle-Back (High, Low, Even, Odd)",
    stake_label_step_mix:
      "Number Set: Mixed (High-Low + Even-Odd + Number Cut)",
    step_pick_big: "Big",
    step_pick_small: "Small",
    step_pick_even: "Even",
    step_pick_odd: "Odd",

    // Package labels — keyed by Package.code (see api/src/seeds/package.seed.ts)
    package1: "70 per Baht",
    package2: "80 per Baht",
    package3: "90 per Baht",
    package4: "91 per Baht",
    package5: "92 per Baht",
    package6: "93 per Baht",
    package7: "94 per Baht",
    package8: "95 per Baht",
    package9: "96 per Baht",
    package10: "97 per Baht",
    package11: "98 per Baht",

    topup_status_pending: "Pending",
    topup_status_approved: "Approved",
    topup_status_rejected: "Rejected",
    topup_load_admin_error: "An error occurred while loading admin information",
    topup_admin_not_found: "Admin information not found",
    topup_confirm_approve_title: "Approve this top-up request?",
    topup_confirm_reject_title: "Reject this top-up request?",
    topup_already_processed: "This request has already been processed",
    topup_approve_success: "Approved successfully",
    topup_reject_success: "Rejected successfully",
    topup_action_error: "An error occurred while processing the request",
    topup_col_evidence: "Evidence",
    topup_col_processed_by: "Processed By",
    topup_approve_button: "Approve",
    topup_reject_button: "Reject",

    withdraw_confirm_approve_title: "Approve this withdrawal request?",
    withdraw_confirm_reject_title: "Reject this withdrawal request?",
    withdraw_confirm_approve_text_prefix: "The amount of",
    withdraw_confirm_approve_text_middle:
      "will be deducted from the member's balance",
    withdraw_confirm_reject_text:
      "Press confirm to reject this member's withdrawal request",
    withdraw_insufficient_credit:
      "The member's balance is insufficient for this withdrawal",
    withdraw_col_balance: "Remaining Balance",
    withdraw_col_amount: "Withdrawal Amount",

    lotto_service_day_of_month_prefix: "Day",
    lotto_service_toggle_text_prefix: "You are about to",
    lotto_service_action_open: "open",
    lotto_service_action_close: "close",
    lotto_service_toggle_text_suffix: "ticket sales for",
    lotto_service_confirm_update: "Yes, update!",
    lotto_service_update_status_error:
      "An error occurred while updating the status",
    lotto_service_update_status_success: "Status updated successfully!",
    lotto_service_add_title: "Add Lottery Type",
    lotto_service_name_label: "Lottery Type Name",
    lotto_service_type_code_placeholder: "Type code (e.g. th_gov)",
    lotto_service_name_required: "Please enter the lottery type name",
    lotto_service_type_code_required: "Please enter the type code",
    lotto_service_add_error: "Failed to add lottery type",
    lotto_service_add_success: "Lottery type added successfully",
    lotto_service_round_number_invalid:
      "Round number must be a positive integer",
    lotto_service_round_prefix: "Round",
    lotto_service_round_duplicate_suffix: "is duplicated",
    lotto_service_round_needs_time_suffix: "must have at least 1 time slot",
    lotto_service_round_time_required_suffix: "please specify a start-end time",
    lotto_service_round_days_of_month_required_suffix:
      "please select at least 1 day of the month",
    lotto_service_round_days_of_week_required_suffix:
      "please select at least 1 day of the week",
    lotto_service_edit_error: "Failed to update lottery type",
    lotto_service_edit_success: "Lottery type updated successfully",
    lotto_service_col_type: "Lottery Type",
    lotto_service_col_rounds_time: "Rounds & Sale Times",
    lotto_service_col_reward_group: "Reward Group",
    lotto_service_col_sale_status: "Sale Status",
    lotto_service_no_rounds_yet: "No rounds configured yet",
    lotto_service_round_label: "Round",
    lotto_service_manage_reward_group: "Manage Reward Group",
    lotto_service_no_reward_groups_yet:
      "No reward groups for this lottery type yet",
    lotto_service_status_open: "Selling",
    lotto_service_status_closed: "Sale Closed",
    lotto_service_edit_title: "Edit Lottery Type",
    lotto_service_rounds_schedule_label: "Rounds & Sale Schedule",
    lotto_service_add_round_button: "+ Add Round",
    lotto_service_no_rounds_yet_short: "No rounds yet",
    lotto_service_delete_round_button: "Delete Round",
    lotto_service_mode_days_of_month: "Days of Month",
    lotto_service_mode_days_of_week: "Days of Week",
    lotto_service_add_rule_button: "+ Add Time Slot",

    limitnumber_incomplete_title: "Incomplete Information",
    limitnumber_add_confirm_prefix: "You will add the number",
    limitnumber_add_confirm_lotto_prefix: "for lottery",
    limitnumber_add_confirm_date_prefix: "on draw date",
    limitnumber_add_confirm_reward_prefix: "with reward",
    limitnumber_add_success: "Added successfully",
    limitnumber_add_error: "An error occurred while adding the data",
    limitnumber_delete_confirm_text:
      "Do you want to delete this limited number?",
    limitnumber_delete_success: "Deleted successfully",
    limitnumber_delete_error: "An error occurred while deleting the data",
    limitnumber_edit_confirm_prefix:
      "Do you want to change the reward for limited number",
    limitnumber_edit_confirm_middle: "to",
    limitnumber_edit_success: "Updated successfully",
    limitnumber_edit_error: "An error occurred while updating the data",
    limitnumber_period_label: "Draw Date",
    limitnumber_add_button: "Add Limited Number",
    limitnumber_col_number: "Limited Number",
    limitnumber_draw_label: "Draw",
    limitnumber_col_result_round: "Result Round",
    limitnumber_placeholder: "Limited number",
    limitnumber_reward_label: "Reward for Limited Number",
    limitnumber_edit_title: "Edit Limited Number Rate",

    lotto_type_th_gov: "Thai Government",
    lotto_type_laos_gov: "Laos",
    lotto_type_hanoi: "Hanoi Lottery",

    fightlimit_exceed_prefix: "Max fight limit should not exceed",
    fightlimit_update_success: "Fight limit successfully updated.",
    fightlimit_update_error: "An error occurred while updating fight limit.",
    fightlimit_col_game_type: "Game Type",
    fightlimit_col_max: "Max Fight Limit",
    fightlimit_save_button: "Save",

    lotto_type_select_filter_first:
      "Please select a lottery type in the filter before creating a group",
    lotto_type_create_group_title: "Create New Group",
    lotto_type_group_name_label: "Group Name",
    lotto_type_group_name_required: "Please enter a group name",
    lotto_type_create_group_error: "Failed to create group",
    lotto_type_create_group_success: "Group created successfully",
    lotto_type_edit_group_title: "Edit Group",
    lotto_type_select_type_required: "Please select a lottery type",
    lotto_type_edit_group_error: "Failed to update group",
    lotto_type_edit_group_success: "Group updated successfully",
    lotto_type_delete_group_confirm_prefix: "Do you want to delete group",
    lotto_type_confirm_yes_delete: "Yes, delete",
    lotto_type_delete_group_error: "Failed to delete group",
    lotto_type_delete_group_success: "Group deleted successfully",
    lotto_type_remove_item_error: "Failed to remove",
    lotto_type_add_item_error: "Failed to add",
    lotto_type_add_item_success: "Items added successfully",
    lotto_type_create_group_button: "Create Group",
    lotto_type_no_groups_yet: "No groups yet",
    lotto_type_add_item_button: "Add Items",
    lotto_type_delete_group_button: "Delete Group",
    lotto_type_no_items_in_group: "No items in this group yet",
    lotto_type_search_placeholder: "Search name/code",
    lotto_type_no_items_available: "No items available to add",
    lotto_type_used_in_group_prefix: "already used in group",
    lotto_type_add_count_button: "Add",

    common_hour: "Hour",
    common_minute: "Minute",

    schedule_job_label_th_gov: "Thai Government Lottery",
    schedule_job_label_lao_gov: "Laos Government Lottery",
    schedule_job_label_yeekee5: "Yeekee 5",
    schedule_job_label_yeekee10: "Yeekee 10",
    schedule_job_label_yeekee15: "Yeekee 15",
    schedule_job_label_hanoi_round_1: "Hanoi Round 1",
    schedule_job_label_hanoi_round_2: "Hanoi Round 2",
    schedule_job_label_hanoi_round_3: "Hanoi Round 3",
    schedule_job_label_hanoi_round_4: "Hanoi Round 4",
    schedule_job_label_hanoi_round_5: "Hanoi Round 5",
    schedule_job_label_hanoi_round_6: "Hanoi Round 6",
    schedule_job_label_clear_activity_log: "Clear Activity Log",
    schedule_type_minute_list: "Minute list (e.g. every 5 minutes)",
    schedule_type_daily: "Daily (one time per day)",
    schedule_type_weekly_window: "Weekly time window",
    schedule_type_advanced: "Advanced (Cron Expression)",
    schedule_all_jobs_configured_prefix: "All",
    schedule_all_jobs_configured_suffix: "jobs already have a schedule",
    schedule_description_required: "Please enter a description",
    schedule_minute_required: "Please select at least 1 minute",
    schedule_day_required: "Please select at least 1 day",
    schedule_cron_required: "Please enter a Cron Expression",
    schedule_create_error: "Failed to create schedule",
    schedule_create_success: "Schedule created successfully",
    schedule_edit_error: "Failed to update schedule",
    schedule_edit_success: "Schedule updated successfully",
    schedule_toggle_status_error: "Failed to change status",
    schedule_add_button: "Add Schedule",
    schedule_col_description: "Description",
    schedule_col_format: "Format",
    schedule_col_cron_example: "Cron (Next Run Example)",
    schedule_enabled_label: "Enabled",
    schedule_no_schedules_yet: "No schedules yet",
    schedule_edit_title: "Edit Schedule",
    schedule_type_label: "Schedule Type",
    schedule_minutes_label: "Minutes to Run",
    schedule_hour_optional_label: "Hour (blank = every hour)",
    schedule_every_hour: "Every hour",
    schedule_days_of_month_optional_label: "Day of Month (blank = every day)",
    schedule_minute_start_label: "Start Minute",
    schedule_minute_end_label: "End Minute",
    schedule_cron_placeholder: "e.g. 0,15,30,45 * * * *",

    common_view: "View",
    winlose_col_account: "Account",
    winlose_col_name: "Name",
    winlose_col_view: "View",
    winlose_col_bet_amount: "Stake",
    winlose_col_payout: "Payout",
    winlose_col_company: "Company",
    winlose_col_senior: "Senior",
    winlose_col_master: "Master",
    winlose_col_agent: "Agent",
    winlose_col_win_loss: "Win/Loss",

    wl_tooltip_stake: "Stake",
    wl_tooltip_position_pct: "Position-taking rate (this tier)",
    wl_tooltip_position_amount: "Position-taking",
    wl_tooltip_fight_limit_credit: "Remaining fight-limit credit",
    wl_tooltip_fight_limit_config: "Fight limit",
    wl_upline_config_title: "Member's upline configuration",
    wl_upline_config_tier: "Tier",
    wl_upline_config_name: "Name",
    wl_upline_config_reward_rate: "Reward rate",
    wl_tooltip_excess: "Excess (passed up)",
    wl_tooltip_turnover_formula:
      "Turnover is the amount this tier actually takes on — whichever is smaller between the remaining guarantee limit and the position-taking amount owed (including any excess passed up from the tier below), so it never goes over the configured limit.",
    wl_tooltip_commission_pct: "Commission rate",
    wl_tooltip_commission_base:
      "Commission base (stake − own/downline turnover)",
    wl_tooltip_net_commission: "Net commission",
    wl_tooltip_position_net_base_pct: "Net position-taking rate",
    wl_tooltip_position_net: "Net position-taking",
    wl_tooltip_net_amount_label: "Net amount",
    wl_tooltip_net_amount_formula:
      "Net amount = net position-taking + net commission",
    wl_tooltip_win_formula: "Win/Loss = −(turnover × Reward) + net amount",
    wl_tooltip_pending_formula: "Win/Loss = net amount (lose / pending)",
    wl_tooltip_member_turnover_formula: "Member turnover = stake",
    wl_tooltip_member_commission_amount:
      "Member commission amount (stake × rate)",
    wl_tooltip_member_net_formula:
      "Net amount = (stake × commission rate) − stake",
    wl_tooltip_win_amount: "Win amount",
    wl_tooltip_member_win_formula:
      "Win/Loss = win amount − (stake − commission amount)",
    wl_tooltip_member_pending_formula: "Win/Loss = net amount (lose / pending)",
    wl_tooltip_title_turnover: "How turnover is calculated",
    wl_tooltip_title_net_amt: "How net amount is calculated",
    wl_tooltip_title_wl: "How win/loss is calculated",

    lottoresult_select_type_label: "Select Lottery Type:",
    lottoresult_date_label: "Result Date:",
    lottoresult_select_round_label: "Select Round:",
    lottoresult_add_button: "+ Add Result",
    lottoresult_table_header: "Results",
    lottoresult_source_title: "Result Source Connection",
    lottoresult_source_check_button: "Check",
    lottoresult_source_checking: "Checking...",
    lottoresult_source_th_gov: "Thai Lottery",
    lottoresult_source_laos_gov: "Lao Lottery",
    lottoresult_source_hanoy: "Hanoi Lottery",
    lottoresult_source_connected: "Connected",
    lottoresult_source_failed: "Connection failed",
    lottoresult_source_latest: "Latest",

    add_result_title: "Add Result",
    add_result_lotto_type_label: "Lottery Type",
    add_result_date_label: "Draw Date",
    add_result_round_label: "Round",
    add_result_top_label: "Top Number",
    add_result_bottom_label: "Bottom Number",
    add_result_digits_suffix: "digits",
    add_result_top_placeholder_th_gov: "e.g. 506357",
    add_result_top_placeholder_other: "e.g. 12345",
    add_result_bottom_placeholder: "e.g. 31",
    add_result_top_required: "Please enter the top number",
    add_result_bottom_required: "Please enter the bottom number",
    add_result_save_error: "Failed to save data",
    add_result_save_success: "Result saved successfully",
    add_result_save_button: "Save",
    add_result_fetch_button: "Fetch from source",
    add_result_fetching: "Fetching...",
    add_result_fetch_success: "Result fetched — please review before saving",

    common_order: "Order",
    common_number_label: "Number",
    waitresult_fight_percent_label: "Fight %",
    waitresult_commission_percent_label: "Commission %",
    waitresult_fight_limit_remaining_label: "Fight Limit Remaining",
    waitresult_outstanding_label: "Outstanding",
    waitresult_payout_rate_label: "Reward",
    waitresult_bet_wager_label: "Stake (Wager)",
    waitresult_bet_payout_label: "Stake (Payout)",
    waitresult_amount_label: "Amount",

    common_date_label: "Date",
    common_search: "Search",
    lotto_type_yeekee: "Yeekee",
    lotto_type_yeekee_vip: "Yeekee VIP",
    lotto_type_yeekee_vvip: "Yeekee VVIP",
    bet_group_four_digit: "4 Digits",
    bet_group_three_digit: "3 Digits",
    bet_group_two_digit: "2 Digits",
    lottobet_market_label: "Market",
    lottobet_draw_date_label: "Draw Date",
    lottobet_bet_type_label: "Game",
    loginlog_date_prefix: "Date",
    loginlog_time_prefix: "Time",
    activitylog_col_entity: "Entity",
    activitylog_col_entity_id: "Entity ID",
    activitylog_col_action: "Action",
    activitylog_col_changed_fields: "Changed Fields",
    activitylog_col_old_values: "Old Values",
    activitylog_col_new_values: "New Values",
    activitylog_col_user_id: "User ID",
  },
  lo: {
    navbar_welcome: "MESOK LOTERRY - ຍິນດີຕ້ອນຮັບ",
    navbar_home: "ໜ້າທຳອິດ",
    navbar_logout: "ອອກຈາກລະບົບ",
    navbar_notice: "ແຈ້ງການ",
    navbar_notice_text:
      "ແຈ້ງການຈາກລະບົບ : ຂະນະນີ້ກຳລັງຢູ່ໃນຊ່ວງພັດທະນາລະບົບ ແຈ້ງເມື່ອ 12/11/2024",
    logout_confirm_title: "ທ່ານຕ້ອງການອອກຈາກລະບົບແທ້ບໍ?",
    logout_confirm_yes: "ແມ່ນ, ອອກຈາກລະບົບ",
    logout_confirm_no: "ບໍ່",

    sidebar_close_menu: "ປິດເມນູ",
    sidebar_open_menu: "ເປີດເມນູ",
    menu_category_1: "1 ເມນູ",
    menu_category_2: "2 ຕັ້ງຄ່າຈຳກັດ",
    menu_category_3: "3 ລາຍງານ",
    menu_category_4: "4 ຍອດເດີມພັນ",
    menu_category_5: "5 ບັນທຶກລະບົບ",
    menu_dashboard: "Dashboard",
    menu_manage_members: "ຈັດການສະມາຊິກ",
    menu_manage_subaccount: "ຈັດການບັນຊີຜູ້ໃຊ້ຮ່ວມ",
    menu_agent_system: "ລະບົບຈັດການ Agent",
    menu_manage_senior: "ຈັດການ Senior",
    menu_manage_master: "ຈັດການ Master",
    menu_manage_agent: "ຈັດການ Agent",
    menu_manage_commission: "ຈັດການຄອມມິຊັ່ນ",
    menu_manage_topup: "ຈັດການສະມາຊິກຕື່ມເງິນ",
    menu_manage_withdraw: "ຈັດການສະມາຊິກຖອນເງິນ",
    menu_lotto_onoff: "ເປີດປິດຫວຍ",
    menu_limit_number: "ເລກອັ້ນ",
    menu_max_fight: "ຕັ້ງຄ່າຮັບສູ້ສູງສຸດ",
    menu_commission_reward_setting: "ຕັ້ງຄ່າຄອມມິຊັ່ນ & ລາງວັນ",
    menu_lotto_type_setting: "ຕັ້ງຄ່າປະເພດຫວຍ",
    menu_schedule_setting: "ຕັ້ງຄ່າຕາຕະລາງເວລາ",
    menu_winlose: "ແພ້ຊະນະລວມ",
    menu_lotto_result: "ຜົນຫວຍ",
    menu_membertopup_report: "ລາຍງານຕື່ມເຄຣດິດລູກຄ້າ",
    menu_agenttopup_report: "ລາຍງານຕື່ມເຄຣດິດເອເຢນ",
    menu_bet_amount: "ຍອດເດີມພັນ",
    menu_outstanding_user: "ຍອດຄ້າງຜູ້ໃຊ້",
    menu_outstanding_type: "ຍອດຄ້າງຕາມປະເພດ",
    menu_login_history: "ປະຫວັດການເຂົ້າລະບົບ",
    menu_activity_logs: "Activity Logs",
    menu_settings: "ຕັ້ງຄ່າ",
    settings_tab_currency: "ສະກຸນເງິນ",
    settings_currency_col_code: "ລະຫັດ",
    settings_currency_col_name: "ຊື່",
    settings_currency_col_symbol: "ສັນຍາລັກ",
    settings_currency_col_status: "ສະຖານະ",

    login_title: "ເຂົ້າສູ່ລະບົບ",
    login_subtitle: "ກະລຸນາປ້ອນຂໍ້ມູນເພື່ອເຂົ້າໃຊ້ລະບົບຈັດການ",
    login_username_label: "ຊື່ຜູ້ໃຊ້",
    login_password_label: "ລະຫັດຜ່ານ",
    login_hide_password: "ເຊື່ອງລະຫັດຜ່ານ",
    login_show_password: "ສະແດງລະຫັດຜ່ານ",
    login_signing_in: "ກຳລັງເຂົ້າສູ່ລະບົບ...",
    login_suspended_title: "ບັນຊີຖືກໂຈະ",
    login_suspended_text: "ກະລຸນາຕິດຕໍ່ເຈົ້າຂອງບັນຊີຫຼັກ",
    login_error_title: "ເຂົ້າສູ່ລະບົບຜິດພາດ",
    login_error_text: "Username ຫຼືລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ",
    common_ok: "ຕົກລົງ",
    common_cancel: "ຍົກເລີກ",
    common_confirm: "ຢືນຢັນ",
    common_yes: "ແມ່ນ",
    common_no: "ບໍ່",
    common_error: "ຂໍ້ຜິດພາດ!",
    common_oops: "ອູ້ປສ...",
    common_success_title: "ສຳເລັດ!",
    common_generic_error: "ເກີດຂໍ້ຜິດພາດ!",
    common_no_permission: "ບໍ່ມີສິດເຂົ້າເຖິງ",
    common_load_error: "ເກີດຂໍ້ຜິດພາດໃນການໂຫຼດຂໍ້ມູນ",
    common_add: "ເພີ່ມ",
    common_optional: "ບໍ່ບັງຄັບ",
    common_next: "ຖັດໄປ",
    common_previous: "ກັບຄືນ",
    common_saving: "ກຳລັງບັນທຶກ...",
    common_are_you_sure: "ແນ່ໃຈບໍ?",
    common_page_previous: "ກ່ອນໜ້າ",
    common_items_unit: "ລາຍການ",
    common_edit: "ແກ້ໄຂ",
    common_all: "ທັງໝົດ",
    common_no_data: "ບໍ່ມີຂໍ້ມູນ",
    common_member: "ສະມາຊິກ",
    common_create: "ສ້າງ",
    common_details: "ລາຍລະອຽດ",
    common_loading: "ກຳລັງໂຫຼດ...",
    common_to: "ເຖິງ",
    common_delete: "ລຶບ",
    common_update: "ອັບເດດ",
    common_close: "ປິດ",
    common_per_page: "ສະແດງຕໍ່ໜ້າ",

    weekday_sun: "ວັນອາທິດ",
    weekday_mon: "ວັນຈັນ",
    weekday_tue: "ວັນອັງຄານ",
    weekday_wed: "ວັນພຸດ",
    weekday_thu: "ວັນພະຫັດ",
    weekday_fri: "ວັນສຸກ",
    weekday_sat: "ວັນເສົາ",

    dashboard_title: "ບັນຊີ",
    dashboard_login_id: "ຊື່ຜູ້ໃຊ້ເຂົ້າສູ່ລະບົບ",
    dashboard_credit: "ເຄຣດິດທີ່ມີ",
    dashboard_member_count: "ຈຳນວນລູກຄ້າ",
    dashboard_downline_count: "ຈຳນວນດາວໄລນ໌",
    dashboard_bet_amount: "ຍອດແທງ",
    dashboard_loss_amount: "ຍອດເສຍ",
    dashboard_profit: "ກຳໄລ",

    topup_credit_modal_title: "ຕື່ມເຄຣດິດ",
    topup_credit_modal_user_not_found: "ບໍ່ພົບຂໍ້ມູນຜູ້ໃຊ້",
    topup_credit_modal_error: "ເກີດຂໍ້ຜິດພາດໃນການຕື່ມເຄຣດິດ",
    topup_credit_modal_success: "ຕື່ມເຄຣດິດສຳເລັດ",
    topup_credit_modal_history_title: "ປະຫວັດການຕື່ມເຄຣດິດ",
    topup_credit_modal_col_by: "ໂດຍ",

    member_page_title: "ສະມາຊິກ",
    member_add_button: "ເພີ່ມສະມາຊິກ",
    member_add_dialog_title: "ເພີ່ມສະມາຊິກໃໝ່",
    member_field_required: "ຈຳເປັນ",
    member_first_name: "ຊື່",
    member_last_name: "ນາມສະກຸນ",
    member_mobile_number: "ເບີມືຖື",
    member_bank: "ທະນາຄານ",
    member_bank_account_number: "ເລກບັນຊີທະນາຄານ",
    member_fill_all_fields: "ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ!",
    member_add_success: "ເພີ່ມສະມາຊິກໃໝ່ຮຽບຮ້ອຍແລ້ວ!",
    member_register_error: "ເກີດຂໍ້ຜິດພາດໃນການລົງທະບຽນຜູ້ໃຊ້",
    member_package_label: "ແພັກເກັດ",
    member_package_placeholder: "ເລືອກແພັກເກັດ",
    member_package_required: "ກະລຸນາເລືອກແພັກເກັດ",

    member_commission_no_groups: "ບໍ່ມີກຸ່ມລາງວັນສຳລັບຫວຍນີ້",
    member_commission_sync_group: "ໃຊ້ຄ່າດຽວກັນທັງກຸ່ມ",
    member_commission_label: "ຄອມມິຊັ່ນ (%)",
    member_commission_validate_title: "ກວດສອບຂໍ້ມູນໃຫ້ຖືກຕ້ອງ",
    member_commission_exceed_prefix: "ຄອມມິຊັ່ນບໍ່ຄວນເກີນ",
    commission_step_reward_label: "ລາງວັນ",
    commission_step_reward_exceed_prefix: "ລາງວັນບໍ່ຄວນເກີນ",
    commission_step_no_items: "ກຸ່ມນີ້ຍັງບໍ່ມີລາຍການ",
    commission_step_reward_placeholder: "ໃສ່ລາງວັນ",
    commission_step_commission_placeholder: "ໃສ່ຄອມມິຊັ່ນ",
    commission_step_minbet_label: "ແທງຂັ້ນຕ່ຳ",
    commission_step_maxbet_label: "ແທງສູງສຸດ",
    commission_step_maxbetpermatch_label: "ສູງສຸດ/ແມັດ",
    commission_step_maxfight_label: "ສູ້ສູງສຸດ (%)",
    commission_step_maxfight_exceed_prefix: "ເປີເຊັນສູ້ບໍ່ຄວນເກີນ",
    member_commission_filter_label: "ກັ່ນຕອງຕາມຫວຍ:",
    commission_filter_by_package: "ແພັກເກັດ:",
    member_commission_group_thai: "ຄ່າຄອມມິຊັ່ນ ຫວຍໄທ",
    member_commission_group_hanoi: "ຄ່າຄອມມິຊັ່ນ ຫວຍຮານອຍ",
    member_commission_group_laos: "ຄ່າຄອມມິຊັ່ນ ຫວຍລາວ",
    member_commission_group_yeekee: "ຄ່າຄອມມິຊັ່ນ Yeekee",
    member_commission_group_yeekeevip: "ຄ່າຄອມມິຊັ່ນ Yeekee VIP",
    member_commission_group_yeekeevvip: "ຄ່າຄອມມິຊັ່ນ Yeekee VVIP",

    table_lotto_thai: "ຫວຍໄທ",
    table_lotto_laos: "ຫວຍລາວ",
    table_lotto_yeekee5: "Yeekee 5 ນາທີ",
    table_lotto_yeekee10: "Yeekee 10 ນາທີ",
    table_lotto_yeekee15: "Yeekee 15 ນາທີ",
    table_status_paid: "ຈ່າຍແລ້ວ",
    table_status_unpaid: "ຍັງບໍ່ຈ່າຍ",
    table_bet_first: "ລາງວັນທີໜຶ່ງ",
    table_bet_two_bot: "ສອງໂຕລ່າງ",
    table_bet_run_top: "ແລ່ນເທິງ",
    table_bet_two_top: "ສອງໂຕເທິງ",
    table_bet_three_front: "ສາມໂຕໜ້າ",
    table_bet_run_bot: "ແລ່ນລ່າງ",
    table_bet_three_tod: "ສາມໂຕໂຕດ",
    table_bet_three_top: "ສາມໂຕເທິງ",
    table_filter_by_lotto_type: "ຕາມປະເພດຫວຍ",
    table_filter_by_bet_type: "ປະເພດເລກ",
    table_search_button: "ຄົ້ນຫາ",
    common_export_excel: "ສົ່ງອອກ Excel",
    common_exporting: "ກຳລັງສົ່ງອອກ...",
    table_from_date: "ຈາກວັນທີ",
    table_to_date: "ເຖິງວັນທີ",
    table_search_username: "ຄົ້ນຫາຈາກຊື່ຜູ້ໃຊ້",
    table_filter_by_payment_status: "ຕາມສະຖານະການຈ່າຍ",
    table_search_phone: "ຄົ້ນຫາຈາກເບີໂທລະສັບ",
    table_search_account_number: "ຄົ້ນຫາຈາກເລກບັນຊີ",
    table_search_agent_name: "ຄົ້ນຫາຊື່ Agent",
    table_search_upline_name: "ຄົ້ນຫາຊື່ Upline",
    table_total: "ລວມ",

    orderhistory_page_title: "ປະຫວັດການສັ່ງຊື້",
    orderhistory_search_number_placeholder: "ຄົ້ນຫາເລກ",
    orderhistory_col_draw_id: "ລະຫັດງວດ",
    orderhistory_col_ticket_no: "ເລກທີ່ປີ້",
    orderhistory_col_transaction_time: "ເວລາເຮັດລາຍການ",
    orderhistory_col_turnover: "ຍອດໝູນວຽນ",
    orderhistory_col_net_amt: "ຍອດສຸດທິ",
    outstanding_detail_page_title: "ລາຍລະອຽດຍອດຄ້າງ",
    outstanding_detail_col_comm: "ຄອມມິຊັ່ນ",
    common_first: "ໜ້າທຳອິດ",
    common_last: "ໜ້າສຸດທ້າຍ",

    membertable_delete_confirm_title: "ຕ້ອງການລຶບສະມາຊິກ?",
    membertable_delete_confirm_text_prefix: "ກົດຢືນຢັນເພື່ອລຶບສະມາຊິກ",
    membertable_delete_confirm_text_suffix: "ແບບຖາວອນ",
    membertable_delete_success: "ລຶບຜູ້ໃຊ້ສຳເລັດ!",
    membertable_delete_error: "ເກີດຂໍ້ຜິດພາດໃນການລຶບຜູ້ໃຊ້",
    membertable_update_confirm_title: "ຕ້ອງການແກ້ໄຂລາຍລະອຽດສະມາຊິກ?",
    membertable_update_confirm_text_prefix: "ກົດຢືນຢັນເພື່ອບັນທຶກຂໍ້ມູນສະມາຊິກ",
    membertable_update_success: "ອັບເດດຂໍ້ມູນຜູ້ໃຊ້ສຳເລັດ!",
    membertable_update_error: "ເກີດຂໍ້ຜິດພາດໃນການອັບເດດຜູ້ໃຊ້",
    membertable_credit_invalid: "ກະລຸນາປ້ອນຈຳນວນເຄຣດິດທີ່ຖືກຕ້ອງ",
    membertable_add_credit_confirm_title: "ເພີ່ມເຄຣດິດ?",
    membertable_add_credit_confirm_text_prefix:
      "ກົດຢືນຢັນເພື່ອເພີ່ມເຄຣດິດຈຳນວນ",
    membertable_add_credit_confirm_text_middle: "ໃຫ້ກັບສະມາຊິກ",
    membertable_add_credit_insufficient: "ເຄຣດິດບໍ່ພຽງພໍ!",
    membertable_add_credit_success_prefix: "ເພີ່ມເຄຣດິດຈຳນວນ",
    membertable_add_credit_success_middle: "ໃຫ້ກັບສະມາຊິກ",
    membertable_add_credit_success_suffix: "ສຳເລັດ",
    membertable_add_credit_error: "ເກີດຂໍ້ຜິດພາດໃນການເພີ່ມເຄຣດິດ",
    membertable_change_password_title: "ປ່ຽນລະຫັດໃຫ້ກັບສະມາຊິກ?",
    membertable_change_password_text: "ກົດຢືນຢັນເພື່ອແກ້ໄຂລະຫັດໃຫ້ກັບສະມາຊິກ",
    membertable_change_password_error: "ເກີດຂໍ້ຜິດພາດໃນການປ່ຽນລະຫັດຜ່ານ",
    membertable_change_password_success: "ປ່ຽນລະຫັດຜ່ານສຳເລັດ",
    membertable_col_no: "ລຳດັບ",
    membertable_col_name: "ຊື່ ນາມສະກຸນ",
    membertable_col_phone: "ເບີໂທ",
    membertable_col_credit: "ເຄຣດິດ",
    membertable_col_manage: "ຈັດການ",
    membertopupreport_col_date: "ວັນທີ",
    membertopupreport_col_member: "ລູກຄ້າ",
    membertopupreport_col_approveby: "ອະນຸມັດໂດຍ",
    agenttopupreport_col_sender: "ຜູ້ຕື່ມເຄຣດິດ",
    membertable_tx_col_sender: "ສົ່ງ",
    membertable_tx_col_receiver: "ຮັບ",
    membertable_tx_col_amount: "ຈຳນວນ",
    membertable_tx_col_date: "ວັນທີ",
    membertable_tx_col_ip: "IP",
    membertable_tx_col_device: "ອຸປະກອນ",
    membertable_edit_title_prefix: "ແກ້ໄຂຂໍ້ມູນ",
    membertable_commission_note:
      "ໝາຍເຫດ: ຫາກແກ້ໄຂຄ່າຄອມມິຊັ່ນຂອງປະເພດຫວຍໃດ ກະລຸນາປ້ອນໃຫ້ຄົບທຸກຊ່ອງຂອງປະເພດນັ້ນ (ຊ່ອງທີ່ເວັ້ນວ່າງໄວ້ໃນປະເພດທີ່ແກ້ໄຂຈະຖືກບັນທຶກເປັນ 0)",
    membertable_save: "ບັນທຶກ",
    membertable_change_password_dialog_title_prefix:
      "ແກ້ໄຂລະຫັດຜ່ານ ສຳລັບ Username :",
    membertable_new_password_prompt: "ປ້ອນລະຫັດຜ່ານໃໝ່",
    membertable_credit_history_title: "ປະຫວັດເຄຣດິດ",
    membertable_add_credit_title_prefix: "ເພີ່ມເຄຣດິດ :",
    membertable_credit_amount_label: "ຈຳນວນເຄຣດິດ",
    membertable_credit_amount_placeholder: "ປ້ອນຈຳນວນເຄຣດິດ",

    subaccount_page_title: "ບັນຊີຜູ້ໃຊ້ຮ່ວມ",
    subaccount_add_button: "ເພີ່ມບັນຊີຜູ້ໃຊ້ຮ່ວມ",
    subaccount_permissions_fetch_error: "ເກີດຂໍ້ຜິດພາດໃນການໂຫຼດສິດການໃຊ້ງານ",
    subaccount_add_success: "ເພີ່ມບັນຊີຜູ້ໃຊ້ຮ່ວມໃໝ່ຮຽບຮ້ອຍແລ້ວ!",
    subaccount_duplicate_username: "ມີຊື່ຜູ້ໃຊ້ນີ້ໃນລະບົບແລ້ວ",
    subaccount_status_label: "ສະຖານະ",
    subaccount_status_active: "ເຮັດວຽກ",
    subaccount_status_inactive: "ຢຸດເຮັດວຽກ",
    subaccount_permissions_label: "ລາຍການສິດ",
    subaccount_select_all: "ເລືອກທັງໝົດ",
    subaccount_update_confirm_title: "ຕ້ອງການແກ້ໄຂລາຍລະອຽດ?",
    subaccount_update_confirm_text: "ກົດຢືນຢັນເພື່ອບັນທຶກຂໍ້ມູນ",
    subaccount_update_success: "ແກ້ໄຂຂໍ້ມູນບັນຊີຜູ້ໃຊ້ຮ່ວມສຳເລັດ!",
    subaccount_update_error: "ເກີດຂໍ້ຜິດພາດໃນການແກ້ໄຂຂໍ້ມູນ",
    subaccount_change_password_title: "ປ່ຽນລະຫັດຜ່ານບັນຊີຜູ້ໃຊ້ຮ່ວມ?",
    subaccount_change_password_text: "ກົດຢືນຢັນເພື່ອປ່ຽນລະຫັດຜ່ານ",
    subaccount_delete_confirm_title: "ຕ້ອງການລຶບບັນຊີຜູ້ໃຊ້ຮ່ວມ?",
    subaccount_delete_confirm_text_prefix: "ທ່ານຕ້ອງການລຶບ",
    subaccount_delete_success: "ລຶບບັນຊີຜູ້ໃຊ້ຮ່ວມຮຽບຮ້ອຍແລ້ວ",
    common_delete_error: "ເກີດຂໍ້ຜິດພາດບາງຢ່າງ!",
    subaccount_col_last_login_time: "ເວລາເປີດລ່າສຸດ",
    subaccount_col_last_login_ip: "IP ເປີດລ່າສຸດ",
    subaccount_edit_dialog_title: "ແກ້ໄຂບັນຊີຜູ້ໃຊ້ງານຮ່ວມ",

    agent_credit_amount_required: "ກະລຸນາປ້ອນຈຳນວນເຄຣດິດທີ່ຕ້ອງການຕື່ມ!",
    agent_credit_confirm_title: "ທ່ານແນ່ໃຈບໍ?",
    agent_credit_confirm_text_prefix: "ທ່ານຕ້ອງການຕື່ມເຄຣດິດຈຳນວນ",
    agent_credit_confirm_text_middle: "ໃຫ້ກັບ",
    agent_credit_insufficient: "ເຄຣດິດບໍ່ພຽງພໍ!",
    agent_credit_added_success: "ຕື່ມເຄຣດິດຮຽບຮ້ອຍແລ້ວ!",
    agent_no_downline: "ບໍ່ມີດາວໄລນ໌",
    agent_downline_list_title: "ລາຍຊື່ Downline",
    agent_col_agent_username: "ຊື່ຜູ້ໃຊ້ເອເຢນ",
    agent_col_position: "ຕຳແໜ່ງ",
    agent_col_upline: "ອັບໄລນ໌",
    agent_col_total_downline: "ດາວໄລນ໌ທັງໝົດ",
    agent_col_total_member: "ສະມາຊິກທັງໝົດ",
    agent_col_credit: "ເຄຣດິດ",
    agent_col_credit_history: "ປະຫວັດ",
    agent_col_status: "ສະຖານະ",
    agent_col_lock: "ລັອກ",
    agent_lock_confirm_title: "ຢືນຢັນການເຮັດລາຍການ",
    agent_lock_confirm_text_lock: "ທ່ານຕ້ອງການລັອກຜູ້ໃຊ້ນີ້ແທ້ບໍ?",
    agent_lock_confirm_text_unlock: "ທ່ານຕ້ອງການປົດລັອກຜູ້ໃຊ້ນີ້ແທ້ບໍ?",
    agent_lock_success: "ບັນທຶກຂໍ້ມູນສຳເລັດ",
    agent_lock_error: "ເກີດຂໍ້ຜິດພາດໃນການບັນທຶກຂໍ້ມູນ",
    agent_status_confirm_title: "ປ່ຽນສະຖານະຜູ້ໃຊ້",
    agent_status_inactive_warning_title: "ຄຳເຕືອນ",
    agent_status_inactive_warning_text:
      'ການຕັ້ງສະຖານະເປັນ "ບໍ່ໃຊ້ງານ" ຈະລ້າງຄ່າຄອມມິຊັ່ນ ແລະ ອັດຕາຈ່າຍຂອງຜູ້ໃຊ້ນີ້ ພ້ອມທັງ downline ທັງໝົດໃຫ້ເປັນ 0 ຖາວອນ ບໍ່ສາມາດຄືນຄ່າໄດ້ ຢືນຢັນບໍ່?',
    member_status_inactive_warning_title: "ຄຳເຕືອນ",
    member_status_inactive_warning_text:
      'ການຕັ້ງສະຖານະເປັນ "ບໍ່ໃຊ້ງານ" ຈະລ້າງຄ່າຄອມມິຊັ່ນຂອງສະມາຊິກຄົນນີ້ໃຫ້ເປັນ 0 ຖາວອນ ບໍ່ສາມາດຄືນຄ່າໄດ້ ຢືນຢັນບໍ່?',
    agent_col_add_remove_credit: "ເພີ່ມ/ລຶບເຄຣດິດ",
    agent_col_edit_data: "ແກ້ໄຂຂໍ້ມູນ",
    agent_person_unit: "ຄົນ",
    agent_add_credit_title: "ເພີ່ມເຄຣດິດ",
    agent_remove_credit_title: "ລຶບເຄຣດິດ",

    permission_category_member: "ຈັດການສະມາຊິກ",
    permission_category_sub_account: "ບັນຊີຜູ້ໃຊ້ງານຮ່ວມ",
    permission_category_company: "ຈັດການ Company",
    permission_category_senior_account: "ຈັດການ Senior",
    permission_category_master_account: "ຈັດການ Master",
    permission_category_agent: "ຈັດການເອເຢນ",
    permission_category_commission: "ຄ່າຄອມມິຊັ່ນ",
    permission_category_payrate: "ອັດຕາຈ່າຍ",
    permission_category_limited_number: "ເລກອັ້ນ",
    permission_category_fight_limit: "ຈຳກັດຍອດແທງ",
    permission_category_win_lose: "ລາຍງານແພ້ຊະນະ",
    permission_category_result: "ລາຍງານຜົນລາງວັນ",
    permission_category_lotto_wait: "ລາຍງານລໍຖ້າຜົນຫວຍ",
    permission_category_activity_log: "ປະຫວັດການໃຊ້ງານ",
    permission_category_login_log: "ປະຫວັດການເຂົ້າສູ່ລະບົບ",
    permission_category_bet: "ການແທງ",
    permission_category_billcut: "ຕັດບິນ",
    permission_category_hanoi: "ຜົນຮານອຍ",
    permission_category_memberlog: "ປະຫວັດການເຮັດລາຍການສະມາຊິກ",
    permission_category_order: "ອໍເດີ",
    permission_category_permission: "ສິດການໃຊ້ງານ",
    permission_category_transaction: "ລາຍການເດີນບັນຊີ",
    permission_category_waitresultuser: "ຍອດຄ້າງຜູ້ໃຊ້",
    permission_category_waitresulttype: "ຍອດຄ້າງຕາມປະເພດ",
    permission_category_lottobet: "ຍອດເດີມພັນ",
    permission_category_lotto_reward_type_group: "ຈັດການກຸ່ມປະເພດລາງວັນ",
    permission_category_lotto_type: "ຈັດການປະເພດຫວຍ",
    permission_category_schedule: "ຈັດການຕາຕະລາງເວລາ",
    permission_category_other: "ອື່ນໆ",

    permission_label_member_view: "ເບິ່ງຂໍ້ມູນສະມາຊິກ",
    permission_label_member_add: "ເພີ່ມສະມາຊິກ",
    permission_label_member_edit: "ແກ້ໄຂສະມາຊິກ",
    permission_label_member_delete: "ລຶບສະມາຊິກ",
    permission_label_sub_account_view: "ເບິ່ງຂໍ້ມູນບັນຊີຍ່ອຍ",
    permission_label_sub_account_add: "ເພີ່ມບັນຊີຍ່ອຍ",
    permission_label_sub_account_edit: "ແກ້ໄຂບັນຊີຍ່ອຍ",
    permission_label_sub_account_delete: "ລຶບບັນຊີຍ່ອຍ",
    permission_label_company_view: "ເບິ່ງຂໍ້ມູນບໍລິສັດ",
    permission_label_company_add: "ເພີ່ມບໍລິສັດ",
    permission_label_company_edit: "ແກ້ໄຂບໍລິສັດ",
    permission_label_company_delete: "ລຶບບໍລິສັດ",
    permission_label_senior_account_view: "ເບິ່ງຂໍ້ມູນບັນຊີ Senior",
    permission_label_senior_account_add: "ເພີ່ມບັນຊີ Senior",
    permission_label_senior_account_edit: "ແກ້ໄຂບັນຊີ Senior",
    permission_label_senior_account_delete: "ລຶບບັນຊີ Senior",
    permission_label_master_account_view: "ເບິ່ງຂໍ້ມູນບັນຊີ Master",
    permission_label_master_account_add: "ເພີ່ມບັນຊີ Master",
    permission_label_master_account_edit: "ແກ້ໄຂບັນຊີ Master",
    permission_label_master_account_delete: "ລຶບບັນຊີ Master",
    permission_label_agent_view: "ເບິ່ງຂໍ້ມູນເອເຢນ",
    permission_label_agent_add: "ເພີ່ມເອເຢນ",
    permission_label_agent_edit: "ແກ້ໄຂເອເຢນ",
    permission_label_agent_delete: "ລຶບເອເຢນ",
    permission_label_commission_view: "ເບິ່ງຂໍ້ມູນຄ່າຄອມມິຊັ່ນ",
    permission_label_commission_edit: "ແກ້ໄຂຄ່າຄອມມິຊັ່ນ",
    permission_label_payrate_view: "ເບິ່ງຂໍ້ມູນອັດຕາຈ່າຍ",
    permission_label_payrate_edit: "ແກ້ໄຂອັດຕາຈ່າຍ",
    permission_label_payrate_on_off: "ເປີດ/ປິດອັດຕາຈ່າຍ",
    permission_label_limited_number_view: "ເບິ່ງຂໍ້ມູນເລກອັ້ນ",
    permission_label_limited_number_add: "ເພີ່ມເລກອັ້ນ",
    permission_label_limited_number_edit: "ແກ້ໄຂເລກອັ້ນ",
    permission_label_limited_number_delete: "ລຶບເລກອັ້ນ",
    permission_label_fight_limit_view: "ເບິ່ງຂໍ້ມູນຈຳກັດຍອດແທງ",
    permission_label_fight_limit_edit: "ແກ້ໄຂຈຳກັດຍອດແທງ",
    permission_label_win_lose_view: "ເບິ່ງຂໍ້ມູນຜົນແພ້ຊະນະ",
    permission_label_result_view: "ເບິ່ງຂໍ້ມູນຜົນລາງວັນ",
    permission_label_lotto_wait_view: "ເບິ່ງຂໍ້ມູນລໍຖ້າຜົນຫວຍ",
    permission_label_activity_log_view: "ເບິ່ງຂໍ້ມູນປະຫວັດການໃຊ້ງານ",
    permission_label_login_log_view: "ເບິ່ງຂໍ້ມູນປະຫວັດການເຂົ້າສູ່ລະບົບ",
    permission_label_bet_view: "ເບິ່ງຂໍ້ມູນການແທງ",
    permission_label_bet_edit: "ແກ້ໄຂຂໍ້ມູນການແທງ",
    permission_label_billcut_view: "ເບິ່ງຂໍ້ມູນຕັດບິນ",
    permission_label_billcut_edit: "ແກ້ໄຂຂໍ້ມູນຕັດບິນ",
    permission_label_hanoi_edit: "ແກ້ໄຂຜົນຮານອຍ",
    permission_label_memberlog_view: "ເບິ່ງປະຫວັດການເຮັດລາຍການສະມາຊິກ",
    permission_label_memberlog_edit: "ແກ້ໄຂປະຫວັດການເຮັດລາຍການສະມາຊິກ",
    permission_label_order_view: "ເບິ່ງຂໍ້ມູນອໍເດີ",
    permission_label_order_edit: "ແກ້ໄຂຂໍ້ມູນອໍເດີ",
    permission_label_permission_view: "ເບິ່ງຂໍ້ມູນສິດການໃຊ້ງານ",
    permission_label_permission_edit: "ແກ້ໄຂສິດການໃຊ້ງານ",
    permission_label_transaction_view: "ເບິ່ງຂໍ້ມູນລາຍການເດີນບັນຊີ",
    permission_label_waitresultuser_view: "ຍອດຄ້າງຜູ້ໃຊ້",
    permission_label_waitresulttype_view: "ຍອດຄ້າງຕາມປະເພດ",
    permission_label_lottobet_view: "ຍອດເດີມພັນ",
    permission_label_lotto_reward_type_group_view: "ເບິ່ງກຸ່ມປະເພດລາງວັນ",
    permission_label_lotto_reward_type_group_add: "ເພີ່ມກຸ່ມປະເພດລາງວັນ",
    permission_label_lotto_reward_type_group_edit: "ແກ້ໄຂກຸ່ມປະເພດລາງວັນ",
    permission_label_lotto_reward_type_group_delete: "ລຶບກຸ່ມປະເພດລາງວັນ",
    permission_label_lotto_type_view: "ເບິ່ງປະເພດຫວຍ",
    permission_label_lotto_type_add: "ເພີ່ມປະເພດຫວຍ",
    permission_label_lotto_type_edit: "ແກ້ໄຂປະເພດຫວຍ",
    permission_label_lotto_type_delete: "ລຶບປະເພດຫວຍ",
    permission_label_schedule_view: "ເບິ່ງຕາຕະລາງເວລາ",
    permission_label_schedule_add: "ເພີ່ມຕາຕະລາງເວລາ",
    permission_label_schedule_edit: "ແກ້ໄຂຕາຕະລາງເວລາ",
    permission_label_schedule_delete: "ລຶບຕາຕະລາງເວລາ",

    agentadd_password_required: "ກະລຸນາປ້ອນລະຫັດຜ່ານ!",
    agentadd_package_required: "ກະລຸນາເປີດໃຊ້ງານຢ່າງໜ້ອຍ 1 ແພັກເກັດ!",
    agentadd_position_required: "ກະລຸນາເລືອກຕຳແໜ່ງ!",
    agentadd_generic_error: "ເກີດຂໍ້ຜິດພາດ ກະລຸນາໂຫຼດໃໝ່ແລ້ວລອງອີກຄັ້ງ!",
    agentadd_confirm_title: "ຕ້ອງການເພີ່ມ Agent",
    agentadd_confirm_text_prefix: "ເພີ່ມ Agent",
    agentadd_confirm_text_middle: "ລະດັບ",
    agentadd_success_prefix: "ເພີ່ມບັນຊີ",
    agentadd_success_middle: "ລະດັບ",
    agentadd_success_suffix: "ຮຽບຮ້ອຍ",
    agentadd_step_commission_reward: "ຄອມມິຊັ່ນ & ລາງວັນ",
    agentadd_step_bet_limit: "ວົງເງິນແທງ",
    agentadd_step_max_fight_percent: "ເປີເຊັນສູ້ສູງສຸດ",
    agentadd_step_fight_limit: "ຈຳກັດຍອດສູ້",
    agentadd_header_title: "Agent => ເພີ່ມເອເຢນໃໝ່",
    agentadd_name_label: "ຊື່",
    agentadd_tel_label: "ເບີໂທ",
    agentadd_email_label: "ອີເມວ",
    agentadd_status_label: "ສະຖານະ",
    agentadd_status_active: "ໃຊ້ງານ",
    agentadd_status_inactive: "ບໍ່ໃຊ້ງານ",
    agentadd_status_suspend: "ໂຈະ",
    agentadd_lock_label: "ລັອກ",
    agentadd_currency_label: "ສະກຸນເງິນ",
    agentedit_currency_cascade_hint:
      "ການປ່ຽນສະກຸນເງິນຈະມີຜົນກັບ downline ແລະສະມາຊິກທັງໝົດຂອງ agent ນີ້",
    agentadd_save_button: "ບັນທຶກຂໍ້ມູນ",

    agentedit_confirm_text: "ທ່ານຈະບັນທຶກຂໍ້ມູນນີ້ແທ້ບໍ?",
    agentedit_save_success: "ບັນທຶກຂໍ້ມູນສຳເລັດ",
    agentedit_save_error: "ເກີດຂໍ້ຜິດພາດໃນການບັນທຶກຂໍ້ມູນ",
    agentedit_header_title: "Agent => ແກ້ໄຂເອເຢນ",
    agentedit_downline_header: "ແກ້ໄຂດາວໄລນ໌",
    agentedit_downline_header_of: "ເຊິ່ງເປັນດາວໄລນ໌ຂອງ",

    commission_nav_commission: "ຄ່າຄອມມິຊັ່ນ",
    commission_nav_reward: "ລາງວັນ",
    commission_nav_max_bet: "ແທງສູງສຸດ",
    commission_nav_min_bet: "ແທງຕ່ຳສຸດ",
    commission_nav_max_bet_per_match: "ແທງສູງສຸດຕໍ່ເລກ",
    commission_filter_by_lotto_type: "ກັ່ນຕອງຕາມປະເພດຫວຍ:",
    commission_filter_by_downline_level: "ລະດັບດາວໄລນ໌:",
    commission_page_label: "ໜ້າ",
    commission_total_prefix: "ທັງໝົດ",
    commission_edit_dialog_title: "ປັບຄ່າຄອມມິຊັ່ນ",
    commission_max_label: "ສູງສຸດ",
    commission_no_data_yet: "ຍັງບໍ່ມີຂໍ້ມູນ",

    stake_label_first: "ລາງວັນທີ 1",
    stake_label_four_top: "4 ໂຕເທິງ",
    stake_label_four_tod: "4 ໂຕ Tod",
    stake_label_three_top: "3 ໂຕເທິງ",
    stake_label_three_front: "3 ໂຕໜ້າ",
    stake_label_three_bot: "3 ໂຕຫຼັງ",
    stake_label_three_tod: "3 ໂຕ Tod",
    stake_label_two_top: "2 ໂຕເທິງ",
    stake_label_two_bot: "2 ໂຕລ່າງ",
    stake_label_run_top: "ແລ່ນເທິງ",
    stake_label_run_bot: "ແລ່ນລ່າງ",
    stake_label_run_top_front: "ແລ່ນໜ້າ (ເທິງ)",
    stake_label_run_top_mid: "ແລ່ນກາງ (ເທິງ)",
    stake_label_run_top_end: "ແລ່ນທ້າຍ (ເທິງ)",
    stake_label_run_bot_front: "ແລ່ນໜ້າ (ລ່າງ)",
    stake_label_run_bot_mid: "ແລ່ນກາງ (ລ່າງ)",
    stake_label_run_bot_end: "ແລ່ນທ້າຍ (ລ່າງ)",
    stake_label_run_top_big: "ແລ່ນສູງ (ເທິງ)",
    stake_label_run_top_small: "ແລ່ນຕ່ຳ (ເທິງ)",
    stake_label_run_top_even: "ແລ່ນຄູ່ (ເທິງ)",
    stake_label_run_top_odd: "ແລ່ນຄີ່ (ເທິງ)",
    stake_label_run_bot_big: "ແລ່ນສູງ (ລ່າງ)",
    stake_label_run_bot_small: "ແລ່ນຕ່ຳ (ລ່າງ)",
    stake_label_run_bot_even: "ແລ່ນຄູ່ (ລ່າງ)",
    stake_label_run_bot_odd: "ແລ່ນຄີ່ (ລ່າງ)",
    stake_label_run_top_front_even: "ແລ່ນໜ້າຄູ່ (ເທິງ)",
    stake_label_run_top_front_odd: "ແລ່ນໜ້າຄີ່ (ເທິງ)",
    stake_label_run_top_front_small: "ແລ່ນໜ້າຕ່ຳ (ເທິງ)",
    stake_label_run_top_front_big: "ແລ່ນໜ້າສູງ (ເທິງ)",
    stake_label_run_top_mid_even: "ແລ່ນກາງຄູ່ (ເທິງ)",
    stake_label_run_top_mid_odd: "ແລ່ນກາງຄີ່ (ເທິງ)",
    stake_label_run_top_mid_small: "ແລ່ນກາງຕ່ຳ (ເທິງ)",
    stake_label_run_top_mid_big: "ແລ່ນກາງສູງ (ເທິງ)",
    stake_label_run_top_end_even: "ແລ່ນທ້າຍຄູ່ (ເທິງ)",
    stake_label_run_top_end_odd: "ແລ່ນທ້າຍຄີ່ (ເທິງ)",
    stake_label_run_top_end_small: "ແລ່ນທ້າຍຕ່ຳ (ເທິງ)",
    stake_label_run_top_end_big: "ແລ່ນທ້າຍສູງ (ເທິງ)",
    stake_label_run_bot_front_even: "ແລ່ນໜ້າຄູ່ (ລ່າງ)",
    stake_label_run_bot_front_odd: "ແລ່ນໜ້າຄີ່ (ລ່າງ)",
    stake_label_run_bot_front_small: "ແລ່ນໜ້າຕ່ຳ (ລ່າງ)",
    stake_label_run_bot_front_big: "ແລ່ນໜ້າສູງ (ລ່າງ)",
    stake_label_run_bot_mid_even: "ແລ່ນກາງຄູ່ (ລ່າງ)",
    stake_label_run_bot_mid_odd: "ແລ່ນກາງຄີ່ (ລ່າງ)",
    stake_label_run_bot_mid_small: "ແລ່ນກາງຕ່ຳ (ລ່າງ)",
    stake_label_run_bot_mid_big: "ແລ່ນກາງສູງ (ລ່າງ)",
    stake_label_run_bot_end_even: "ແລ່ນທ້າຍຄູ່ (ລ່າງ)",
    stake_label_run_bot_end_odd: "ແລ່ນທ້າຍຄີ່ (ລ່າງ)",
    stake_label_run_bot_end_small: "ແລ່ນທ້າຍຕ່ຳ (ລ່າງ)",
    stake_label_run_bot_end_big: "ແລ່ນທ້າຍສູງ (ລ່າງ)",
    stake_label_step_front_mid_end: "ເລກຊຸດ ໜ້າກາງຫຼັງ (ສູງ, ຕ່ຳ, ຄູ່, ຄີ່)",
    stake_label_step_mix: "ເລກຊຸດ ປະສົມ (ສູງຕ່ຳ + ຄູ່ຄີ່ + ຕັດເລກ)",
    step_pick_big: "ສູງ",
    step_pick_small: "ຕ່ຳ",
    step_pick_even: "ຄູ່",
    step_pick_odd: "ຄີ່",

    // Package labels — keyed by Package.code (see api/src/seeds/package.seed.ts)
    package1: "ບາດລະ 70",
    package2: "ບາດລະ 80",
    package3: "ບາດລະ 90",
    package4: "ບາດລະ 91",
    package5: "ບາດລະ 92",
    package6: "ບາດລະ 93",
    package7: "ບາດລະ 94",
    package8: "ບາດລະ 95",
    package9: "ບາດລະ 96",
    package10: "ບາດລະ 97",
    package11: "ບາດລະ 98",

    topup_status_pending: "ລໍຖ້າດຳເນີນການ",
    topup_status_approved: "ອະນຸມັດແລ້ວ",
    topup_status_rejected: "ປະຕິເສດແລ້ວ",
    topup_load_admin_error: "ເກີດຂໍ້ຜິດພາດໃນການໂຫຼດຂໍ້ມູນຜູ້ດູແລ",
    topup_admin_not_found: "ບໍ່ພົບຂໍ້ມູນຜູ້ດູແລລະບົບ",
    topup_confirm_approve_title: "ອະນຸມັດລາຍການຕື່ມເງິນນີ້?",
    topup_confirm_reject_title: "ປະຕິເສດລາຍການຕື່ມເງິນນີ້?",
    topup_already_processed: "ລາຍການນີ້ຖືກດຳເນີນການໄປແລ້ວ",
    topup_approve_success: "ອະນຸມັດລາຍການສຳເລັດ",
    topup_reject_success: "ປະຕິເສດລາຍການສຳເລັດ",
    topup_action_error: "ເກີດຂໍ້ຜິດພາດໃນການດຳເນີນການ",
    topup_col_evidence: "ຫຼັກຖານ",
    topup_col_processed_by: "ດຳເນີນການໂດຍ",
    topup_approve_button: "ອະນຸມັດ",
    topup_reject_button: "ປະຕິເສດ",

    withdraw_confirm_approve_title: "ອະນຸມັດລາຍການຖອນເງິນນີ້?",
    withdraw_confirm_reject_title: "ປະຕິເສດລາຍການຖອນເງິນນີ້?",
    withdraw_confirm_approve_text_prefix: "ຈຳນວນ",
    withdraw_confirm_approve_text_middle: "ຈະຖືກຫັກອອກຈາກຍອດເງິນຂອງສະມາຊິກ",
    withdraw_confirm_reject_text:
      "ກົດຢືນຢັນເພື່ອປະຕິເສດລາຍການຖອນເງິນຂອງສະມາຊິກ",
    withdraw_insufficient_credit: "ຍອດເງິນຂອງສະມາຊິກບໍ່ພຽງພໍສຳລັບການຖອນຄັ້ງນີ້",
    withdraw_col_balance: "ຍອດເງິນຄົງເຫຼືອ",
    withdraw_col_amount: "ຈຳນວນທີ່ຖອນ",

    lotto_service_day_of_month_prefix: "ວັນທີ",
    lotto_service_toggle_text_prefix: "ທ່ານກຳລັງເຮັດການ",
    lotto_service_action_open: "ເປີດ",
    lotto_service_action_close: "ປິດ",
    lotto_service_toggle_text_suffix: "ຂາຍຫວຍ",
    lotto_service_confirm_update: "ແມ່ນ, ອັບເດດ!",
    lotto_service_update_status_error: "ເກີດຂໍ້ຜິດພາດໃນການອັບເດດສະຖານະ",
    lotto_service_update_status_success: "ອັບເດດສະຖານະສຳເລັດແລ້ວ!",
    lotto_service_add_title: "ເພີ່ມປະເພດຫວຍ",
    lotto_service_name_label: "ຊື່ປະເພດຫວຍ",
    lotto_service_type_code_placeholder: "ລະຫັດປະເພດ (ເຊັ່ນ th_gov)",
    lotto_service_name_required: "ກະລຸນາລະບຸຊື່ປະເພດຫວຍ",
    lotto_service_type_code_required: "ກະລຸນາລະບຸລະຫັດປະເພດ",
    lotto_service_add_error: "ເພີ່ມປະເພດຫວຍບໍ່ສຳເລັດ",
    lotto_service_add_success: "ເພີ່ມປະເພດຫວຍສຳເລັດ",
    lotto_service_round_number_invalid: "ໝາຍເລກຮອບຕ້ອງເປັນຈຳນວນເຕັມບວກ",
    lotto_service_round_prefix: "ຮອບທີ",
    lotto_service_round_duplicate_suffix: "ຊ້ຳກັນ",
    lotto_service_round_needs_time_suffix: "ຕ້ອງມີຢ່າງໜ້ອຍ 1 ຊ່ວງເວລາ",
    lotto_service_round_time_required_suffix: "ກະລຸນາລະບຸເວລາເລີ່ມ-ສິ້ນສຸດ",
    lotto_service_round_days_of_month_required_suffix:
      "ກະລຸນາເລືອກວັນທີໃນເດືອນຢ່າງໜ້ອຍ 1 ວັນ",
    lotto_service_round_days_of_week_required_suffix:
      "ກະລຸນາເລືອກວັນໃນອາທິດຢ່າງໜ້ອຍ 1 ວັນ",
    lotto_service_edit_error: "ແກ້ໄຂປະເພດຫວຍບໍ່ສຳເລັດ",
    lotto_service_edit_success: "ແກ້ໄຂປະເພດຫວຍສຳເລັດ",
    lotto_service_col_type: "ປະເພດຫວຍ",
    lotto_service_col_rounds_time: "ຮອບ ແລະ ເວລາເປີດຂາຍ",
    lotto_service_col_reward_group: "ກຸ່ມລາງວັນ",
    lotto_service_col_sale_status: "ສະຖານະການຂາຍ",
    lotto_service_no_rounds_yet: "ຍັງບໍ່ໄດ້ຕັ້ງຄ່າຮອບ",
    lotto_service_round_label: "ຮອບ",
    lotto_service_manage_reward_group: "ຈັດການກຸ່ມລາງວັນ",
    lotto_service_no_reward_groups_yet: "ຍັງບໍ່ມີກຸ່ມລາງວັນສຳລັບຫວຍນີ້",
    lotto_service_status_open: "ເປີດຂາຍ",
    lotto_service_status_closed: "ປິດການຂາຍ",
    lotto_service_edit_title: "ແກ້ໄຂປະເພດຫວຍ",
    lotto_service_rounds_schedule_label: "ຮອບ ແລະ ຕາຕະລາງເວລາເປີດຂາຍ",
    lotto_service_add_round_button: "+ ເພີ່ມຮອບ",
    lotto_service_no_rounds_yet_short: "ຍັງບໍ່ມີຮອບ",
    lotto_service_delete_round_button: "ລຶບຮອບ",
    lotto_service_mode_days_of_month: "ວັນທີໃນເດືອນ",
    lotto_service_mode_days_of_week: "ວັນໃນອາທິດ",
    lotto_service_add_rule_button: "+ ເພີ່ມຊ່ວງເວລາ",

    limitnumber_incomplete_title: "ຂໍ້ມູນບໍ່ຄົບຖ້ວນ",
    limitnumber_add_confirm_prefix: "ທ່ານຈະເພີ່ມເລກ",
    limitnumber_add_confirm_lotto_prefix: "ຫວຍ",
    limitnumber_add_confirm_date_prefix: "ງວດວັນທີ",
    limitnumber_add_confirm_reward_prefix: "ລາງວັນ",
    limitnumber_add_success: "ເພີ່ມຂໍ້ມູນສຳເລັດ",
    limitnumber_add_error: "ເກີດຂໍ້ຜິດພາດໃນການເພີ່ມຂໍ້ມູນ",
    limitnumber_delete_confirm_text: "ທ່ານຕ້ອງການລຶບເລກອັ້ນນີ້ແທ້ບໍ",
    limitnumber_delete_success: "ລຶບຂໍ້ມູນສຳເລັດ",
    limitnumber_delete_error: "ເກີດຂໍ້ຜິດພາດໃນການລຶບຂໍ້ມູນ",
    limitnumber_edit_confirm_prefix: "ທ່ານຕ້ອງການແກ້ໄຂລາງວັນເລກທີ່ອັ້ນ",
    limitnumber_edit_confirm_middle: "ເປັນ",
    limitnumber_edit_success: "ແກ້ໄຂຂໍ້ມູນສຳເລັດ",
    limitnumber_edit_error: "ເກີດຂໍ້ຜິດພາດໃນການແກ້ໄຂຂໍ້ມູນ",
    limitnumber_period_label: "ງວດທີ",
    limitnumber_add_button: "ເພີ່ມເລກອັ້ນ",
    limitnumber_col_number: "ເລກທີ່ອັ້ນ",
    limitnumber_draw_label: "ງວດ",
    limitnumber_col_result_round: "ຮອບທີ່ອອກຜົນ",
    limitnumber_placeholder: "ເລກອັ້ນ",
    limitnumber_reward_label: "ລາງວັນເລກທີ່ອັ້ນ",
    limitnumber_edit_title: "ແກ້ໄຂເລດເລກອັ້ນ",

    lotto_type_th_gov: "ລັດຖະບານໄທ",
    lotto_type_laos_gov: "ລາວ",
    lotto_type_hanoi: "ຫວຍຮານອຍ",

    fightlimit_exceed_prefix: "ຮັບສູ້ສູງສຸດບໍ່ຄວນເກີນ",
    fightlimit_update_success: "ອັບເດດຮັບສູ້ສູງສຸດສຳເລັດ",
    fightlimit_update_error: "ເກີດຂໍ້ຜິດພາດໃນການອັບເດດຮັບສູ້ສູງສຸດ",
    fightlimit_col_game_type: "ຊະນິດເກມ",
    fightlimit_col_max: "ຮັບສູ້ສູງສຸດ",
    fightlimit_save_button: "ບັນທຶກເຂົ້າສູ່ລະບົບ",

    lotto_type_select_filter_first: "ກະລຸນາເລືອກປະເພດຫວຍທີ່ຕົວກອງກ່ອນສ້າງກຸ່ມ",
    lotto_type_create_group_title: "ສ້າງກຸ່ມໃໝ່",
    lotto_type_group_name_label: "ຊື່ກຸ່ມ",
    lotto_type_group_name_required: "ກະລຸນາລະບຸຊື່ກຸ່ມ",
    lotto_type_create_group_error: "ສ້າງກຸ່ມບໍ່ສຳເລັດ",
    lotto_type_create_group_success: "ສ້າງກຸ່ມສຳເລັດ",
    lotto_type_edit_group_title: "ແກ້ໄຂກຸ່ມ",
    lotto_type_select_type_required: "ກະລຸນາເລືອກປະເພດຫວຍ",
    lotto_type_edit_group_error: "ແກ້ໄຂກຸ່ມບໍ່ສຳເລັດ",
    lotto_type_edit_group_success: "ແກ້ໄຂກຸ່ມສຳເລັດ",
    lotto_type_delete_group_confirm_prefix: "ຕ້ອງການລຶບກຸ່ມ",
    lotto_type_confirm_yes_delete: "ແມ່ນ, ລຶບ",
    lotto_type_delete_group_error: "ລຶບກຸ່ມບໍ່ສຳເລັດ",
    lotto_type_delete_group_success: "ລຶບກຸ່ມສຳເລັດ",
    lotto_type_remove_item_error: "ນຳອອກບໍ່ສຳເລັດ",
    lotto_type_add_item_error: "ເພີ່ມບໍ່ສຳເລັດ",
    lotto_type_add_item_success: "ເພີ່ມລາຍການສຳເລັດ",
    lotto_type_create_group_button: "ສ້າງກຸ່ມ",
    lotto_type_no_groups_yet: "ຍັງບໍ່ມີກຸ່ມ",
    lotto_type_add_item_button: "ເພີ່ມລາຍການ",
    lotto_type_delete_group_button: "ລຶບກຸ່ມ",
    lotto_type_no_items_in_group: "ຍັງບໍ່ມີລາຍການໃນກຸ່ມນີ້",
    lotto_type_search_placeholder: "ຄົ້ນຫາຊື່/ລະຫັດ",
    lotto_type_no_items_available: "ບໍ່ມີລາຍການທີ່ສາມາດເພີ່ມໄດ້",
    lotto_type_used_in_group_prefix: "ໃຊ້ຢູ່ໃນກຸ່ມ",
    lotto_type_add_count_button: "ເພີ່ມ",

    common_hour: "ຊົ່ວໂມງ",
    common_minute: "ນາທີ",

    schedule_job_label_th_gov: "ຫວຍລັດຖະບານໄທ",
    schedule_job_label_lao_gov: "ຫວຍລັດຖະບານລາວ",
    schedule_job_label_yeekee5: "Yeekee 5",
    schedule_job_label_yeekee10: "Yeekee 10",
    schedule_job_label_yeekee15: "Yeekee 15",
    schedule_job_label_hanoi_round_1: "ຮານອຍ ຮອບ 1",
    schedule_job_label_hanoi_round_2: "ຮານອຍ ຮອບ 2",
    schedule_job_label_hanoi_round_3: "ຮານອຍ ຮອບ 3",
    schedule_job_label_hanoi_round_4: "ຮານອຍ ຮອບ 4",
    schedule_job_label_hanoi_round_5: "ຮານອຍ ຮອບ 5",
    schedule_job_label_hanoi_round_6: "ຮານອຍ ຮອບ 6",
    schedule_job_label_clear_activity_log: "ລ້າງປະຫວັດກິດຈະກຳ",
    schedule_type_minute_list: "ລາຍການນາທີ (ເຊັ່ນ ທຸກ 5 ນາທີ)",
    schedule_type_daily: "ລາຍວັນ (ເວລາດຽວຕໍ່ວັນ)",
    schedule_type_weekly_window: "ຊ່ວງເວລາລາຍອາທິດ",
    schedule_type_advanced: "ຂັ້ນສູງ (Cron Expression)",
    schedule_all_jobs_configured_prefix: "ມີຕາຕະລາງເວລາຄົບທັງ",
    schedule_all_jobs_configured_suffix: "ງານແລ້ວ",
    schedule_description_required: "ກະລຸນາລະບຸຄຳອະທິບາຍ",
    schedule_minute_required: "ກະລຸນາເລືອກຢ່າງໜ້ອຍ 1 ນາທີ",
    schedule_day_required: "ກະລຸນາເລືອກຢ່າງໜ້ອຍ 1 ວັນ",
    schedule_cron_required: "ກະລຸນາລະບຸ Cron Expression",
    schedule_create_error: "ສ້າງຕາຕະລາງເວລາບໍ່ສຳເລັດ",
    schedule_create_success: "ສ້າງຕາຕະລາງເວລາສຳເລັດ",
    schedule_edit_error: "ແກ້ໄຂຕາຕະລາງເວລາບໍ່ສຳເລັດ",
    schedule_edit_success: "ແກ້ໄຂຕາຕະລາງເວລາສຳເລັດ",
    schedule_toggle_status_error: "ປ່ຽນສະຖານະບໍ່ສຳເລັດ",
    schedule_add_button: "ເພີ່ມຕາຕະລາງເວລາ",
    schedule_col_description: "ຄຳອະທິບາຍ",
    schedule_col_format: "ຮູບແບບ",
    schedule_col_cron_example: "Cron (ຕົວຢ່າງທີ່ລັນ)",
    schedule_enabled_label: "ເປີດໃຊ້ງານ",
    schedule_no_schedules_yet: "ຍັງບໍ່ມີຕາຕະລາງເວລາ",
    schedule_edit_title: "ແກ້ໄຂຕາຕະລາງເວລາ",
    schedule_type_label: "ຮູບແບບເວລາ",
    schedule_minutes_label: "ນາທີທີ່ເຮັດວຽກ",
    schedule_hour_optional_label: "ຊົ່ວໂມງ (ເວັ້ນວ່າງ = ທຸກຊົ່ວໂມງ)",
    schedule_every_hour: "ທຸກຊົ່ວໂມງ",
    schedule_days_of_month_optional_label: "ວັນທີຂອງເດືອນ (ເວັ້ນວ່າງ = ທຸກວັນ)",
    schedule_minute_start_label: "ນາທີເລີ່ມ",
    schedule_minute_end_label: "ນາທີສິ້ນສຸດ",
    schedule_cron_placeholder: "ເຊັ່ນ 0,15,30,45 * * * *",

    common_view: "ເບິ່ງ",
    winlose_col_account: "ບັນຊີ",
    winlose_col_name: "ຊື່",
    winlose_col_view: "ໂຕ",
    winlose_col_bet_amount: "ຍອດການແທງ",
    winlose_col_payout: "ຈ່າຍອອກ",
    winlose_col_company: "ບໍລິສັດ",
    winlose_col_senior: "Senior",
    winlose_col_master: "Master",
    winlose_col_agent: "ເອເຢນ",
    winlose_col_win_loss: "ຊະນະ/ແພ້",

    wl_tooltip_stake: "ຍອດແທງ",
    wl_tooltip_position_pct: "ອັດຕາພາລະ (ລະດັບນີ້)",
    wl_tooltip_position_amount: "ພາລະ",
    wl_tooltip_fight_limit_credit: "ວົງເງິນຄ້ຳທີ່ເຫຼືອ",
    wl_tooltip_fight_limit_config: "ວົງເງິນຄ້ຳຖືສູ້",
    wl_upline_config_title: "ການຕັ້ງຄ່າສາຍເທິງຂອງສະມາຊິກ",
    wl_upline_config_tier: "ລະດັບ",
    wl_upline_config_name: "ຊື່",
    wl_upline_config_reward_rate: "ອັດຕາຈ່າຍ",
    wl_tooltip_excess: "ສ່ວນເກີນ (ສົ່ງຕໍ່ຊັ້ນເທິງ)",
    wl_tooltip_turnover_formula:
      "ເທີນໂອເວີ ແມ່ນຍອດທີ່ລະດັບນີ້ຮັບຜິດຊອບແທ້ຈິງ ໂດຍຈະເອົາຄ່າທີ່ນ້ອຍກວ່າລະຫວ່າງວົງເງິນຄ້ຳທີ່ເຫຼືອ ກັບຍອດພາລະທີ່ຄວນໄດ້ຮັບ (ລວມສ່ວນເກີນທີ່ສົ່ງມາຈາກລະດັບລຸ່ມ ຖ້າມີ) ເພື່ອບໍ່ໃຫ້ເກີນວົງເງິນທີ່ຕັ້ງໄວ້",
    wl_tooltip_commission_pct: "ອັດຕາຄອມມິຊັ່ນ",
    wl_tooltip_commission_base:
      "ພື້ນຖານຄິດໄລ່ຄອມ (stake − ເທີນໂອເວີຕົນເອງ/ຊັ້ນລຸ່ມ)",
    wl_tooltip_net_commission: "ຄອມມິຊັ່ນສຸດທິ",
    wl_tooltip_position_net_base_pct: "ອັດຕາພາລະສຸດທິ",
    wl_tooltip_position_net: "ພາລະສຸດທິ",
    wl_tooltip_net_amount_label: "ຍອດສຸດທິ",
    wl_tooltip_net_amount_formula: "ຍອດສຸດທິ = ພາລະສຸດທິ + ຄອມມິຊັ່ນສຸດທິ",
    wl_tooltip_win_formula: "ຜົນໄດ້ເສຍ = −(ເທີນໂອເວີ × ອັດຕາຈ່າຍ) + ຍອດສຸດທິ",
    wl_tooltip_pending_formula: "ຜົນໄດ້ເສຍ = ຍອດສຸດທິ (ຍັງບໍ່ອອກຜົນ/ແພ້)",
    wl_tooltip_member_turnover_formula: "ເທີນໂອເວີຂອງສະມາຊິກ = ຍອດແທງ",
    wl_tooltip_member_commission_amount:
      "ຄ່າຄອມມິຊັ່ນສະມາຊິກ (stake × ອັດຕາຄອມ)",
    wl_tooltip_member_net_formula: "ຍອດສຸດທິ = (stake × ອັດຕາຄອມ) − stake",
    wl_tooltip_win_amount: "ຍອດຖືກລາງວັນ",
    wl_tooltip_member_win_formula:
      "ຜົນໄດ້ເສຍ = ຍອດຖືກລາງວັນ − (ຍອດແທງ − ຄ່າຄອມມິຊັ່ນ)",
    wl_tooltip_member_pending_formula:
      "ຜົນໄດ້ເສຍ = ຍອດສຸດທິ (ຍັງບໍ່ອອກຜົນ/ແພ້)",
    wl_tooltip_title_turnover: "ທີ່ມາຂອງເທີນໂອເວີ",
    wl_tooltip_title_net_amt: "ທີ່ມາຂອງຍອດສຸດທິ",
    wl_tooltip_title_wl: "ທີ່ມາຂອງຜົນໄດ້ເສຍ",

    lottoresult_select_type_label: "ເລືອກປະເພດຫວຍ :",
    lottoresult_date_label: "ວັນທີອອກຜົນ :",
    lottoresult_select_round_label: "ເລືອກຮອບ :",
    lottoresult_add_button: "+ ເພີ່ມຜົນລາງວັນ",
    lottoresult_table_header: "ຜົນລາງວັນ",
    lottoresult_source_title: "ກວດສອບການເຊື່ອມຕໍ່ແຫຼ່ງຜົນຫວຍ",
    lottoresult_source_check_button: "ກວດສອບ",
    lottoresult_source_checking: "ກຳລັງກວດສອບ...",
    lottoresult_source_th_gov: "ຫວຍໄທ",
    lottoresult_source_laos_gov: "ຫວຍລາວ",
    lottoresult_source_hanoy: "ຫວຍຫວຽດ",
    lottoresult_source_connected: "ເຊື່ອມຕໍ່ໄດ້",
    lottoresult_source_failed: "ເຊື່ອມຕໍ່ບໍ່ໄດ້",
    lottoresult_source_latest: "ລ່າສຸດ",

    add_result_title: "ເພີ່ມຜົນລາງວັນ",
    add_result_lotto_type_label: "ປະເພດຫວຍ",
    add_result_date_label: "ວັນທີອອກຜົນ",
    add_result_round_label: "ຮອບທີ",
    add_result_top_label: "ເລກເທິງ",
    add_result_bottom_label: "ເລກລ່າງ",
    add_result_digits_suffix: "ຫຼັກ",
    add_result_top_placeholder_th_gov: "ເຊັ່ນ 506357",
    add_result_top_placeholder_other: "ເຊັ່ນ 12345",
    add_result_bottom_placeholder: "ເຊັ່ນ 31",
    add_result_top_required: "ກະລຸນາປ້ອນເລກເທິງ",
    add_result_bottom_required: "ກະລຸນາປ້ອນເລກລ່າງ",
    add_result_save_error: "ເກີດຂໍ້ຜິດພາດໃນການບັນທຶກຂໍ້ມູນ",
    add_result_save_success: "ບັນທຶກຜົນລາງວັນສຳເລັດ",
    add_result_save_button: "ບັນທຶກ",
    add_result_fetch_button: "ດຶງຜົນຈາກແຫຼ່ງຂໍ້ມູນ",
    add_result_fetching: "ກຳລັງດຶງຜົນ...",
    add_result_fetch_success: "ດຶງຜົນສຳເລັດ ກະລຸນາກວດສອບກ່ອນບັນທຶກ",

    common_order: "ອໍເດີ",
    common_number_label: "ເລກ",
    waitresult_fight_percent_label: "ສູ້ %",
    waitresult_commission_percent_label: "ຄອມມິຊັ່ນ (%)",
    waitresult_fight_limit_remaining_label: "Fight Limit ຄົງເຫຼືອ",
    waitresult_outstanding_label: "ຍອດຄ້າງ",
    waitresult_payout_rate_label: "ອັດຕາຈ່າຍ",
    waitresult_bet_wager_label: "ຍອດພະນັນ(ເດີມພັນ)",
    waitresult_bet_payout_label: "ຍອດພະນັນ(ການຈ່າຍ)",
    waitresult_amount_label: "ຍອດ",

    common_date_label: "ວັນທີ",
    common_search: "ຄົ້ນຫາ",
    lotto_type_yeekee: "Yeekee",
    lotto_type_yeekee_vip: "Yeekee VIP",
    lotto_type_yeekee_vvip: "Yeekee VVIP",
    bet_group_four_digit: "4ໂຕ",
    bet_group_three_digit: "3ໂຕ",
    bet_group_two_digit: "2ໂຕ",
    lottobet_market_label: "ຕະຫຼາດ",
    lottobet_draw_date_label: "ງວດປະຈຳວັນທີ",
    lottobet_bet_type_label: "ປະເພດທີ່ແທງ",
    loginlog_date_prefix: "ວັນທີ",
    loginlog_time_prefix: "ເວລາ",
    activitylog_col_entity: "ເອນທິຕີ",
    activitylog_col_entity_id: "ລະຫັດເອນທິຕີ",
    activitylog_col_action: "ການກະທຳ",
    activitylog_col_changed_fields: "ຟິວທີ່ປ່ຽນແປງ",
    activitylog_col_old_values: "ຄ່າເດີມ",
    activitylog_col_new_values: "ຄ່າໃໝ່",
    activitylog_col_user_id: "ລະຫັດຜູ້ໃຊ້",
  },
  zh: {
    navbar_welcome: "MESOK LOTERRY - 欢迎",
    navbar_home: "首页",
    navbar_logout: "退出登录",
    navbar_notice: "公告",
    navbar_notice_text: "系统公告：目前系统正在开发中。公告日期 12/11/2024",
    logout_confirm_title: "您确定要退出登录吗？",
    logout_confirm_yes: "是，退出登录",
    logout_confirm_no: "否",

    sidebar_close_menu: "关闭菜单",
    sidebar_open_menu: "打开菜单",
    menu_category_1: "1 菜单",
    menu_category_2: "2 限额设置",
    menu_category_3: "3 报表",
    menu_category_4: "4 投注金额",
    menu_category_5: "5 系统日志",
    menu_dashboard: "Dashboard",
    menu_manage_members: "会员管理",
    menu_manage_subaccount: "共用账户管理",
    menu_agent_system: "Agent 管理系统",
    menu_manage_senior: "Senior 管理",
    menu_manage_master: "Master 管理",
    menu_manage_agent: "Agent 管理",
    menu_manage_commission: "佣金管理",
    menu_manage_topup: "会员充值管理",
    menu_manage_withdraw: "会员提现管理",
    menu_lotto_onoff: "彩票开关",
    menu_limit_number: "限号",
    menu_max_fight: "最高受注设置",
    menu_commission_reward_setting: "佣金与奖金设置",
    menu_lotto_type_setting: "彩票类型设置",
    menu_schedule_setting: "排程设置",
    menu_winlose: "总输赢",
    menu_lotto_result: "开奖结果",
    menu_membertopup_report: "会员充值报表",
    menu_agenttopup_report: "代理充值报表",
    menu_bet_amount: "投注金额",
    menu_outstanding_user: "用户未结余额",
    menu_outstanding_type: "按类型未结余额",
    menu_login_history: "登录历史",
    menu_activity_logs: "Activity Logs",
    menu_settings: "设置",
    settings_tab_currency: "货币",
    settings_currency_col_code: "代码",
    settings_currency_col_name: "名称",
    settings_currency_col_symbol: "符号",
    settings_currency_col_status: "状态",

    login_title: "登录",
    login_subtitle: "请填写信息以登录管理系统",
    login_username_label: "用户名",
    login_password_label: "密码",
    login_hide_password: "隐藏密码",
    login_show_password: "显示密码",
    login_signing_in: "正在登录...",
    login_suspended_title: "账户已被暂停",
    login_suspended_text: "请联系主账户所有者",
    login_error_title: "登录失败",
    login_error_text: "用户名或密码不正确",
    common_ok: "确定",
    common_cancel: "取消",
    common_confirm: "确认",
    common_yes: "是",
    common_no: "否",
    common_error: "错误！",
    common_oops: "哎呀...",
    common_success_title: "成功！",
    common_generic_error: "发生错误！",
    common_no_permission: "没有访问权限",
    common_load_error: "加载数据时发生错误",
    common_add: "添加",
    common_optional: "选填",
    common_next: "下一步",
    common_previous: "返回",
    common_saving: "正在保存...",
    common_are_you_sure: "您确定吗？",
    common_page_previous: "上一页",
    common_items_unit: "项",
    common_edit: "编辑",
    common_all: "全部",
    common_no_data: "暂无数据",
    common_member: "会员",
    common_create: "创建",
    common_details: "详情",
    common_loading: "正在加载...",
    common_to: "至",
    common_delete: "删除",
    common_update: "更新",
    common_close: "关闭",
    common_per_page: "每页显示",

    weekday_sun: "星期日",
    weekday_mon: "星期一",
    weekday_tue: "星期二",
    weekday_wed: "星期三",
    weekday_thu: "星期四",
    weekday_fri: "星期五",
    weekday_sat: "星期六",

    dashboard_title: "账户",
    dashboard_login_id: "登录用户名",
    dashboard_credit: "可用额度",
    dashboard_member_count: "会员数量",
    dashboard_downline_count: "下线数量",
    dashboard_bet_amount: "投注金额",
    dashboard_loss_amount: "亏损金额",
    dashboard_profit: "利润",

    topup_credit_modal_title: "充值额度",
    topup_credit_modal_user_not_found: "未找到用户信息",
    topup_credit_modal_error: "充值额度时发生错误",
    topup_credit_modal_success: "充值额度成功",
    topup_credit_modal_history_title: "充值记录",
    topup_credit_modal_col_by: "操作人",

    member_page_title: "会员",
    member_add_button: "添加会员",
    member_add_dialog_title: "添加新会员",
    member_field_required: "必填",
    member_first_name: "名字",
    member_last_name: "姓氏",
    member_mobile_number: "手机号码",
    member_bank: "银行",
    member_bank_account_number: "银行账号",
    member_fill_all_fields: "请填写完整信息！",
    member_add_success: "成功添加新会员！",
    member_register_error: "注册用户时发生错误",
    member_package_label: "套餐",
    member_package_placeholder: "选择套餐",
    member_package_required: "请选择套餐",

    member_commission_no_groups: "此彩票没有奖金组",
    member_commission_sync_group: "整组使用相同数值",
    member_commission_label: "佣金 (%)",
    member_commission_validate_title: "请检查信息是否正确",
    member_commission_exceed_prefix: "佣金不应超过",
    commission_step_reward_label: "奖金",
    commission_step_reward_exceed_prefix: "奖金不应超过",
    commission_step_no_items: "该组尚无项目",
    commission_step_reward_placeholder: "输入奖金",
    commission_step_commission_placeholder: "输入佣金",
    commission_step_minbet_label: "最低投注",
    commission_step_maxbet_label: "最高投注",
    commission_step_maxbetpermatch_label: "每注最高",
    commission_step_maxfight_label: "最高受注 (%)",
    commission_step_maxfight_exceed_prefix: "受注百分比不应超过",
    member_commission_filter_label: "按彩票筛选：",
    commission_filter_by_package: "套餐：",
    member_commission_group_thai: "泰国彩票佣金",
    member_commission_group_hanoi: "河内彩票佣金",
    member_commission_group_laos: "老挝彩票佣金",
    member_commission_group_yeekee: "Yeekee 佣金",
    member_commission_group_yeekeevip: "Yeekee VIP 佣金",
    member_commission_group_yeekeevvip: "Yeekee VVIP 佣金",

    table_lotto_thai: "泰国彩票",
    table_lotto_laos: "老挝彩票",
    table_lotto_yeekee5: "Yeekee 5 分钟",
    table_lotto_yeekee10: "Yeekee 10 分钟",
    table_lotto_yeekee15: "Yeekee 15 分钟",
    table_status_paid: "已派彩",
    table_status_unpaid: "未派彩",
    table_bet_first: "头奖",
    table_bet_two_bot: "二字尾",
    table_bet_run_top: "上跑马",
    table_bet_two_top: "二字头",
    table_bet_three_front: "三字前",
    table_bet_run_bot: "下跑马",
    table_bet_three_tod: "三字组合",
    table_bet_three_top: "三字头",
    table_filter_by_lotto_type: "按彩票类型",
    table_filter_by_bet_type: "按号码类型",
    table_search_button: "查询",
    common_export_excel: "导出 Excel",
    common_exporting: "正在导出...",
    table_from_date: "起始日期",
    table_to_date: "结束日期",
    table_search_username: "按用户名搜索",
    table_filter_by_payment_status: "按派彩状态",
    table_search_phone: "按电话号码搜索",
    table_search_account_number: "按账号搜索",
    table_search_agent_name: "搜索 Agent 名称",
    table_search_upline_name: "搜索 Upline 名称",
    table_total: "合计",

    orderhistory_page_title: "购买记录",
    orderhistory_search_number_placeholder: "搜索号码",
    orderhistory_col_draw_id: "期号",
    orderhistory_col_ticket_no: "票号",
    orderhistory_col_transaction_time: "交易时间",
    orderhistory_col_turnover: "流水金额",
    orderhistory_col_net_amt: "净额",
    outstanding_detail_page_title: "未结明细",
    outstanding_detail_col_comm: "佣金",
    common_first: "首页",
    common_last: "末页",

    membertable_delete_confirm_title: "要删除该会员吗？",
    membertable_delete_confirm_text_prefix: "点击确认以删除会员",
    membertable_delete_confirm_text_suffix: "（永久删除）",
    membertable_delete_success: "删除用户成功！",
    membertable_delete_error: "删除用户时发生错误",
    membertable_update_confirm_title: "要修改该会员的详细信息吗？",
    membertable_update_confirm_text_prefix: "点击确认以保存会员信息",
    membertable_update_success: "更新用户信息成功！",
    membertable_update_error: "更新用户信息时发生错误",
    membertable_credit_invalid: "请输入正确的额度数量",
    membertable_add_credit_confirm_title: "增加额度？",
    membertable_add_credit_confirm_text_prefix: "点击确认以增加额度",
    membertable_add_credit_confirm_text_middle: "给会员",
    membertable_add_credit_insufficient: "额度不足！",
    membertable_add_credit_success_prefix: "增加额度",
    membertable_add_credit_success_middle: "给会员",
    membertable_add_credit_success_suffix: "成功",
    membertable_add_credit_error: "增加额度时发生错误",
    membertable_change_password_title: "要为该会员修改密码吗？",
    membertable_change_password_text: "点击确认以为会员修改密码",
    membertable_change_password_error: "修改密码时发生错误",
    membertable_change_password_success: "修改密码成功",
    membertable_col_no: "序号",
    membertable_col_name: "姓名",
    membertable_col_phone: "电话号码",
    membertable_col_credit: "额度",
    membertable_col_manage: "操作",
    membertopupreport_col_date: "日期",
    membertopupreport_col_member: "会员",
    membertopupreport_col_approveby: "审批人",
    agenttopupreport_col_sender: "充值人",
    membertable_tx_col_sender: "发送",
    membertable_tx_col_receiver: "接收",
    membertable_tx_col_amount: "金额",
    membertable_tx_col_date: "日期",
    membertable_tx_col_ip: "IP",
    membertable_tx_col_device: "设备",
    membertable_edit_title_prefix: "编辑信息",
    membertable_commission_note:
      "备注：若修改任一彩票类型的佣金，请填写该类型的所有栏位（编辑类型中留空的栏位将被记录为 0）",
    membertable_save: "保存",
    membertable_change_password_dialog_title_prefix: "修改密码 用户名：",
    membertable_new_password_prompt: "输入新密码",
    membertable_credit_history_title: "额度记录",
    membertable_add_credit_title_prefix: "增加额度：",
    membertable_credit_amount_label: "额度数量",
    membertable_credit_amount_placeholder: "输入额度数量",

    subaccount_page_title: "共用账户",
    subaccount_add_button: "添加共用账户",
    subaccount_permissions_fetch_error: "加载使用权限时发生错误",
    subaccount_add_success: "成功添加新共用账户！",
    subaccount_duplicate_username: "该用户名已存在于系统中",
    subaccount_status_label: "状态",
    subaccount_status_active: "运作中",
    subaccount_status_inactive: "已停止",
    subaccount_permissions_label: "权限列表",
    subaccount_select_all: "全选",
    subaccount_update_confirm_title: "要修改详细信息吗？",
    subaccount_update_confirm_text: "点击确认以保存信息",
    subaccount_update_success: "修改共用账户信息成功！",
    subaccount_update_error: "修改信息时发生错误",
    subaccount_change_password_title: "要修改共用账户密码吗？",
    subaccount_change_password_text: "点击确认以修改密码",
    subaccount_delete_confirm_title: "要删除该共用账户吗？",
    subaccount_delete_confirm_text_prefix: "您要删除",
    subaccount_delete_success: "共用账户删除成功",
    common_delete_error: "发生了一些错误！",
    subaccount_col_last_login_time: "最近登录时间",
    subaccount_col_last_login_ip: "最近登录 IP",
    subaccount_edit_dialog_title: "编辑共用账户",

    agent_credit_amount_required: "请输入要充值的额度数量！",
    agent_credit_confirm_title: "您确定吗？",
    agent_credit_confirm_text_prefix: "您要充值额度数量",
    agent_credit_confirm_text_middle: "给",
    agent_credit_insufficient: "额度不足！",
    agent_credit_added_success: "充值额度成功！",
    agent_no_downline: "没有下线",
    agent_downline_list_title: "Downline 列表",
    agent_col_agent_username: "代理用户名",
    agent_col_position: "职位",
    agent_col_upline: "上线",
    agent_col_total_downline: "下线总数",
    agent_col_total_member: "会员总数",
    agent_col_credit: "额度",
    agent_col_credit_history: "记录",
    agent_col_status: "状态",
    agent_col_lock: "锁定",
    agent_lock_confirm_title: "确认操作",
    agent_lock_confirm_text_lock: "您确定要锁定此用户吗？",
    agent_lock_confirm_text_unlock: "您确定要解锁此用户吗？",
    agent_lock_success: "保存信息成功",
    agent_lock_error: "保存信息时发生错误",
    agent_status_confirm_title: "更改用户状态",
    agent_status_inactive_warning_title: "警告",
    agent_status_inactive_warning_text:
      '将状态设置为"未使用"将永久清零该用户及其所有下线的佣金和派彩率，且无法恢复。是否继续？',
    member_status_inactive_warning_title: "警告",
    member_status_inactive_warning_text:
      '将状态设置为"未使用"将永久清零该会员的佣金，且无法恢复。是否继续？',
    agent_col_add_remove_credit: "增加/扣除额度",
    agent_col_edit_data: "编辑信息",
    agent_person_unit: "人",
    agent_add_credit_title: "增加额度",
    agent_remove_credit_title: "扣除额度",

    permission_category_member: "会员管理",
    permission_category_sub_account: "共用账户",
    permission_category_company: "Company 管理",
    permission_category_senior_account: "Senior 管理",
    permission_category_master_account: "Master 管理",
    permission_category_agent: "代理管理",
    permission_category_commission: "佣金",
    permission_category_payrate: "派彩率",
    permission_category_limited_number: "限号",
    permission_category_fight_limit: "投注限额",
    permission_category_win_lose: "输赢报表",
    permission_category_result: "开奖结果报表",
    permission_category_lotto_wait: "待开奖报表",
    permission_category_activity_log: "使用记录",
    permission_category_login_log: "登录记录",
    permission_category_bet: "投注",
    permission_category_billcut: "截单",
    permission_category_hanoi: "河内结果",
    permission_category_memberlog: "会员操作记录",
    permission_category_order: "订单",
    permission_category_permission: "使用权限",
    permission_category_transaction: "账户流水",
    permission_category_waitresultuser: "用户未结余额",
    permission_category_waitresulttype: "按类型未结余额",
    permission_category_lottobet: "投注金额",
    permission_category_lotto_reward_type_group: "奖金类型组管理",
    permission_category_lotto_type: "彩票类型管理",
    permission_category_schedule: "排程管理",
    permission_category_other: "其他",

    permission_label_member_view: "查看会员信息",
    permission_label_member_add: "添加会员",
    permission_label_member_edit: "编辑会员",
    permission_label_member_delete: "删除会员",
    permission_label_sub_account_view: "查看子账户信息",
    permission_label_sub_account_add: "添加子账户",
    permission_label_sub_account_edit: "编辑子账户",
    permission_label_sub_account_delete: "删除子账户",
    permission_label_company_view: "查看公司信息",
    permission_label_company_add: "添加公司",
    permission_label_company_edit: "编辑公司",
    permission_label_company_delete: "删除公司",
    permission_label_senior_account_view: "查看 Senior 账户信息",
    permission_label_senior_account_add: "添加 Senior 账户",
    permission_label_senior_account_edit: "编辑 Senior 账户",
    permission_label_senior_account_delete: "删除 Senior 账户",
    permission_label_master_account_view: "查看 Master 账户信息",
    permission_label_master_account_add: "添加 Master 账户",
    permission_label_master_account_edit: "编辑 Master 账户",
    permission_label_master_account_delete: "删除 Master 账户",
    permission_label_agent_view: "查看代理信息",
    permission_label_agent_add: "添加代理",
    permission_label_agent_edit: "编辑代理",
    permission_label_agent_delete: "删除代理",
    permission_label_commission_view: "查看佣金信息",
    permission_label_commission_edit: "编辑佣金",
    permission_label_payrate_view: "查看派彩率信息",
    permission_label_payrate_edit: "编辑派彩率",
    permission_label_payrate_on_off: "开启/关闭派彩率",
    permission_label_limited_number_view: "查看限号信息",
    permission_label_limited_number_add: "添加限号",
    permission_label_limited_number_edit: "编辑限号",
    permission_label_limited_number_delete: "删除限号",
    permission_label_fight_limit_view: "查看投注限额信息",
    permission_label_fight_limit_edit: "编辑投注限额",
    permission_label_win_lose_view: "查看输赢结果信息",
    permission_label_result_view: "查看开奖结果信息",
    permission_label_lotto_wait_view: "查看待开奖信息",
    permission_label_activity_log_view: "查看使用记录信息",
    permission_label_login_log_view: "查看登录记录信息",
    permission_label_bet_view: "查看投注信息",
    permission_label_bet_edit: "编辑投注信息",
    permission_label_billcut_view: "查看截单信息",
    permission_label_billcut_edit: "编辑截单信息",
    permission_label_hanoi_edit: "编辑河内结果",
    permission_label_memberlog_view: "查看会员操作记录",
    permission_label_memberlog_edit: "编辑会员操作记录",
    permission_label_order_view: "查看订单信息",
    permission_label_order_edit: "编辑订单信息",
    permission_label_permission_view: "查看使用权限信息",
    permission_label_permission_edit: "编辑使用权限",
    permission_label_transaction_view: "查看账户流水信息",
    permission_label_waitresultuser_view: "用户未结余额",
    permission_label_waitresulttype_view: "按类型未结余额",
    permission_label_lottobet_view: "投注金额",
    permission_label_lotto_reward_type_group_view: "查看奖金类型组",
    permission_label_lotto_reward_type_group_add: "添加奖金类型组",
    permission_label_lotto_reward_type_group_edit: "编辑奖金类型组",
    permission_label_lotto_reward_type_group_delete: "删除奖金类型组",
    permission_label_lotto_type_view: "查看彩票类型",
    permission_label_lotto_type_add: "添加彩票类型",
    permission_label_lotto_type_edit: "编辑彩票类型",
    permission_label_lotto_type_delete: "删除彩票类型",
    permission_label_schedule_view: "查看排程",
    permission_label_schedule_add: "添加排程",
    permission_label_schedule_edit: "编辑排程",
    permission_label_schedule_delete: "删除排程",

    agentadd_password_required: "请输入密码！",
    agentadd_package_required: "请至少启用 1 个套餐！",
    agentadd_position_required: "请选择职位！",
    agentadd_generic_error: "发生错误，请刷新后重试！",
    agentadd_confirm_title: "要添加 Agent",
    agentadd_confirm_text_prefix: "添加 Agent",
    agentadd_confirm_text_middle: "级别",
    agentadd_success_prefix: "添加账户",
    agentadd_success_middle: "级别",
    agentadd_success_suffix: "成功",
    agentadd_step_commission_reward: "佣金与奖金",
    agentadd_step_bet_limit: "投注限额",
    agentadd_step_max_fight_percent: "最高受注百分比",
    agentadd_step_fight_limit: "受注限额",
    agentadd_header_title: "Agent => 添加新代理",
    agentadd_name_label: "姓名",
    agentadd_tel_label: "电话",
    agentadd_email_label: "邮箱",
    agentadd_status_label: "状态",
    agentadd_status_active: "启用",
    agentadd_status_inactive: "停用",
    agentadd_status_suspend: "暂停",
    agentadd_lock_label: "锁定",
    agentadd_currency_label: "货币",
    agentedit_currency_cascade_hint:
      "更改货币将同时应用于该代理的所有下线代理和会员",
    agentadd_save_button: "保存信息",

    agentedit_confirm_text: "您确定要保存此信息吗？",
    agentedit_save_success: "保存信息成功",
    agentedit_save_error: "保存信息时发生错误",
    agentedit_header_title: "Agent => 编辑代理",
    agentedit_downline_header: "编辑下线",
    agentedit_downline_header_of: "属于以下代理的下线",

    commission_nav_commission: "佣金",
    commission_nav_reward: "奖金",
    commission_nav_max_bet: "最高投注",
    commission_nav_min_bet: "最低投注",
    commission_nav_max_bet_per_match: "每注最高投注",
    commission_filter_by_lotto_type: "按彩票类型筛选：",
    commission_filter_by_downline_level: "下线级别：",
    commission_page_label: "页",
    commission_total_prefix: "共",
    commission_edit_dialog_title: "调整佣金",
    commission_max_label: "最高",
    commission_no_data_yet: "暂无数据",

    stake_label_first: "第1奖",
    stake_label_four_top: "4字上",
    stake_label_four_tod: "4字 Tod",
    stake_label_three_top: "3字上",
    stake_label_three_front: "3字前",
    stake_label_three_bot: "3字后",
    stake_label_three_tod: "3字 Tod",
    stake_label_two_top: "2字上",
    stake_label_two_bot: "2字下",
    stake_label_run_top: "跑马（上）",
    stake_label_run_bot: "跑马（下）",
    stake_label_run_top_front: "前跑马（上）",
    stake_label_run_top_mid: "中跑马（上）",
    stake_label_run_top_end: "尾跑马（上）",
    stake_label_run_bot_front: "前跑马（下）",
    stake_label_run_bot_mid: "中跑马（下）",
    stake_label_run_bot_end: "尾跑马（下）",
    stake_label_run_top_big: "高跑马（上）",
    stake_label_run_top_small: "低跑马（上）",
    stake_label_run_top_even: "双跑马（上）",
    stake_label_run_top_odd: "单跑马（上）",
    stake_label_run_bot_big: "高跑马（下）",
    stake_label_run_bot_small: "低跑马（下）",
    stake_label_run_bot_even: "双跑马（下）",
    stake_label_run_bot_odd: "单跑马（下）",
    stake_label_run_top_front_even: "前双跑马（上）",
    stake_label_run_top_front_odd: "前单跑马（上）",
    stake_label_run_top_front_small: "前低跑马（上）",
    stake_label_run_top_front_big: "前高跑马（上）",
    stake_label_run_top_mid_even: "中双跑马（上）",
    stake_label_run_top_mid_odd: "中单跑马（上）",
    stake_label_run_top_mid_small: "中低跑马（上）",
    stake_label_run_top_mid_big: "中高跑马（上）",
    stake_label_run_top_end_even: "尾双跑马（上）",
    stake_label_run_top_end_odd: "尾单跑马（上）",
    stake_label_run_top_end_small: "尾低跑马（上）",
    stake_label_run_top_end_big: "尾高跑马（上）",
    stake_label_run_bot_front_even: "前双跑马（下）",
    stake_label_run_bot_front_odd: "前单跑马（下）",
    stake_label_run_bot_front_small: "前低跑马（下）",
    stake_label_run_bot_front_big: "前高跑马（下）",
    stake_label_run_bot_mid_even: "中双跑马（下）",
    stake_label_run_bot_mid_odd: "中单跑马（下）",
    stake_label_run_bot_mid_small: "中低跑马（下）",
    stake_label_run_bot_mid_big: "中高跑马（下）",
    stake_label_run_bot_end_even: "尾双跑马（下）",
    stake_label_run_bot_end_odd: "尾单跑马（下）",
    stake_label_run_bot_end_small: "尾低跑马（下）",
    stake_label_run_bot_end_big: "尾高跑马（下）",
    stake_label_step_front_mid_end: "号码组 前中后（高、低、双、单）",
    stake_label_step_mix: "号码组 混合（高低 + 双单 + 切号）",
    step_pick_big: "大",
    step_pick_small: "小",
    step_pick_even: "双",
    step_pick_odd: "单",

    // Package labels — keyed by Package.code (see api/src/seeds/package.seed.ts)
    package1: "70倍",
    package2: "80倍",
    package3: "90倍",
    package4: "91倍",
    package5: "92倍",
    package6: "93倍",
    package7: "94倍",
    package8: "95倍",
    package9: "96倍",
    package10: "97倍",
    package11: "98倍",

    topup_status_pending: "待处理",
    topup_status_approved: "已批准",
    topup_status_rejected: "已拒绝",
    topup_load_admin_error: "加载管理员信息时发生错误",
    topup_admin_not_found: "未找到系统管理员信息",
    topup_confirm_approve_title: "批准此充值申请？",
    topup_confirm_reject_title: "拒绝此充值申请？",
    topup_already_processed: "该申请已被处理",
    topup_approve_success: "批准成功",
    topup_reject_success: "拒绝成功",
    topup_action_error: "操作时发生错误",
    topup_col_evidence: "凭证",
    topup_col_processed_by: "处理人",
    topup_approve_button: "批准",
    topup_reject_button: "拒绝",

    withdraw_confirm_approve_title: "批准此提现申请？",
    withdraw_confirm_reject_title: "拒绝此提现申请？",
    withdraw_confirm_approve_text_prefix: "金额",
    withdraw_confirm_approve_text_middle: "将从会员余额中扣除",
    withdraw_confirm_reject_text: "点击确认以拒绝会员的提现申请",
    withdraw_insufficient_credit: "会员余额不足，无法进行此次提现",
    withdraw_col_balance: "剩余余额",
    withdraw_col_amount: "提现金额",

    lotto_service_day_of_month_prefix: "日期",
    lotto_service_toggle_text_prefix: "您正在",
    lotto_service_action_open: "开启",
    lotto_service_action_close: "关闭",
    lotto_service_toggle_text_suffix: "彩票销售",
    lotto_service_confirm_update: "是，更新！",
    lotto_service_update_status_error: "更新状态时发生错误",
    lotto_service_update_status_success: "更新状态成功！",
    lotto_service_add_title: "添加彩票类型",
    lotto_service_name_label: "彩票类型名称",
    lotto_service_type_code_placeholder: "类型代码（如 th_gov）",
    lotto_service_name_required: "请填写彩票类型名称",
    lotto_service_type_code_required: "请填写类型代码",
    lotto_service_add_error: "添加彩票类型失败",
    lotto_service_add_success: "添加彩票类型成功",
    lotto_service_round_number_invalid: "轮次编号必须为正整数",
    lotto_service_round_prefix: "第",
    lotto_service_round_duplicate_suffix: "轮重复",
    lotto_service_round_needs_time_suffix: "至少需要 1 个时间段",
    lotto_service_round_time_required_suffix: "请填写开始-结束时间",
    lotto_service_round_days_of_month_required_suffix:
      "请至少选择月份中的 1 天",
    lotto_service_round_days_of_week_required_suffix: "请至少选择星期中的 1 天",
    lotto_service_edit_error: "编辑彩票类型失败",
    lotto_service_edit_success: "编辑彩票类型成功",
    lotto_service_col_type: "彩票类型",
    lotto_service_col_rounds_time: "轮次与开售时间",
    lotto_service_col_reward_group: "奖金组",
    lotto_service_col_sale_status: "销售状态",
    lotto_service_no_rounds_yet: "尚未设置轮次",
    lotto_service_round_label: "轮次",
    lotto_service_manage_reward_group: "管理奖金组",
    lotto_service_no_reward_groups_yet: "该彩票尚无奖金组",
    lotto_service_status_open: "开售",
    lotto_service_status_closed: "停售",
    lotto_service_edit_title: "编辑彩票类型",
    lotto_service_rounds_schedule_label: "轮次与开售时间表",
    lotto_service_add_round_button: "+ 添加轮次",
    lotto_service_no_rounds_yet_short: "尚无轮次",
    lotto_service_delete_round_button: "删除轮次",
    lotto_service_mode_days_of_month: "每月日期",
    lotto_service_mode_days_of_week: "每周日期",
    lotto_service_add_rule_button: "+ 添加时间段",

    limitnumber_incomplete_title: "信息不完整",
    limitnumber_add_confirm_prefix: "您将添加号码",
    limitnumber_add_confirm_lotto_prefix: "彩票",
    limitnumber_add_confirm_date_prefix: "期号日期",
    limitnumber_add_confirm_reward_prefix: "奖金",
    limitnumber_add_success: "添加信息成功",
    limitnumber_add_error: "添加信息时发生错误",
    limitnumber_delete_confirm_text: "您确定要删除此限号吗",
    limitnumber_delete_success: "删除信息成功",
    limitnumber_delete_error: "删除信息时发生错误",
    limitnumber_edit_confirm_prefix: "您要将限号",
    limitnumber_edit_confirm_middle: "的奖金改为",
    limitnumber_edit_success: "编辑信息成功",
    limitnumber_edit_error: "编辑信息时发生错误",
    limitnumber_period_label: "第",
    limitnumber_add_button: "添加限号",
    limitnumber_col_number: "限号号码",
    limitnumber_draw_label: "期",
    limitnumber_col_result_round: "开奖轮次",
    limitnumber_placeholder: "限号",
    limitnumber_reward_label: "限号奖金",
    limitnumber_edit_title: "编辑限号费率",

    lotto_type_th_gov: "泰国政府彩票",
    lotto_type_laos_gov: "老挝",
    lotto_type_hanoi: "河内彩票",

    fightlimit_exceed_prefix: "最高受注不应超过",
    fightlimit_update_success: "更新最高受注成功",
    fightlimit_update_error: "更新最高受注时发生错误",
    fightlimit_col_game_type: "游戏类型",
    fightlimit_col_max: "最高受注",
    fightlimit_save_button: "保存至系统",

    lotto_type_select_filter_first: "请先在筛选器中选择彩票类型再创建组",
    lotto_type_create_group_title: "创建新组",
    lotto_type_group_name_label: "组名称",
    lotto_type_group_name_required: "请填写组名称",
    lotto_type_create_group_error: "创建组失败",
    lotto_type_create_group_success: "创建组成功",
    lotto_type_edit_group_title: "编辑组",
    lotto_type_select_type_required: "请选择彩票类型",
    lotto_type_edit_group_error: "编辑组失败",
    lotto_type_edit_group_success: "编辑组成功",
    lotto_type_delete_group_confirm_prefix: "要删除组",
    lotto_type_confirm_yes_delete: "是，删除",
    lotto_type_delete_group_error: "删除组失败",
    lotto_type_delete_group_success: "删除组成功",
    lotto_type_remove_item_error: "移除失败",
    lotto_type_add_item_error: "添加失败",
    lotto_type_add_item_success: "添加项目成功",
    lotto_type_create_group_button: "创建组",
    lotto_type_no_groups_yet: "尚无分组",
    lotto_type_add_item_button: "添加项目",
    lotto_type_delete_group_button: "删除组",
    lotto_type_no_items_in_group: "该组尚无项目",
    lotto_type_search_placeholder: "搜索名称/代码",
    lotto_type_no_items_available: "没有可添加的项目",
    lotto_type_used_in_group_prefix: "已用于组",
    lotto_type_add_count_button: "添加",

    common_hour: "小时",
    common_minute: "分钟",

    schedule_job_label_th_gov: "泰国政府彩票",
    schedule_job_label_lao_gov: "老挝政府彩票",
    schedule_job_label_yeekee5: "Yeekee 5",
    schedule_job_label_yeekee10: "Yeekee 10",
    schedule_job_label_yeekee15: "Yeekee 15",
    schedule_job_label_hanoi_round_1: "河内 第1轮",
    schedule_job_label_hanoi_round_2: "河内 第2轮",
    schedule_job_label_hanoi_round_3: "河内 第3轮",
    schedule_job_label_hanoi_round_4: "河内 第4轮",
    schedule_job_label_hanoi_round_5: "河内 第5轮",
    schedule_job_label_hanoi_round_6: "河内 第6轮",
    schedule_job_label_clear_activity_log: "清除活动记录",
    schedule_type_minute_list: "分钟列表（如每 5 分钟）",
    schedule_type_daily: "每日（每天固定时间）",
    schedule_type_weekly_window: "每周时间段",
    schedule_type_advanced: "高级（Cron 表达式）",
    schedule_all_jobs_configured_prefix: "已完整配置全部",
    schedule_all_jobs_configured_suffix: "项任务的排程",
    schedule_description_required: "请填写说明",
    schedule_minute_required: "请至少选择 1 分钟",
    schedule_day_required: "请至少选择 1 天",
    schedule_cron_required: "请填写 Cron 表达式",
    schedule_create_error: "创建排程失败",
    schedule_create_success: "创建排程成功",
    schedule_edit_error: "编辑排程失败",
    schedule_edit_success: "编辑排程成功",
    schedule_toggle_status_error: "更改状态失败",
    schedule_add_button: "添加排程",
    schedule_col_description: "说明",
    schedule_col_format: "格式",
    schedule_col_cron_example: "Cron（运行示例）",
    schedule_enabled_label: "启用",
    schedule_no_schedules_yet: "尚无排程",
    schedule_edit_title: "编辑排程",
    schedule_type_label: "时间格式",
    schedule_minutes_label: "执行分钟",
    schedule_hour_optional_label: "小时（留空 = 每小时）",
    schedule_every_hour: "每小时",
    schedule_days_of_month_optional_label: "每月日期（留空 = 每天）",
    schedule_minute_start_label: "起始分钟",
    schedule_minute_end_label: "结束分钟",
    schedule_cron_placeholder: "如 0,15,30,45 * * * *",

    common_view: "查看",
    winlose_col_account: "账户",
    winlose_col_name: "姓名",
    winlose_col_view: "字",
    winlose_col_bet_amount: "投注金额",
    winlose_col_payout: "派彩支出",
    winlose_col_company: "公司",
    winlose_col_senior: "Senior",
    winlose_col_master: "Master",
    winlose_col_agent: "代理",
    winlose_col_win_loss: "输赢",

    wl_tooltip_stake: "投注金额",
    wl_tooltip_position_pct: "承担比例（本级）",
    wl_tooltip_position_amount: "承担金额",
    wl_tooltip_fight_limit_credit: "剩余受注限额",
    wl_tooltip_fight_limit_config: "受注限额设置",
    wl_upline_config_title: "会员上线设置",
    wl_upline_config_tier: "级别",
    wl_upline_config_name: "姓名",
    wl_upline_config_reward_rate: "派彩率",
    wl_tooltip_excess: "超出部分（转交上级）",
    wl_tooltip_turnover_formula:
      "流水是本级实际承担的金额，取剩余受注限额与应承担金额（含下级转来的超出部分，如有）两者中较小的值，以确保不超过设定的限额",
    wl_tooltip_commission_pct: "佣金比例",
    wl_tooltip_commission_base: "佣金计算基础（stake − 自身/下级流水）",
    wl_tooltip_net_commission: "净佣金",
    wl_tooltip_position_net_base_pct: "净承担比例",
    wl_tooltip_position_net: "净承担金额",
    wl_tooltip_net_amount_label: "净额",
    wl_tooltip_net_amount_formula: "净额 = 净承担金额 + 净佣金",
    wl_tooltip_win_formula: "输赢 = −(流水 × 派彩率) + 净额",
    wl_tooltip_pending_formula: "输赢 = 净额（尚未开奖/未输）",
    wl_tooltip_member_turnover_formula: "会员流水 = 投注金额",
    wl_tooltip_member_commission_amount: "会员佣金（stake × 佣金比例）",
    wl_tooltip_member_net_formula: "净额 = (stake × 佣金比例) − stake",
    wl_tooltip_win_amount: "中奖金额",
    wl_tooltip_member_win_formula: "输赢 = 中奖金额 − (投注金额 − 佣金)",
    wl_tooltip_member_pending_formula: "输赢 = 净额（尚未开奖/未输）",
    wl_tooltip_title_turnover: "流水来源",
    wl_tooltip_title_net_amt: "净额来源",
    wl_tooltip_title_wl: "输赢来源",

    lottoresult_select_type_label: "选择彩票类型：",
    lottoresult_date_label: "开奖日期：",
    lottoresult_select_round_label: "选择轮次：",
    lottoresult_add_button: "+ 添加开奖结果",
    lottoresult_table_header: "开奖结果",
    lottoresult_source_title: "开奖来源连接检查",
    lottoresult_source_check_button: "检查",
    lottoresult_source_checking: "检查中...",
    lottoresult_source_th_gov: "泰国彩票",
    lottoresult_source_laos_gov: "老挝彩票",
    lottoresult_source_hanoy: "越南彩票",
    lottoresult_source_connected: "已连接",
    lottoresult_source_failed: "连接失败",
    lottoresult_source_latest: "最新",

    add_result_title: "添加开奖结果",
    add_result_lotto_type_label: "彩票类型",
    add_result_date_label: "开奖日期",
    add_result_round_label: "第",
    add_result_top_label: "上区号码",
    add_result_bottom_label: "下区号码",
    add_result_digits_suffix: "位",
    add_result_top_placeholder_th_gov: "如 506357",
    add_result_top_placeholder_other: "如 12345",
    add_result_bottom_placeholder: "如 31",
    add_result_top_required: "请填写上区号码",
    add_result_bottom_required: "请填写下区号码",
    add_result_save_error: "保存信息时发生错误",
    add_result_save_success: "保存开奖结果成功",
    add_result_save_button: "保存",
    add_result_fetch_button: "从来源获取",
    add_result_fetching: "获取中...",
    add_result_fetch_success: "已获取结果，请检查后再保存",

    common_order: "订单",
    common_number_label: "号码",
    waitresult_fight_percent_label: "受注 %",
    waitresult_commission_percent_label: "佣金 (%)",
    waitresult_fight_limit_remaining_label: "剩余受注限额",
    waitresult_outstanding_label: "未结金额",
    waitresult_payout_rate_label: "派彩率",
    waitresult_bet_wager_label: "投注金额（下注）",
    waitresult_bet_payout_label: "投注金额（派彩）",
    waitresult_amount_label: "金额",

    common_date_label: "日期",
    common_search: "搜索",
    lotto_type_yeekee: "Yeekee",
    lotto_type_yeekee_vip: "Yeekee VIP",
    lotto_type_yeekee_vvip: "Yeekee VVIP",
    bet_group_four_digit: "4字",
    bet_group_three_digit: "3字",
    bet_group_two_digit: "2字",
    lottobet_market_label: "市场",
    lottobet_draw_date_label: "期号日期",
    lottobet_bet_type_label: "投注类型",
    loginlog_date_prefix: "日期",
    loginlog_time_prefix: "时间",
    activitylog_col_entity: "实体",
    activitylog_col_entity_id: "实体编号",
    activitylog_col_action: "操作",
    activitylog_col_changed_fields: "变更字段",
    activitylog_col_old_values: "旧值",
    activitylog_col_new_values: "新值",
    activitylog_col_user_id: "用户编号",
  },
  vi: {
    navbar_welcome: "MESOK LOTERRY - Chào mừng",
    navbar_home: "Trang chủ",
    navbar_logout: "Đăng xuất",
    navbar_notice: "Thông báo",
    navbar_notice_text:
      "Thông báo hệ thống: hệ thống hiện đang trong quá trình phát triển. Thông báo ngày 12/11/2024",
    logout_confirm_title: "Bạn có muốn đăng xuất không?",
    logout_confirm_yes: "Có, đăng xuất",
    logout_confirm_no: "Không",

    sidebar_close_menu: "Đóng menu",
    sidebar_open_menu: "Mở menu",
    menu_category_1: "1 Menu",
    menu_category_2: "2 Cài đặt giới hạn",
    menu_category_3: "3 Báo cáo",
    menu_category_4: "4 Số tiền cược",
    menu_category_5: "5 Nhật ký hệ thống",
    menu_dashboard: "Dashboard",
    menu_manage_members: "Quản lý hội viên",
    menu_manage_subaccount: "Quản lý tài khoản dùng chung",
    menu_agent_system: "Hệ thống quản lý Agent",
    menu_manage_senior: "Quản lý Senior",
    menu_manage_master: "Quản lý Master",
    menu_manage_agent: "Quản lý Agent",
    menu_manage_commission: "Quản lý hoa hồng",
    menu_manage_topup: "Quản lý nạp tiền hội viên",
    menu_manage_withdraw: "Quản lý rút tiền hội viên",
    menu_lotto_onoff: "Bật/tắt xổ số",
    menu_limit_number: "Số bị hạn chế",
    menu_max_fight: "Cài đặt hạn mức ôm tối đa",
    menu_commission_reward_setting: "Cài đặt hoa hồng & giải thưởng",
    menu_lotto_type_setting: "Cài đặt loại xổ số",
    menu_schedule_setting: "Cài đặt lịch trình",
    menu_winlose: "Tổng thắng thua",
    menu_lotto_result: "Kết quả xổ số",
    menu_membertopup_report: "Báo cáo nạp tiền hội viên",
    menu_agenttopup_report: "Báo cáo nạp tiền đại lý",
    menu_bet_amount: "Số tiền cược",
    menu_outstanding_user: "Số dư chưa xử lý theo người dùng",
    menu_outstanding_type: "Số dư chưa xử lý theo loại",
    menu_login_history: "Lịch sử đăng nhập",
    menu_activity_logs: "Activity Logs",
    menu_settings: "Cài đặt",
    settings_tab_currency: "Tiền tệ",
    settings_currency_col_code: "Mã",
    settings_currency_col_name: "Tên",
    settings_currency_col_symbol: "Ký hiệu",
    settings_currency_col_status: "Trạng thái",

    login_title: "Đăng nhập",
    login_subtitle: "Vui lòng nhập thông tin để đăng nhập hệ thống quản lý",
    login_username_label: "Tên đăng nhập",
    login_password_label: "Mật khẩu",
    login_hide_password: "Ẩn mật khẩu",
    login_show_password: "Hiện mật khẩu",
    login_signing_in: "Đang đăng nhập...",
    login_suspended_title: "Tài khoản đã bị tạm ngưng",
    login_suspended_text: "Vui lòng liên hệ chủ tài khoản chính",
    login_error_title: "Đăng nhập thất bại",
    login_error_text: "Tên đăng nhập hoặc mật khẩu không đúng",
    common_ok: "Đồng ý",
    common_cancel: "Hủy",
    common_confirm: "Xác nhận",
    common_yes: "Có",
    common_no: "Không",
    common_error: "Lỗi!",
    common_oops: "Ối...",
    common_success_title: "Thành công!",
    common_generic_error: "Đã xảy ra lỗi!",
    common_no_permission: "Không có quyền truy cập",
    common_load_error: "Đã xảy ra lỗi khi tải dữ liệu",
    common_add: "Thêm",
    common_optional: "Không bắt buộc",
    common_next: "Tiếp theo",
    common_previous: "Quay lại",
    common_saving: "Đang lưu...",
    common_are_you_sure: "Bạn có chắc chắn không?",
    common_page_previous: "Trước",
    common_items_unit: "mục",
    common_edit: "Chỉnh sửa",
    common_all: "Tất cả",
    common_no_data: "Không có dữ liệu",
    common_member: "Hội viên",
    common_create: "Tạo",
    common_details: "Chi tiết",
    common_loading: "Đang tải...",
    common_to: "đến",
    common_delete: "Xóa",
    common_update: "Cập nhật",
    common_close: "Đóng",
    common_per_page: "Hiển thị mỗi trang",

    weekday_sun: "Chủ nhật",
    weekday_mon: "Thứ hai",
    weekday_tue: "Thứ ba",
    weekday_wed: "Thứ tư",
    weekday_thu: "Thứ năm",
    weekday_fri: "Thứ sáu",
    weekday_sat: "Thứ bảy",

    dashboard_title: "Tài khoản",
    dashboard_login_id: "Tên đăng nhập",
    dashboard_credit: "Tín dụng hiện có",
    dashboard_member_count: "Số lượng hội viên",
    dashboard_downline_count: "Số lượng tuyến dưới",
    dashboard_bet_amount: "Số tiền cược",
    dashboard_loss_amount: "Số tiền thua",
    dashboard_profit: "Lợi nhuận",

    topup_credit_modal_title: "Nạp tín dụng",
    topup_credit_modal_user_not_found: "Không tìm thấy thông tin người dùng",
    topup_credit_modal_error: "Đã xảy ra lỗi khi nạp tín dụng",
    topup_credit_modal_success: "Nạp tín dụng thành công",
    topup_credit_modal_history_title: "Lịch sử nạp tín dụng",
    topup_credit_modal_col_by: "Bởi",

    member_page_title: "Hội viên",
    member_add_button: "Thêm hội viên",
    member_add_dialog_title: "Thêm hội viên mới",
    member_field_required: "Bắt buộc",
    member_first_name: "Tên",
    member_last_name: "Họ",
    member_mobile_number: "Số điện thoại di động",
    member_bank: "Ngân hàng",
    member_bank_account_number: "Số tài khoản ngân hàng",
    member_fill_all_fields: "Vui lòng nhập đầy đủ thông tin!",
    member_add_success: "Thêm hội viên mới thành công!",
    member_register_error: "Đã xảy ra lỗi khi đăng ký người dùng",
    member_package_label: "Gói",
    member_package_placeholder: "Chọn gói",
    member_package_required: "Vui lòng chọn gói",

    member_commission_no_groups: "Không có nhóm giải thưởng cho loại xổ số này",
    member_commission_sync_group: "Dùng cùng một giá trị cho cả nhóm",
    member_commission_label: "Hoa hồng (%)",
    member_commission_validate_title:
      "Vui lòng kiểm tra thông tin cho chính xác",
    member_commission_exceed_prefix: "Hoa hồng không nên vượt quá",
    commission_step_reward_label: "Giải thưởng",
    commission_step_reward_exceed_prefix: "Giải thưởng không nên vượt quá",
    commission_step_no_items: "Nhóm này chưa có mục nào",
    commission_step_reward_placeholder: "Nhập giải thưởng",
    commission_step_commission_placeholder: "Nhập hoa hồng",
    commission_step_minbet_label: "Cược tối thiểu",
    commission_step_maxbet_label: "Cược tối đa",
    commission_step_maxbetpermatch_label: "Tối đa/số",
    commission_step_maxfight_label: "Ôm tối đa (%)",
    commission_step_maxfight_exceed_prefix: "Phần trăm ôm không nên vượt quá",
    member_commission_filter_label: "Lọc theo xổ số:",
    commission_filter_by_package: "Gói:",
    member_commission_group_thai: "Hoa hồng xổ số Thái",
    member_commission_group_hanoi: "Hoa hồng xổ số Hà Nội",
    member_commission_group_laos: "Hoa hồng xổ số Lào",
    member_commission_group_yeekee: "Hoa hồng Yeekee",
    member_commission_group_yeekeevip: "Hoa hồng Yeekee VIP",
    member_commission_group_yeekeevvip: "Hoa hồng Yeekee VVIP",

    table_lotto_thai: "Xổ số Thái",
    table_lotto_laos: "Xổ số Lào",
    table_lotto_yeekee5: "Yeekee 5 phút",
    table_lotto_yeekee10: "Yeekee 10 phút",
    table_lotto_yeekee15: "Yeekee 15 phút",
    table_status_paid: "Đã thanh toán",
    table_status_unpaid: "Chưa thanh toán",
    table_bet_first: "Giải nhất",
    table_bet_two_bot: "Hai số dưới",
    table_bet_run_top: "Chạy trên",
    table_bet_two_top: "Hai số trên",
    table_bet_three_front: "Ba số trước",
    table_bet_run_bot: "Chạy dưới",
    table_bet_three_tod: "Ba số đảo",
    table_bet_three_top: "Ba số trên",
    table_filter_by_lotto_type: "Theo loại xổ số",
    table_filter_by_bet_type: "Theo loại số",
    table_search_button: "Tìm kiếm",
    common_export_excel: "Xuất Excel",
    common_exporting: "Đang xuất...",
    table_from_date: "Từ ngày",
    table_to_date: "Đến ngày",
    table_search_username: "Tìm theo tên đăng nhập",
    table_filter_by_payment_status: "Theo trạng thái thanh toán",
    table_search_phone: "Tìm theo số điện thoại",
    table_search_account_number: "Tìm theo số tài khoản",
    table_search_agent_name: "Tìm tên Agent",
    table_search_upline_name: "Tìm tên Upline",
    table_total: "Tổng",

    orderhistory_page_title: "Lịch sử đặt cược",
    orderhistory_search_number_placeholder: "Tìm số",
    orderhistory_col_draw_id: "Mã kỳ",
    orderhistory_col_ticket_no: "Số vé",
    orderhistory_col_transaction_time: "Thời gian giao dịch",
    orderhistory_col_turnover: "Doanh số",
    orderhistory_col_net_amt: "Số tiền ròng",
    outstanding_detail_page_title: "Chi tiết dư nợ",
    outstanding_detail_col_comm: "Hoa hồng",
    common_first: "Đầu tiên",
    common_last: "Cuối cùng",

    membertable_delete_confirm_title: "Bạn muốn xóa hội viên này?",
    membertable_delete_confirm_text_prefix: "Nhấn xác nhận để xóa hội viên",
    membertable_delete_confirm_text_suffix: "vĩnh viễn",
    membertable_delete_success: "Xóa người dùng thành công!",
    membertable_delete_error: "Đã xảy ra lỗi khi xóa người dùng",
    membertable_update_confirm_title:
      "Bạn muốn chỉnh sửa thông tin hội viên này?",
    membertable_update_confirm_text_prefix:
      "Nhấn xác nhận để lưu thông tin hội viên",
    membertable_update_success: "Cập nhật thông tin người dùng thành công!",
    membertable_update_error: "Đã xảy ra lỗi khi cập nhật người dùng",
    membertable_credit_invalid: "Vui lòng nhập số tín dụng hợp lệ",
    membertable_add_credit_confirm_title: "Thêm tín dụng?",
    membertable_add_credit_confirm_text_prefix:
      "Nhấn xác nhận để thêm tín dụng số lượng",
    membertable_add_credit_confirm_text_middle: "cho hội viên",
    membertable_add_credit_insufficient: "Tín dụng không đủ!",
    membertable_add_credit_success_prefix: "Thêm tín dụng số lượng",
    membertable_add_credit_success_middle: "cho hội viên",
    membertable_add_credit_success_suffix: "thành công",
    membertable_add_credit_error: "Đã xảy ra lỗi khi thêm tín dụng",
    membertable_change_password_title: "Đổi mật khẩu cho hội viên?",
    membertable_change_password_text:
      "Nhấn xác nhận để đổi mật khẩu cho hội viên",
    membertable_change_password_error: "Đã xảy ra lỗi khi đổi mật khẩu",
    membertable_change_password_success: "Đổi mật khẩu thành công",
    membertable_col_no: "STT",
    membertable_col_name: "Họ và tên",
    membertable_col_phone: "Số điện thoại",
    membertable_col_credit: "Tín dụng",
    membertable_col_manage: "Quản lý",
    membertopupreport_col_date: "Ngày",
    membertopupreport_col_member: "Hội viên",
    membertopupreport_col_approveby: "Phê duyệt bởi",
    agenttopupreport_col_sender: "Người nạp tín dụng",
    membertable_tx_col_sender: "Gửi",
    membertable_tx_col_receiver: "Nhận",
    membertable_tx_col_amount: "Số lượng",
    membertable_tx_col_date: "Ngày",
    membertable_tx_col_ip: "IP",
    membertable_tx_col_device: "Thiết bị",
    membertable_edit_title_prefix: "Chỉnh sửa thông tin",
    membertable_commission_note:
      "Lưu ý: Nếu chỉnh sửa hoa hồng của loại xổ số nào, vui lòng nhập đầy đủ tất cả các ô của loại đó (ô để trống trong loại đang chỉnh sửa sẽ được lưu thành 0)",
    membertable_save: "Lưu",
    membertable_change_password_dialog_title_prefix:
      "Đổi mật khẩu cho Username :",
    membertable_new_password_prompt: "Nhập mật khẩu mới",
    membertable_credit_history_title: "Lịch sử tín dụng",
    membertable_add_credit_title_prefix: "Thêm tín dụng :",
    membertable_credit_amount_label: "Số lượng tín dụng",
    membertable_credit_amount_placeholder: "Nhập số lượng tín dụng",

    subaccount_page_title: "Tài khoản dùng chung",
    subaccount_add_button: "Thêm tài khoản dùng chung",
    subaccount_permissions_fetch_error: "Đã xảy ra lỗi khi tải quyền sử dụng",
    subaccount_add_success: "Thêm tài khoản dùng chung mới thành công!",
    subaccount_duplicate_username:
      "Tên đăng nhập này đã tồn tại trong hệ thống",
    subaccount_status_label: "Trạng thái",
    subaccount_status_active: "Hoạt động",
    subaccount_status_inactive: "Ngừng hoạt động",
    subaccount_permissions_label: "Danh sách quyền",
    subaccount_select_all: "Chọn tất cả",
    subaccount_update_confirm_title: "Bạn muốn chỉnh sửa thông tin chi tiết?",
    subaccount_update_confirm_text: "Nhấn xác nhận để lưu thông tin",
    subaccount_update_success:
      "Chỉnh sửa thông tin tài khoản dùng chung thành công!",
    subaccount_update_error: "Đã xảy ra lỗi khi chỉnh sửa thông tin",
    subaccount_change_password_title: "Đổi mật khẩu tài khoản dùng chung?",
    subaccount_change_password_text: "Nhấn xác nhận để đổi mật khẩu",
    subaccount_delete_confirm_title: "Bạn muốn xóa tài khoản dùng chung này?",
    subaccount_delete_confirm_text_prefix: "Bạn muốn xóa",
    subaccount_delete_success: "Xóa tài khoản dùng chung thành công",
    common_delete_error: "Đã xảy ra lỗi nào đó!",
    subaccount_col_last_login_time: "Thời gian đăng nhập gần nhất",
    subaccount_col_last_login_ip: "IP đăng nhập gần nhất",
    subaccount_edit_dialog_title: "Chỉnh sửa tài khoản dùng chung",

    agent_credit_amount_required: "Vui lòng nhập số lượng tín dụng muốn nạp!",
    agent_credit_confirm_title: "Bạn có chắc chắn không?",
    agent_credit_confirm_text_prefix: "Bạn muốn nạp tín dụng số lượng",
    agent_credit_confirm_text_middle: "cho",
    agent_credit_insufficient: "Tín dụng không đủ!",
    agent_credit_added_success: "Nạp tín dụng thành công!",
    agent_no_downline: "Không có tuyến dưới",
    agent_downline_list_title: "Danh sách Downline",
    agent_col_agent_username: "Tên đăng nhập đại lý",
    agent_col_position: "Vị trí",
    agent_col_upline: "Tuyến trên",
    agent_col_total_downline: "Tổng tuyến dưới",
    agent_col_total_member: "Tổng hội viên",
    agent_col_credit: "Tín dụng",
    agent_col_credit_history: "Lịch sử",
    agent_col_status: "Trạng thái",
    agent_col_lock: "Khóa",
    agent_lock_confirm_title: "Xác nhận thao tác",
    agent_lock_confirm_text_lock: "Bạn có muốn khóa người dùng này không?",
    agent_lock_confirm_text_unlock: "Bạn có muốn mở khóa người dùng này không?",
    agent_lock_success: "Lưu thông tin thành công",
    agent_lock_error: "Đã xảy ra lỗi khi lưu thông tin",
    agent_status_confirm_title: "Thay đổi trạng thái người dùng",
    agent_status_inactive_warning_title: "Cảnh báo",
    agent_status_inactive_warning_text:
      'Đặt trạng thái thành "Không hoạt động" sẽ đặt vĩnh viễn hoa hồng và tỷ lệ trả thưởng của người dùng này cùng toàn bộ downline về 0, không thể hoàn tác. Tiếp tục?',
    member_status_inactive_warning_title: "Cảnh báo",
    member_status_inactive_warning_text:
      'Đặt trạng thái thành "Không hoạt động" sẽ đặt vĩnh viễn hoa hồng của thành viên này về 0, không thể hoàn tác. Tiếp tục?',
    agent_col_add_remove_credit: "Thêm/Bớt tín dụng",
    agent_col_edit_data: "Chỉnh sửa thông tin",
    agent_person_unit: "người",
    agent_add_credit_title: "Thêm tín dụng",
    agent_remove_credit_title: "Bớt tín dụng",

    permission_category_member: "Quản lý hội viên",
    permission_category_sub_account: "Tài khoản dùng chung",
    permission_category_company: "Quản lý Company",
    permission_category_senior_account: "Quản lý Senior",
    permission_category_master_account: "Quản lý Master",
    permission_category_agent: "Quản lý đại lý",
    permission_category_commission: "Hoa hồng",
    permission_category_payrate: "Tỷ lệ trả thưởng",
    permission_category_limited_number: "Số bị hạn chế",
    permission_category_fight_limit: "Hạn mức cược",
    permission_category_win_lose: "Báo cáo thắng thua",
    permission_category_result: "Báo cáo kết quả giải thưởng",
    permission_category_lotto_wait: "Báo cáo chờ kết quả xổ số",
    permission_category_activity_log: "Lịch sử sử dụng",
    permission_category_login_log: "Lịch sử đăng nhập",
    permission_category_bet: "Đặt cược",
    permission_category_billcut: "Cắt cược",
    permission_category_hanoi: "Kết quả Hà Nội",
    permission_category_memberlog: "Lịch sử giao dịch hội viên",
    permission_category_order: "Đơn hàng",
    permission_category_permission: "Quyền sử dụng",
    permission_category_transaction: "Giao dịch tài khoản",
    permission_category_waitresultuser: "Số dư chưa xử lý theo người dùng",
    permission_category_waitresulttype: "Số dư chưa xử lý theo loại",
    permission_category_lottobet: "Số tiền cược",
    permission_category_lotto_reward_type_group:
      "Quản lý nhóm loại giải thưởng",
    permission_category_lotto_type: "Quản lý loại xổ số",
    permission_category_schedule: "Quản lý lịch trình",
    permission_category_other: "Khác",

    permission_label_member_view: "Xem thông tin hội viên",
    permission_label_member_add: "Thêm hội viên",
    permission_label_member_edit: "Chỉnh sửa hội viên",
    permission_label_member_delete: "Xóa hội viên",
    permission_label_sub_account_view: "Xem thông tin tài khoản phụ",
    permission_label_sub_account_add: "Thêm tài khoản phụ",
    permission_label_sub_account_edit: "Chỉnh sửa tài khoản phụ",
    permission_label_sub_account_delete: "Xóa tài khoản phụ",
    permission_label_company_view: "Xem thông tin công ty",
    permission_label_company_add: "Thêm công ty",
    permission_label_company_edit: "Chỉnh sửa công ty",
    permission_label_company_delete: "Xóa công ty",
    permission_label_senior_account_view: "Xem thông tin tài khoản Senior",
    permission_label_senior_account_add: "Thêm tài khoản Senior",
    permission_label_senior_account_edit: "Chỉnh sửa tài khoản Senior",
    permission_label_senior_account_delete: "Xóa tài khoản Senior",
    permission_label_master_account_view: "Xem thông tin tài khoản Master",
    permission_label_master_account_add: "Thêm tài khoản Master",
    permission_label_master_account_edit: "Chỉnh sửa tài khoản Master",
    permission_label_master_account_delete: "Xóa tài khoản Master",
    permission_label_agent_view: "Xem thông tin đại lý",
    permission_label_agent_add: "Thêm đại lý",
    permission_label_agent_edit: "Chỉnh sửa đại lý",
    permission_label_agent_delete: "Xóa đại lý",
    permission_label_commission_view: "Xem thông tin hoa hồng",
    permission_label_commission_edit: "Chỉnh sửa hoa hồng",
    permission_label_payrate_view: "Xem thông tin tỷ lệ trả thưởng",
    permission_label_payrate_edit: "Chỉnh sửa tỷ lệ trả thưởng",
    permission_label_payrate_on_off: "Bật/tắt tỷ lệ trả thưởng",
    permission_label_limited_number_view: "Xem thông tin số bị hạn chế",
    permission_label_limited_number_add: "Thêm số bị hạn chế",
    permission_label_limited_number_edit: "Chỉnh sửa số bị hạn chế",
    permission_label_limited_number_delete: "Xóa số bị hạn chế",
    permission_label_fight_limit_view: "Xem thông tin hạn mức cược",
    permission_label_fight_limit_edit: "Chỉnh sửa hạn mức cược",
    permission_label_win_lose_view: "Xem thông tin thắng thua",
    permission_label_result_view: "Xem thông tin kết quả giải thưởng",
    permission_label_lotto_wait_view: "Xem thông tin chờ kết quả xổ số",
    permission_label_activity_log_view: "Xem thông tin lịch sử sử dụng",
    permission_label_login_log_view: "Xem thông tin lịch sử đăng nhập",
    permission_label_bet_view: "Xem thông tin đặt cược",
    permission_label_bet_edit: "Chỉnh sửa thông tin đặt cược",
    permission_label_billcut_view: "Xem thông tin cắt cược",
    permission_label_billcut_edit: "Chỉnh sửa thông tin cắt cược",
    permission_label_hanoi_edit: "Chỉnh sửa kết quả Hà Nội",
    permission_label_memberlog_view: "Xem lịch sử giao dịch hội viên",
    permission_label_memberlog_edit: "Chỉnh sửa lịch sử giao dịch hội viên",
    permission_label_order_view: "Xem thông tin đơn hàng",
    permission_label_order_edit: "Chỉnh sửa thông tin đơn hàng",
    permission_label_permission_view: "Xem thông tin quyền sử dụng",
    permission_label_permission_edit: "Chỉnh sửa quyền sử dụng",
    permission_label_transaction_view: "Xem thông tin giao dịch tài khoản",
    permission_label_waitresultuser_view: "Số dư chưa xử lý theo người dùng",
    permission_label_waitresulttype_view: "Số dư chưa xử lý theo loại",
    permission_label_lottobet_view: "Số tiền cược",
    permission_label_lotto_reward_type_group_view: "Xem nhóm loại giải thưởng",
    permission_label_lotto_reward_type_group_add: "Thêm nhóm loại giải thưởng",
    permission_label_lotto_reward_type_group_edit:
      "Chỉnh sửa nhóm loại giải thưởng",
    permission_label_lotto_reward_type_group_delete:
      "Xóa nhóm loại giải thưởng",
    permission_label_lotto_type_view: "Xem loại xổ số",
    permission_label_lotto_type_add: "Thêm loại xổ số",
    permission_label_lotto_type_edit: "Chỉnh sửa loại xổ số",
    permission_label_lotto_type_delete: "Xóa loại xổ số",
    permission_label_schedule_view: "Xem lịch trình",
    permission_label_schedule_add: "Thêm lịch trình",
    permission_label_schedule_edit: "Chỉnh sửa lịch trình",
    permission_label_schedule_delete: "Xóa lịch trình",

    agentadd_password_required: "Vui lòng nhập mật khẩu!",
    agentadd_package_required: "Vui lòng bật ít nhất 1 gói!",
    agentadd_position_required: "Vui lòng chọn vị trí!",
    agentadd_generic_error: "Đã xảy ra lỗi, vui lòng tải lại và thử lại!",
    agentadd_confirm_title: "Muốn thêm Agent",
    agentadd_confirm_text_prefix: "Thêm Agent",
    agentadd_confirm_text_middle: "cấp",
    agentadd_success_prefix: "Thêm tài khoản",
    agentadd_success_middle: "cấp",
    agentadd_success_suffix: "thành công",
    agentadd_step_commission_reward: "Hoa hồng & Giải thưởng",
    agentadd_step_bet_limit: "Hạn mức cược",
    agentadd_step_max_fight_percent: "Phần trăm ôm tối đa",
    agentadd_step_fight_limit: "Hạn mức ôm",
    agentadd_header_title: "Agent => Thêm đại lý mới",
    agentadd_name_label: "Tên",
    agentadd_tel_label: "Số điện thoại",
    agentadd_email_label: "Email",
    agentadd_status_label: "Trạng thái",
    agentadd_status_active: "Hoạt động",
    agentadd_status_inactive: "Ngừng hoạt động",
    agentadd_status_suspend: "Tạm ngưng",
    agentadd_lock_label: "Khóa",
    agentadd_currency_label: "Tiền tệ",
    agentedit_currency_cascade_hint:
      "Thay đổi tiền tệ cũng áp dụng cho tất cả đại lý cấp dưới và thành viên của đại lý này",
    agentadd_save_button: "Lưu thông tin",

    agentedit_confirm_text: "Bạn có muốn lưu thông tin này không?",
    agentedit_save_success: "Lưu thông tin thành công",
    agentedit_save_error: "Đã xảy ra lỗi khi lưu thông tin",
    agentedit_header_title: "Agent => Chỉnh sửa đại lý",
    agentedit_downline_header: "Chỉnh sửa tuyến dưới",
    agentedit_downline_header_of: "là tuyến dưới của",

    commission_nav_commission: "Hoa hồng",
    commission_nav_reward: "Giải thưởng",
    commission_nav_max_bet: "Cược tối đa",
    commission_nav_min_bet: "Cược tối thiểu",
    commission_nav_max_bet_per_match: "Cược tối đa mỗi số",
    commission_filter_by_lotto_type: "Lọc theo loại xổ số:",
    commission_filter_by_downline_level: "Cấp tuyến dưới:",
    commission_page_label: "Trang",
    commission_total_prefix: "Tổng cộng",
    commission_edit_dialog_title: "Điều chỉnh hoa hồng",
    commission_max_label: "Tối đa",
    commission_no_data_yet: "Chưa có dữ liệu",

    stake_label_first: "Giải 1",
    stake_label_four_top: "4 số trên",
    stake_label_four_tod: "4 số Tod",
    stake_label_three_top: "3 số trên",
    stake_label_three_front: "3 số trước",
    stake_label_three_bot: "3 số sau",
    stake_label_three_tod: "3 số Tod",
    stake_label_two_top: "2 số trên",
    stake_label_two_bot: "2 số dưới",
    stake_label_run_top: "Chạy trên",
    stake_label_run_bot: "Chạy dưới",
    stake_label_run_top_front: "Chạy trước (Trên)",
    stake_label_run_top_mid: "Chạy giữa (Trên)",
    stake_label_run_top_end: "Chạy cuối (Trên)",
    stake_label_run_bot_front: "Chạy trước (Dưới)",
    stake_label_run_bot_mid: "Chạy giữa (Dưới)",
    stake_label_run_bot_end: "Chạy cuối (Dưới)",
    stake_label_run_top_big: "Chạy cao (Trên)",
    stake_label_run_top_small: "Chạy thấp (Trên)",
    stake_label_run_top_even: "Chạy chẵn (Trên)",
    stake_label_run_top_odd: "Chạy lẻ (Trên)",
    stake_label_run_bot_big: "Chạy cao (Dưới)",
    stake_label_run_bot_small: "Chạy thấp (Dưới)",
    stake_label_run_bot_even: "Chạy chẵn (Dưới)",
    stake_label_run_bot_odd: "Chạy lẻ (Dưới)",
    stake_label_run_top_front_even: "Chạy trước chẵn (Trên)",
    stake_label_run_top_front_odd: "Chạy trước lẻ (Trên)",
    stake_label_run_top_front_small: "Chạy trước thấp (Trên)",
    stake_label_run_top_front_big: "Chạy trước cao (Trên)",
    stake_label_run_top_mid_even: "Chạy giữa chẵn (Trên)",
    stake_label_run_top_mid_odd: "Chạy giữa lẻ (Trên)",
    stake_label_run_top_mid_small: "Chạy giữa thấp (Trên)",
    stake_label_run_top_mid_big: "Chạy giữa cao (Trên)",
    stake_label_run_top_end_even: "Chạy cuối chẵn (Trên)",
    stake_label_run_top_end_odd: "Chạy cuối lẻ (Trên)",
    stake_label_run_top_end_small: "Chạy cuối thấp (Trên)",
    stake_label_run_top_end_big: "Chạy cuối cao (Trên)",
    stake_label_run_bot_front_even: "Chạy trước chẵn (Dưới)",
    stake_label_run_bot_front_odd: "Chạy trước lẻ (Dưới)",
    stake_label_run_bot_front_small: "Chạy trước thấp (Dưới)",
    stake_label_run_bot_front_big: "Chạy trước cao (Dưới)",
    stake_label_run_bot_mid_even: "Chạy giữa chẵn (Dưới)",
    stake_label_run_bot_mid_odd: "Chạy giữa lẻ (Dưới)",
    stake_label_run_bot_mid_small: "Chạy giữa thấp (Dưới)",
    stake_label_run_bot_mid_big: "Chạy giữa cao (Dưới)",
    stake_label_run_bot_end_even: "Chạy cuối chẵn (Dưới)",
    stake_label_run_bot_end_odd: "Chạy cuối lẻ (Dưới)",
    stake_label_run_bot_end_small: "Chạy cuối thấp (Dưới)",
    stake_label_run_bot_end_big: "Chạy cuối cao (Dưới)",
    stake_label_step_front_mid_end:
      "Bộ số trước-giữa-sau (Cao, Thấp, Chẵn, Lẻ)",
    stake_label_step_mix: "Bộ số hỗn hợp (Cao thấp + Chẵn lẻ + Cắt số)",
    step_pick_big: "Cao",
    step_pick_small: "Thấp",
    step_pick_even: "Chẵn",
    step_pick_odd: "Lẻ",

    // Package labels — keyed by Package.code (see api/src/seeds/package.seed.ts)
    package1: "1 ăn 70",
    package2: "1 ăn 80",
    package3: "1 ăn 90",
    package4: "1 ăn 91",
    package5: "1 ăn 92",
    package6: "1 ăn 93",
    package7: "1 ăn 94",
    package8: "1 ăn 95",
    package9: "1 ăn 96",
    package10: "1 ăn 97",
    package11: "1 ăn 98",

    topup_status_pending: "Đang chờ xử lý",
    topup_status_approved: "Đã duyệt",
    topup_status_rejected: "Đã từ chối",
    topup_load_admin_error: "Đã xảy ra lỗi khi tải thông tin quản trị viên",
    topup_admin_not_found: "Không tìm thấy thông tin quản trị viên hệ thống",
    topup_confirm_approve_title: "Duyệt yêu cầu nạp tiền này?",
    topup_confirm_reject_title: "Từ chối yêu cầu nạp tiền này?",
    topup_already_processed: "Yêu cầu này đã được xử lý",
    topup_approve_success: "Duyệt yêu cầu thành công",
    topup_reject_success: "Từ chối yêu cầu thành công",
    topup_action_error: "Đã xảy ra lỗi khi thực hiện thao tác",
    topup_col_evidence: "Bằng chứng",
    topup_col_processed_by: "Xử lý bởi",
    topup_approve_button: "Duyệt",
    topup_reject_button: "Từ chối",

    withdraw_confirm_approve_title: "Duyệt yêu cầu rút tiền này?",
    withdraw_confirm_reject_title: "Từ chối yêu cầu rút tiền này?",
    withdraw_confirm_approve_text_prefix: "Số tiền",
    withdraw_confirm_approve_text_middle: "sẽ bị trừ khỏi số dư của hội viên",
    withdraw_confirm_reject_text:
      "Nhấn xác nhận để từ chối yêu cầu rút tiền của hội viên",
    withdraw_insufficient_credit:
      "Số dư của hội viên không đủ cho lần rút tiền này",
    withdraw_col_balance: "Số dư còn lại",
    withdraw_col_amount: "Số tiền rút",

    lotto_service_day_of_month_prefix: "Ngày",
    lotto_service_toggle_text_prefix: "Bạn đang thực hiện",
    lotto_service_action_open: "Mở",
    lotto_service_action_close: "Đóng",
    lotto_service_toggle_text_suffix: "bán xổ số",
    lotto_service_confirm_update: "Có, cập nhật!",
    lotto_service_update_status_error: "Đã xảy ra lỗi khi cập nhật trạng thái",
    lotto_service_update_status_success: "Cập nhật trạng thái thành công!",
    lotto_service_add_title: "Thêm loại xổ số",
    lotto_service_name_label: "Tên loại xổ số",
    lotto_service_type_code_placeholder: "Mã loại (VD: th_gov)",
    lotto_service_name_required: "Vui lòng nhập tên loại xổ số",
    lotto_service_type_code_required: "Vui lòng nhập mã loại",
    lotto_service_add_error: "Thêm loại xổ số thất bại",
    lotto_service_add_success: "Thêm loại xổ số thành công",
    lotto_service_round_number_invalid: "Số vòng phải là số nguyên dương",
    lotto_service_round_prefix: "Vòng",
    lotto_service_round_duplicate_suffix: "bị trùng",
    lotto_service_round_needs_time_suffix: "phải có ít nhất 1 khung giờ",
    lotto_service_round_time_required_suffix:
      "Vui lòng nhập giờ bắt đầu-kết thúc",
    lotto_service_round_days_of_month_required_suffix:
      "Vui lòng chọn ít nhất 1 ngày trong tháng",
    lotto_service_round_days_of_week_required_suffix:
      "Vui lòng chọn ít nhất 1 ngày trong tuần",
    lotto_service_edit_error: "Chỉnh sửa loại xổ số thất bại",
    lotto_service_edit_success: "Chỉnh sửa loại xổ số thành công",
    lotto_service_col_type: "Loại xổ số",
    lotto_service_col_rounds_time: "Vòng và giờ mở bán",
    lotto_service_col_reward_group: "Nhóm giải thưởng",
    lotto_service_col_sale_status: "Trạng thái bán",
    lotto_service_no_rounds_yet: "Chưa cài đặt vòng",
    lotto_service_round_label: "Vòng",
    lotto_service_manage_reward_group: "Quản lý nhóm giải thưởng",
    lotto_service_no_reward_groups_yet:
      "Chưa có nhóm giải thưởng cho loại xổ số này",
    lotto_service_status_open: "Đang mở bán",
    lotto_service_status_closed: "Đã đóng bán",
    lotto_service_edit_title: "Chỉnh sửa loại xổ số",
    lotto_service_rounds_schedule_label: "Vòng và lịch mở bán",
    lotto_service_add_round_button: "+ Thêm vòng",
    lotto_service_no_rounds_yet_short: "Chưa có vòng",
    lotto_service_delete_round_button: "Xóa vòng",
    lotto_service_mode_days_of_month: "Ngày trong tháng",
    lotto_service_mode_days_of_week: "Ngày trong tuần",
    lotto_service_add_rule_button: "+ Thêm khung giờ",

    limitnumber_incomplete_title: "Thông tin chưa đầy đủ",
    limitnumber_add_confirm_prefix: "Bạn sẽ thêm số",
    limitnumber_add_confirm_lotto_prefix: "xổ số",
    limitnumber_add_confirm_date_prefix: "kỳ ngày",
    limitnumber_add_confirm_reward_prefix: "giải thưởng",
    limitnumber_add_success: "Thêm thông tin thành công",
    limitnumber_add_error: "Đã xảy ra lỗi khi thêm thông tin",
    limitnumber_delete_confirm_text: "Bạn có muốn xóa số bị hạn chế này không",
    limitnumber_delete_success: "Xóa thông tin thành công",
    limitnumber_delete_error: "Đã xảy ra lỗi khi xóa thông tin",
    limitnumber_edit_confirm_prefix:
      "Bạn muốn sửa giải thưởng của số bị hạn chế",
    limitnumber_edit_confirm_middle: "thành",
    limitnumber_edit_success: "Chỉnh sửa thông tin thành công",
    limitnumber_edit_error: "Đã xảy ra lỗi khi chỉnh sửa thông tin",
    limitnumber_period_label: "Kỳ thứ",
    limitnumber_add_button: "Thêm số bị hạn chế",
    limitnumber_col_number: "Số bị hạn chế",
    limitnumber_draw_label: "Kỳ",
    limitnumber_col_result_round: "Vòng ra kết quả",
    limitnumber_placeholder: "Số bị hạn chế",
    limitnumber_reward_label: "Giải thưởng số bị hạn chế",
    limitnumber_edit_title: "Chỉnh sửa tỷ lệ số bị hạn chế",

    lotto_type_th_gov: "Chính phủ Thái",
    lotto_type_laos_gov: "Lào",
    lotto_type_hanoi: "Xổ số Hà Nội",

    fightlimit_exceed_prefix: "Hạn mức ôm tối đa không nên vượt quá",
    fightlimit_update_success: "Cập nhật hạn mức ôm tối đa thành công",
    fightlimit_update_error: "Đã xảy ra lỗi khi cập nhật hạn mức ôm tối đa",
    fightlimit_col_game_type: "Loại trò chơi",
    fightlimit_col_max: "Hạn mức ôm tối đa",
    fightlimit_save_button: "Lưu vào hệ thống",

    lotto_type_select_filter_first:
      "Vui lòng chọn loại xổ số trong bộ lọc trước khi tạo nhóm",
    lotto_type_create_group_title: "Tạo nhóm mới",
    lotto_type_group_name_label: "Tên nhóm",
    lotto_type_group_name_required: "Vui lòng nhập tên nhóm",
    lotto_type_create_group_error: "Tạo nhóm thất bại",
    lotto_type_create_group_success: "Tạo nhóm thành công",
    lotto_type_edit_group_title: "Chỉnh sửa nhóm",
    lotto_type_select_type_required: "Vui lòng chọn loại xổ số",
    lotto_type_edit_group_error: "Chỉnh sửa nhóm thất bại",
    lotto_type_edit_group_success: "Chỉnh sửa nhóm thành công",
    lotto_type_delete_group_confirm_prefix: "Bạn muốn xóa nhóm",
    lotto_type_confirm_yes_delete: "Có, xóa",
    lotto_type_delete_group_error: "Xóa nhóm thất bại",
    lotto_type_delete_group_success: "Xóa nhóm thành công",
    lotto_type_remove_item_error: "Xóa mục thất bại",
    lotto_type_add_item_error: "Thêm thất bại",
    lotto_type_add_item_success: "Thêm mục thành công",
    lotto_type_create_group_button: "Tạo nhóm",
    lotto_type_no_groups_yet: "Chưa có nhóm nào",
    lotto_type_add_item_button: "Thêm mục",
    lotto_type_delete_group_button: "Xóa nhóm",
    lotto_type_no_items_in_group: "Nhóm này chưa có mục nào",
    lotto_type_search_placeholder: "Tìm tên/mã",
    lotto_type_no_items_available: "Không có mục nào để thêm",
    lotto_type_used_in_group_prefix: "Đang được dùng trong nhóm",
    lotto_type_add_count_button: "Thêm",

    common_hour: "Giờ",
    common_minute: "Phút",

    schedule_job_label_th_gov: "Xổ số chính phủ Thái",
    schedule_job_label_lao_gov: "Xổ số chính phủ Lào",
    schedule_job_label_yeekee5: "Yeekee 5",
    schedule_job_label_yeekee10: "Yeekee 10",
    schedule_job_label_yeekee15: "Yeekee 15",
    schedule_job_label_hanoi_round_1: "Hà Nội Vòng 1",
    schedule_job_label_hanoi_round_2: "Hà Nội Vòng 2",
    schedule_job_label_hanoi_round_3: "Hà Nội Vòng 3",
    schedule_job_label_hanoi_round_4: "Hà Nội Vòng 4",
    schedule_job_label_hanoi_round_5: "Hà Nội Vòng 5",
    schedule_job_label_hanoi_round_6: "Hà Nội Vòng 6",
    schedule_job_label_clear_activity_log: "Xóa lịch sử hoạt động",
    schedule_type_minute_list: "Danh sách phút (VD: mỗi 5 phút)",
    schedule_type_daily: "Hàng ngày (một giờ cố định mỗi ngày)",
    schedule_type_weekly_window: "Khung giờ hàng tuần",
    schedule_type_advanced: "Nâng cao (Cron Expression)",
    schedule_all_jobs_configured_prefix: "Đã cấu hình đầy đủ cả",
    schedule_all_jobs_configured_suffix: "tác vụ",
    schedule_description_required: "Vui lòng nhập mô tả",
    schedule_minute_required: "Vui lòng chọn ít nhất 1 phút",
    schedule_day_required: "Vui lòng chọn ít nhất 1 ngày",
    schedule_cron_required: "Vui lòng nhập Cron Expression",
    schedule_create_error: "Tạo lịch trình thất bại",
    schedule_create_success: "Tạo lịch trình thành công",
    schedule_edit_error: "Chỉnh sửa lịch trình thất bại",
    schedule_edit_success: "Chỉnh sửa lịch trình thành công",
    schedule_toggle_status_error: "Thay đổi trạng thái thất bại",
    schedule_add_button: "Thêm lịch trình",
    schedule_col_description: "Mô tả",
    schedule_col_format: "Định dạng",
    schedule_col_cron_example: "Cron (ví dụ chạy)",
    schedule_enabled_label: "Bật",
    schedule_no_schedules_yet: "Chưa có lịch trình",
    schedule_edit_title: "Chỉnh sửa lịch trình",
    schedule_type_label: "Định dạng thời gian",
    schedule_minutes_label: "Phút hoạt động",
    schedule_hour_optional_label: "Giờ (để trống = mọi giờ)",
    schedule_every_hour: "Mọi giờ",
    schedule_days_of_month_optional_label:
      "Ngày trong tháng (để trống = mọi ngày)",
    schedule_minute_start_label: "Phút bắt đầu",
    schedule_minute_end_label: "Phút kết thúc",
    schedule_cron_placeholder: "VD: 0,15,30,45 * * * *",

    common_view: "Xem",
    winlose_col_account: "Tài khoản",
    winlose_col_name: "Tên",
    winlose_col_view: "Số",
    winlose_col_bet_amount: "Số tiền cược",
    winlose_col_payout: "Chi trả",
    winlose_col_company: "Công ty",
    winlose_col_senior: "Senior",
    winlose_col_master: "Master",
    winlose_col_agent: "Đại lý",
    winlose_col_win_loss: "Thắng/Thua",

    wl_tooltip_stake: "Số tiền cược",
    wl_tooltip_position_pct: "Tỷ lệ gánh chịu (cấp này)",
    wl_tooltip_position_amount: "Gánh chịu",
    wl_tooltip_fight_limit_credit: "Hạn mức ôm còn lại",
    wl_tooltip_fight_limit_config: "Hạn mức ôm đã cài đặt",
    wl_upline_config_title: "Cài đặt tuyến trên của hội viên",
    wl_upline_config_tier: "Cấp",
    wl_upline_config_name: "Tên",
    wl_upline_config_reward_rate: "Tỷ lệ trả thưởng",
    wl_tooltip_excess: "Phần vượt (chuyển lên cấp trên)",
    wl_tooltip_turnover_formula:
      "Doanh số là số tiền mà cấp này thực sự chịu trách nhiệm, được tính bằng giá trị nhỏ hơn giữa hạn mức ôm còn lại và số tiền gánh chịu nên nhận (bao gồm phần vượt chuyển từ cấp dưới, nếu có) để không vượt quá hạn mức đã đặt",
    wl_tooltip_commission_pct: "Tỷ lệ hoa hồng",
    wl_tooltip_commission_base:
      "Cơ sở tính hoa hồng (stake − doanh số của bản thân/cấp dưới)",
    wl_tooltip_net_commission: "Hoa hồng ròng",
    wl_tooltip_position_net_base_pct: "Tỷ lệ gánh chịu ròng",
    wl_tooltip_position_net: "Gánh chịu ròng",
    wl_tooltip_net_amount_label: "Số tiền ròng",
    wl_tooltip_net_amount_formula:
      "Số tiền ròng = Gánh chịu ròng + Hoa hồng ròng",
    wl_tooltip_win_formula:
      "Thắng/thua = −(Doanh số × Tỷ lệ trả thưởng) + Số tiền ròng",
    wl_tooltip_pending_formula:
      "Thắng/thua = Số tiền ròng (chưa ra kết quả/chưa thua)",
    wl_tooltip_member_turnover_formula: "Doanh số của hội viên = Số tiền cược",
    wl_tooltip_member_commission_amount:
      "Hoa hồng hội viên (stake × tỷ lệ hoa hồng)",
    wl_tooltip_member_net_formula:
      "Số tiền ròng = (stake × tỷ lệ hoa hồng) − stake",
    wl_tooltip_win_amount: "Số tiền trúng thưởng",
    wl_tooltip_member_win_formula:
      "Thắng/thua = Số tiền trúng thưởng − (Số tiền cược − Hoa hồng)",
    wl_tooltip_member_pending_formula:
      "Thắng/thua = Số tiền ròng (chưa ra kết quả/chưa thua)",
    wl_tooltip_title_turnover: "Nguồn gốc doanh số",
    wl_tooltip_title_net_amt: "Nguồn gốc số tiền ròng",
    wl_tooltip_title_wl: "Nguồn gốc thắng/thua",

    lottoresult_select_type_label: "Chọn loại xổ số :",
    lottoresult_date_label: "Ngày ra kết quả :",
    lottoresult_select_round_label: "Chọn vòng :",
    lottoresult_add_button: "+ Thêm kết quả giải thưởng",
    lottoresult_table_header: "Kết quả giải thưởng",
    lottoresult_source_title: "Kiểm tra kết nối nguồn kết quả",
    lottoresult_source_check_button: "Kiểm tra",
    lottoresult_source_checking: "Đang kiểm tra...",
    lottoresult_source_th_gov: "Xổ số Thái",
    lottoresult_source_laos_gov: "Xổ số Lào",
    lottoresult_source_hanoy: "Xổ số Việt Nam",
    lottoresult_source_connected: "Đã kết nối",
    lottoresult_source_failed: "Kết nối thất bại",
    lottoresult_source_latest: "Mới nhất",

    add_result_title: "Thêm kết quả giải thưởng",
    add_result_lotto_type_label: "Loại xổ số",
    add_result_date_label: "Ngày ra kết quả",
    add_result_round_label: "Vòng thứ",
    add_result_top_label: "Số trên",
    add_result_bottom_label: "Số dưới",
    add_result_digits_suffix: "chữ số",
    add_result_top_placeholder_th_gov: "VD: 506357",
    add_result_top_placeholder_other: "VD: 12345",
    add_result_bottom_placeholder: "VD: 31",
    add_result_top_required: "Vui lòng nhập số trên",
    add_result_bottom_required: "Vui lòng nhập số dưới",
    add_result_save_error: "Đã xảy ra lỗi khi lưu thông tin",
    add_result_save_success: "Lưu kết quả giải thưởng thành công",
    add_result_save_button: "Lưu",
    add_result_fetch_button: "Lấy từ nguồn",
    add_result_fetching: "Đang lấy...",
    add_result_fetch_success: "Đã lấy kết quả — vui lòng kiểm tra trước khi lưu",

    common_order: "Đơn hàng",
    common_number_label: "Số",
    waitresult_fight_percent_label: "Ôm %",
    waitresult_commission_percent_label: "Hoa hồng (%)",
    waitresult_fight_limit_remaining_label: "Hạn mức ôm còn lại",
    waitresult_outstanding_label: "Số dư chưa xử lý",
    waitresult_payout_rate_label: "Tỷ lệ trả thưởng",
    waitresult_bet_wager_label: "Số tiền cược (đặt cược)",
    waitresult_bet_payout_label: "Số tiền cược (chi trả)",
    waitresult_amount_label: "Số tiền",

    common_date_label: "Ngày",
    common_search: "Tìm kiếm",
    lotto_type_yeekee: "Yeekee",
    lotto_type_yeekee_vip: "Yeekee VIP",
    lotto_type_yeekee_vvip: "Yeekee VVIP",
    bet_group_four_digit: "4 số",
    bet_group_three_digit: "3 số",
    bet_group_two_digit: "2 số",
    lottobet_market_label: "Thị trường",
    lottobet_draw_date_label: "Kỳ ngày",
    lottobet_bet_type_label: "Loại cược",
    loginlog_date_prefix: "Ngày",
    loginlog_time_prefix: "Giờ",
    activitylog_col_entity: "Thực thể",
    activitylog_col_entity_id: "Mã thực thể",
    activitylog_col_action: "Hành động",
    activitylog_col_changed_fields: "Trường đã thay đổi",
    activitylog_col_old_values: "Giá trị cũ",
    activitylog_col_new_values: "Giá trị mới",
    activitylog_col_user_id: "Mã người dùng",
  },
};
